import {
  c as commonjsGlobal,
  g as getDefaultExportFromCjs,
} from "wes/chunk_commonjsHelpers";

var i18n$1 = { exports: {} };

(function (module) {
  (function (root, factory) {
    if (module.exports) {
      // Node. Does not work with strict CommonJS, but
      // only CommonJS-like environments that support module.exports,
      // like Node.
      module.exports = factory(root);
    } else {
      // Browser globals (root is window)
      root.I18n = factory(root);
    }
  })(commonjsGlobal, function (global) {
    // Use previously defined object if exists in current scope
    var I18n = (global && global.I18n) || {};

    // Just cache the Array#slice function.
    var slice = Array.prototype.slice;

    // Apply number padding.
    var padding = function (number) {
      return ("0" + number.toString()).substr(-2);
    };

    // Improved toFixed number rounding function with support for unprecise floating points
    // JavaScript's standard toFixed function does not round certain numbers correctly (for example 0.105 with precision 2).
    var toFixed = function (number, precision) {
      return decimalAdjust("round", number, -precision).toFixed(precision);
    };

    // Is a given variable an object?
    // Borrowed from Underscore.js
    var isObject = function (obj) {
      var type = typeof obj;
      return type === "function" || type === "object";
    };
    var isFunction = function (func) {
      var type = typeof func;
      return type === "function";
    };

    // Check if value is different than undefined and null;
    var isSet = function (value) {
      return typeof value !== "undefined" && value !== null;
    };

    // Is a given value an array?
    // Borrowed from Underscore.js
    var isArray = function (val) {
      if (Array.isArray) {
        return Array.isArray(val);
      }
      return Object.prototype.toString.call(val) === "[object Array]";
    };
    var isString = function (val) {
      return (
        typeof val === "string" ||
        Object.prototype.toString.call(val) === "[object String]"
      );
    };
    var isNumber = function (val) {
      return (
        typeof val === "number" ||
        Object.prototype.toString.call(val) === "[object Number]"
      );
    };
    var isBoolean = function (val) {
      return val === true || val === false;
    };
    var isNull = function (val) {
      return val === null;
    };
    var decimalAdjust = function (type, value, exp) {
      // If the exp is undefined or zero...
      if (typeof exp === "undefined" || +exp === 0) {
        return Math[type](value);
      }
      value = +value;
      exp = +exp;
      // If the value is not a number or the exp is not an integer...
      if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
        return NaN;
      }
      // Shift
      value = value.toString().split("e");
      value = Math[type](
        +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)),
      );
      // Shift back
      value = value.toString().split("e");
      return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
    };
    var lazyEvaluate = function (message, scope) {
      if (isFunction(message)) {
        return message(scope);
      } else {
        return message;
      }
    };
    var merge = function (dest, obj) {
      var key, value;
      for (key in obj)
        if (obj.hasOwnProperty(key)) {
          value = obj[key];
          if (
            isString(value) ||
            isNumber(value) ||
            isBoolean(value) ||
            isArray(value) ||
            isNull(value)
          ) {
            dest[key] = value;
          } else {
            if (dest[key] == null) dest[key] = {};
            merge(dest[key], value);
          }
        }
      return dest;
    };

    // Set default days/months translations.
    var DATE = {
      day_names: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      abbr_day_names: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      month_names: [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      abbr_month_names: [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      meridian: ["AM", "PM"],
    };

    // Set default number format.
    var NUMBER_FORMAT = {
      precision: 3,
      separator: ".",
      delimiter: ",",
      strip_insignificant_zeros: false,
    };

    // Set default currency format.
    var CURRENCY_FORMAT = {
      unit: "$",
      precision: 2,
      format: "%u%n",
      sign_first: true,
      delimiter: ",",
      separator: ".",
    };

    // Set default percentage format.
    var PERCENTAGE_FORMAT = {
      unit: "%",
      precision: 3,
      format: "%n%u",
      separator: ".",
      delimiter: "",
    };

    // Set default size units.
    var SIZE_UNITS = [null, "kb", "mb", "gb", "tb"];

    // Other default options
    var DEFAULT_OPTIONS = {
      // Set default locale. This locale will be used when fallback is enabled and
      // the translation doesn't exist in a particular locale.
      defaultLocale: "en",
      // Set the current locale to `en`.
      locale: "en",
      // Set the translation key separator.
      defaultSeparator: ".",
      // Set the placeholder format. Accepts `{{placeholder}}` and `%{placeholder}`.
      placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm,
      // Set if engine should fallback to the default locale when a translation
      // is missing.
      fallbacks: false,
      // Set the default translation object.
      translations: {},
      // Set missing translation behavior. 'message' will display a message
      // that the translation is missing, 'guess' will try to guess the string
      missingBehaviour: "message",
      // if you use missingBehaviour with 'message', but want to know that the
      // string is actually missing for testing purposes, you can prefix the
      // guessed string by setting the value here. By default, no prefix!
      missingTranslationPrefix: "",
    };

    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
    I18n.reset = function () {
      var key;
      for (key in DEFAULT_OPTIONS) {
        this[key] = DEFAULT_OPTIONS[key];
      }
    };

    // Much like `reset`, but only assign options if not already assigned
    I18n.initializeOptions = function () {
      var key;
      for (key in DEFAULT_OPTIONS)
        if (!isSet(this[key])) {
          this[key] = DEFAULT_OPTIONS[key];
        }
    };
    I18n.initializeOptions();

    // Return a list of all locales that must be tried before returning the
    // missing translation message. By default, this will consider the inline option,
    // current locale and fallback locale.
    //
    //     I18n.locales.get("de-DE");
    //     // ["de-DE", "de", "en"]
    //
    // You can define custom rules for any locale. Just make sure you return a array
    // containing all locales.
    //
    //     // Default the Wookie locale to English.
    //     I18n.locales["wk"] = function(locale) {
    //       return ["en"];
    //     };
    //
    I18n.locales = {};

    // Retrieve locales based on inline locale, current locale or default to
    // I18n's detection.
    I18n.locales.get = function (locale) {
      var result = this[locale] || this[I18n.locale] || this["default"];
      if (isFunction(result)) {
        result = result(locale);
      }
      if (isArray(result) === false) {
        result = [result];
      }
      return result;
    };

    // The default locale list.
    I18n.locales["default"] = function (locale) {
      var locales = [],
        list = [];

      // Handle the inline locale option that can be provided to
      // the `I18n.t` options.
      if (locale) {
        locales.push(locale);
      }

      // Add the current locale to the list.
      if (!locale && I18n.locale) {
        locales.push(I18n.locale);
      }

      // Add the default locale if fallback strategy is enabled.
      if (I18n.fallbacks && I18n.defaultLocale) {
        locales.push(I18n.defaultLocale);
      }

      // Locale code format 1:
      // According to RFC4646 (https://www.ietf.org/rfc/rfc4646.txt)
      // language codes for Traditional Chinese should be `zh-Hant`
      //
      // But due to backward compatibility
      // We use older version of IETF language tag
      // @see https://www.w3.org/TR/html401/struct/dirlang.html
      // @see https://en.wikipedia.org/wiki/IETF_language_tag
      //
      // Format: `language-code = primary-code ( "-" subcode )*`
      //
      // primary-code uses ISO639-1
      // @see https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
      // @see https://www.iso.org/iso/home/standards/language_codes.htm
      //
      // subcode uses ISO 3166-1 alpha-2
      // @see https://en.wikipedia.org/wiki/ISO_3166
      // @see https://www.iso.org/iso/country_codes.htm
      //
      // @note
      //   subcode can be in upper case or lower case
      //   defining it in upper case is a convention only

      // Locale code format 2:
      // Format: `code = primary-code ( "-" region-code )*`
      // primary-code uses ISO 639-1
      // script-code uses ISO 15924
      // region-code uses ISO 3166-1 alpha-2
      // Example: zh-Hant-TW, en-HK, zh-Hant-CN
      //
      // It is similar to RFC4646 (or actually the same),
      // but seems to be limited to language, script, region

      // Compute each locale with its country code.
      // So this will return an array containing
      // `de-DE` and `de`
      // or
      // `zh-hans-tw`, `zh-hans`, `zh`
      // locales.
      locales.forEach(function (locale) {
        var localeParts = locale.split("-");
        var firstFallback = null;
        var secondFallback = null;
        if (localeParts.length === 3) {
          firstFallback = [localeParts[0], localeParts[1]].join("-");
          secondFallback = localeParts[0];
        } else if (localeParts.length === 2) {
          firstFallback = localeParts[0];
        }
        if (list.indexOf(locale) === -1) {
          list.push(locale);
        }
        if (!I18n.fallbacks) {
          return;
        }
        [firstFallback, secondFallback].forEach(
          function (nullableFallbackLocale) {
            // We don't want null values
            if (typeof nullableFallbackLocale === "undefined") {
              return;
            }
            if (nullableFallbackLocale === null) {
              return;
            }
            // We don't want duplicate values
            //
            // Comparing with `locale` first is faster than
            // checking whether value's presence in the list
            if (nullableFallbackLocale === locale) {
              return;
            }
            if (list.indexOf(nullableFallbackLocale) !== -1) {
              return;
            }
            list.push(nullableFallbackLocale);
          },
        );
      });

      // No locales set? English it is.
      if (!locales.length) {
        locales.push("en");
      }
      return list;
    };

    // Hold pluralization rules.
    I18n.pluralization = {};

    // Return the pluralizer for a specific locale.
    // If no specify locale is found, then I18n's default will be used.
    I18n.pluralization.get = function (locale) {
      return this[locale] || this[I18n.locale] || this["default"];
    };

    // The default pluralizer rule.
    // It detects the `zero`, `one`, and `other` scopes.
    I18n.pluralization["default"] = function (count) {
      switch (count) {
        case 0:
          return ["zero", "other"];
        case 1:
          return ["one"];
        default:
          return ["other"];
      }
    };

    // Return current locale. If no locale has been set, then
    // the current locale will be the default locale.
    I18n.currentLocale = function () {
      return this.locale || this.defaultLocale;
    };

    // Check if value is different than undefined and null;
    I18n.isSet = isSet;

    // Find and process the translation using the provided scope and options.
    // This is used internally by some functions and should not be used as an
    // public API.
    I18n.lookup = function (scope, options) {
      options = options || {};
      var locales = this.locales.get(options.locale).slice(),
        locale,
        scopes,
        fullScope,
        translations;
      fullScope = this.getFullScope(scope, options);
      while (locales.length) {
        locale = locales.shift();
        scopes = fullScope.split(options.separator || this.defaultSeparator);
        translations = this.translations[locale];
        if (!translations) {
          continue;
        }
        while (scopes.length) {
          translations = translations[scopes.shift()];
          if (translations === undefined || translations === null) {
            break;
          }
        }
        if (translations !== undefined && translations !== null) {
          return translations;
        }
      }
      if (isSet(options.defaultValue)) {
        return lazyEvaluate(options.defaultValue, scope);
      }
    };

    // lookup pluralization rule key into translations
    I18n.pluralizationLookupWithoutFallback = function (
      count,
      locale,
      translations,
    ) {
      var pluralizer = this.pluralization.get(locale),
        pluralizerKeys = pluralizer(count),
        pluralizerKey,
        message;
      if (translations && isObject(translations)) {
        while (pluralizerKeys.length) {
          pluralizerKey = pluralizerKeys.shift();
          if (isSet(translations[pluralizerKey])) {
            message = translations[pluralizerKey];
            break;
          }
        }
      }
      return message;
    };

    // Lookup dedicated to pluralization
    I18n.pluralizationLookup = function (count, scope, options) {
      options = options || {};
      var locales = this.locales.get(options.locale).slice(),
        locale,
        scopes,
        translations,
        message;
      scope = this.getFullScope(scope, options);
      while (locales.length) {
        locale = locales.shift();
        scopes = scope.split(options.separator || this.defaultSeparator);
        translations = this.translations[locale];
        if (!translations) {
          continue;
        }
        while (scopes.length) {
          translations = translations[scopes.shift()];
          if (!isObject(translations)) {
            break;
          }
          if (scopes.length === 0) {
            message = this.pluralizationLookupWithoutFallback(
              count,
              locale,
              translations,
            );
          }
        }
        if (typeof message !== "undefined" && message !== null) {
          break;
        }
      }
      if (typeof message === "undefined" || message === null) {
        if (isSet(options.defaultValue)) {
          if (isObject(options.defaultValue)) {
            message = this.pluralizationLookupWithoutFallback(
              count,
              options.locale,
              options.defaultValue,
            );
          } else {
            message = options.defaultValue;
          }
          translations = options.defaultValue;
        }
      }
      return {
        message: message,
        translations: translations,
      };
    };

    // Rails changed the way the meridian is stored.
    // It started with `date.meridian` returning an array,
    // then it switched to `time.am` and `time.pm`.
    // This function abstracts this difference and returns
    // the correct meridian or the default value when none is provided.
    I18n.meridian = function () {
      var time = this.lookup("time");
      var date = this.lookup("date");
      if (time && time.am && time.pm) {
        return [time.am, time.pm];
      } else if (date && date.meridian) {
        return date.meridian;
      } else {
        return DATE.meridian;
      }
    };

    // Merge serveral hash options, checking if value is set before
    // overwriting any value. The precedence is from left to right.
    //
    //     I18n.prepareOptions({name: "John Doe"}, {name: "Mary Doe", role: "user"});
    //     #=> {name: "John Doe", role: "user"}
    //
    I18n.prepareOptions = function () {
      var args = slice.call(arguments),
        options = {},
        subject;
      while (args.length) {
        subject = args.shift();
        if (typeof subject != "object") {
          continue;
        }
        for (var attr in subject) {
          if (!subject.hasOwnProperty(attr)) {
            continue;
          }
          if (isSet(options[attr])) {
            continue;
          }
          options[attr] = subject[attr];
        }
      }
      return options;
    };

    // Generate a list of translation options for default fallbacks.
    // `defaultValue` is also deleted from options as it is returned as part of
    // the translationOptions array.
    I18n.createTranslationOptions = function (scope, options) {
      var translationOptions = [
        {
          scope: scope,
        },
      ];

      // Defaults should be an array of hashes containing either
      // fallback scopes or messages
      if (isSet(options.defaults)) {
        translationOptions = translationOptions.concat(options.defaults);
      }

      // Maintain support for defaultValue. Since it is always a message
      // insert it in to the translation options as such.
      if (isSet(options.defaultValue)) {
        translationOptions.push({
          message: options.defaultValue,
        });
      }
      return translationOptions;
    };

    // Translate the given scope with the provided options.
    I18n.translate = function (scope, options) {
      options = options || {};
      var translationOptions = this.createTranslationOptions(scope, options);
      var translation;
      var usedScope = scope;
      var optionsWithoutDefault = this.prepareOptions(options);
      delete optionsWithoutDefault.defaultValue;

      // Iterate through the translation options until a translation
      // or message is found.
      var translationFound = translationOptions.some(function (
        translationOption,
      ) {
        if (isSet(translationOption.scope)) {
          usedScope = translationOption.scope;
          translation = this.lookup(usedScope, optionsWithoutDefault);
        } else if (isSet(translationOption.message)) {
          translation = lazyEvaluate(translationOption.message, scope);
        }
        if (translation !== undefined && translation !== null) {
          return true;
        }
      }, this);
      if (!translationFound) {
        return this.missingTranslation(scope, options);
      }
      if (typeof translation === "string") {
        translation = this.interpolate(translation, options);
      } else if (isArray(translation)) {
        translation = translation.map(function (t) {
          return typeof t === "string" ? this.interpolate(t, options) : t;
        }, this);
      } else if (isObject(translation) && isSet(options.count)) {
        translation = this.pluralize(options.count, usedScope, options);
      }
      return translation;
    };

    // This function interpolates the all variables in the given message.
    I18n.interpolate = function (message, options) {
      if (message == null) {
        return message;
      }
      options = options || {};
      var matches = message.match(this.placeholder),
        placeholder,
        value,
        name,
        regex;
      if (!matches) {
        return message;
      }
      while (matches.length) {
        placeholder = matches.shift();
        name = placeholder.replace(this.placeholder, "$1");
        if (isSet(options[name])) {
          value = options[name].toString().replace(/\$/gm, "_#$#_");
        } else if (name in options) {
          value = this.nullPlaceholder(placeholder, message, options);
        } else {
          value = this.missingPlaceholder(placeholder, message, options);
        }
        regex = new RegExp(
          placeholder.replace(/{/gm, "\\{").replace(/}/gm, "\\}"),
        );
        message = message.replace(regex, value);
      }
      return message.replace(/_#\$#_/g, "$");
    };

    // Pluralize the given scope using the `count` value.
    // The pluralized translation may have other placeholders,
    // which will be retrieved from `options`.
    I18n.pluralize = function (count, scope, options) {
      options = this.prepareOptions(
        {
          count: String(count),
        },
        options,
      );
      var pluralizer, result;
      result = this.pluralizationLookup(count, scope, options);
      if (
        typeof result.translations === "undefined" ||
        result.translations == null
      ) {
        return this.missingTranslation(scope, options);
      }
      if (typeof result.message !== "undefined" && result.message != null) {
        return this.interpolate(result.message, options);
      } else {
        pluralizer = this.pluralization.get(options.locale);
        return this.missingTranslation(
          scope + "." + pluralizer(count)[0],
          options,
        );
      }
    };

    // Return a missing translation message for the given parameters.
    I18n.missingTranslation = function (scope, options) {
      //guess intended string
      if (this.missingBehaviour === "guess") {
        //get only the last portion of the scope
        var s = scope.split(".").slice(-1)[0];
        //replace underscore with space && camelcase with space and lowercase letter
        return (
          (this.missingTranslationPrefix.length > 0
            ? this.missingTranslationPrefix
            : "") +
          s
            .replace(/_/g, " ")
            .replace(/([a-z])([A-Z])/g, function (match, p1, p2) {
              return p1 + " " + p2.toLowerCase();
            })
        );
      }
      var localeForTranslation =
        options != null && options.locale != null
          ? options.locale
          : this.currentLocale();
      var fullScope = this.getFullScope(scope, options);
      var fullScopeWithLocale = [localeForTranslation, fullScope].join(
        options.separator || this.defaultSeparator,
      );
      return '[missing "' + fullScopeWithLocale + '" translation]';
    };

    // Return a missing placeholder message for given parameters
    I18n.missingPlaceholder = function (placeholder, message, options) {
      return "[missing " + placeholder + " value]";
    };
    I18n.nullPlaceholder = function () {
      return I18n.missingPlaceholder.apply(I18n, arguments);
    };

    // Format number using localization rules.
    // The options will be retrieved from the `number.format` scope.
    // If this isn't present, then the following options will be used:
    //
    // - `precision`: `3`
    // - `separator`: `"."`
    // - `delimiter`: `","`
    // - `strip_insignificant_zeros`: `false`
    //
    // You can also override these options by providing the `options` argument.
    //
    I18n.toNumber = function (number, options) {
      options = this.prepareOptions(
        options,
        this.lookup("number.format"),
        NUMBER_FORMAT,
      );
      var negative = number < 0,
        string = toFixed(Math.abs(number), options.precision).toString(),
        parts = string.split("."),
        precision,
        buffer = [],
        formattedNumber,
        format = options.format || "%n",
        sign = negative ? "-" : "";
      number = parts[0];
      precision = parts[1];
      while (number.length > 0) {
        buffer.unshift(number.substr(Math.max(0, number.length - 3), 3));
        number = number.substr(0, number.length - 3);
      }
      formattedNumber = buffer.join(options.delimiter);
      if (options.strip_insignificant_zeros && precision) {
        precision = precision.replace(/0+$/, "");
      }
      if (options.precision > 0 && precision) {
        formattedNumber += options.separator + precision;
      }
      if (options.sign_first) {
        format = "%s" + format;
      } else {
        format = format.replace("%n", "%s%n");
      }
      formattedNumber = format
        .replace("%u", options.unit)
        .replace("%n", formattedNumber)
        .replace("%s", sign);
      return formattedNumber;
    };

    // Format currency with localization rules.
    // The options will be retrieved from the `number.currency.format` and
    // `number.format` scopes, in that order.
    //
    // Any missing option will be retrieved from the `I18n.toNumber` defaults and
    // the following options:
    //
    // - `unit`: `"$"`
    // - `precision`: `2`
    // - `format`: `"%u%n"`
    // - `delimiter`: `","`
    // - `separator`: `"."`
    //
    // You can also override these options by providing the `options` argument.
    //
    I18n.toCurrency = function (number, options) {
      options = this.prepareOptions(
        options,
        this.lookup("number.currency.format", options),
        this.lookup("number.format", options),
        CURRENCY_FORMAT,
      );
      return this.toNumber(number, options);
    };

    // Localize several values.
    // You can provide the following scopes: `currency`, `number`, or `percentage`.
    // If you provide a scope that matches the `/^(date|time)/` regular expression
    // then the `value` will be converted by using the `I18n.toTime` function.
    //
    // It will default to the value's `toString` function.
    //
    I18n.localize = function (scope, value, options) {
      options || (options = {});
      switch (scope) {
        case "currency":
          return this.toCurrency(value, options);
        case "number":
          scope = this.lookup("number.format", options);
          return this.toNumber(value, scope);
        case "percentage":
          return this.toPercentage(value, options);
        default:
          var localizedValue;
          if (scope.match(/^(date|time)/)) {
            localizedValue = this.toTime(scope, value, options);
          } else {
            localizedValue = value.toString();
          }
          return this.interpolate(localizedValue, options);
      }
    };

    // Parse a given `date` string into a JavaScript Date object.
    // This function is time zone aware.
    //
    // The following string formats are recognized:
    //
    //    yyyy-mm-dd
    //    yyyy-mm-dd[ T]hh:mm::ss
    //    yyyy-mm-dd[ T]hh:mm::ss
    //    yyyy-mm-dd[ T]hh:mm::ssZ
    //    yyyy-mm-dd[ T]hh:mm::ss+0000
    //    yyyy-mm-dd[ T]hh:mm::ss+00:00
    //    yyyy-mm-dd[ T]hh:mm::ss.123Z
    //
    I18n.parseDate = function (date) {
      var matches, convertedDate, fraction;
      // A date input of `null` or `undefined` will be returned as-is
      if (date == null) {
        return date;
      }
      // we have a date, so just return it.
      if (typeof date === "object") {
        return date;
      }
      matches = date
        .toString()
        .match(
          /(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})([\.,]\d{1,3})?)?(Z|\+00:?00)?/,
        );
      if (matches) {
        for (var i = 1; i <= 6; i++) {
          matches[i] = parseInt(matches[i], 10) || 0;
        }

        // month starts on 0
        matches[2] -= 1;
        fraction = matches[7] ? 1000 * ("0" + matches[7]) : null;
        if (matches[8]) {
          convertedDate = new Date(
            Date.UTC(
              matches[1],
              matches[2],
              matches[3],
              matches[4],
              matches[5],
              matches[6],
              fraction,
            ),
          );
        } else {
          convertedDate = new Date(
            matches[1],
            matches[2],
            matches[3],
            matches[4],
            matches[5],
            matches[6],
            fraction,
          );
        }
      } else if (typeof date == "number") {
        // UNIX timestamp
        convertedDate = new Date();
        convertedDate.setTime(date);
      } else if (
        date.match(
          /([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/,
        )
      ) {
        // This format `Wed Jul 20 13:03:39 +0000 2011` is parsed by
        // webkit/firefox, but not by IE, so we must parse it manually.
        convertedDate = new Date();
        convertedDate.setTime(
          Date.parse(
            [
              RegExp.$1,
              RegExp.$2,
              RegExp.$3,
              RegExp.$6,
              RegExp.$4,
              RegExp.$5,
            ].join(" "),
          ),
        );
      } else if (date.match(/\d+ \d+:\d+:\d+ [+-]\d+ \d+/)) {
        // a valid javascript format with timezone info
        convertedDate = new Date();
        convertedDate.setTime(Date.parse(date));
      } else {
        // an arbitrary javascript string
        convertedDate = new Date();
        convertedDate.setTime(Date.parse(date));
      }
      return convertedDate;
    };

    // Formats time according to the directives in the given format string.
    // The directives begins with a percent (%) character. Any text not listed as a
    // directive will be passed through to the output string.
    //
    // The accepted formats are:
    //
    //     %a     - The abbreviated weekday name (Sun)
    //     %A     - The full weekday name (Sunday)
    //     %b     - The abbreviated month name (Jan)
    //     %B     - The full month name (January)
    //     %c     - The preferred local date and time representation
    //     %d     - Day of the month (01..31)
    //     %-d    - Day of the month (1..31)
    //     %H     - Hour of the day, 24-hour clock (00..23)
    //     %-H/%k - Hour of the day, 24-hour clock (0..23)
    //     %I     - Hour of the day, 12-hour clock (01..12)
    //     %-I/%l - Hour of the day, 12-hour clock (1..12)
    //     %m     - Month of the year (01..12)
    //     %-m    - Month of the year (1..12)
    //     %M     - Minute of the hour (00..59)
    //     %-M    - Minute of the hour (0..59)
    //     %p     - Meridian indicator (AM  or  PM)
    //     %P     - Meridian indicator (am  or  pm)
    //     %S     - Second of the minute (00..60)
    //     %-S    - Second of the minute (0..60)
    //     %w     - Day of the week (Sunday is 0, 0..6)
    //     %y     - Year without a century (00..99)
    //     %-y    - Year without a century (0..99)
    //     %Y     - Year with century
    //     %z/%Z  - Timezone offset (+0545)
    //
    I18n.strftime = function (date, format, options) {
      var options = this.lookup("date", options),
        meridianOptions = I18n.meridian();
      if (!options) {
        options = {};
      }
      options = this.prepareOptions(options, DATE);
      if (isNaN(date.getTime())) {
        throw new Error(
          "I18n.strftime() requires a valid date object, but received an invalid date.",
        );
      }
      var weekDay = date.getDay(),
        day = date.getDate(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        hour = date.getHours(),
        hour12 = hour,
        meridian = hour > 11 ? 1 : 0,
        secs = date.getSeconds(),
        mins = date.getMinutes(),
        offset = date.getTimezoneOffset(),
        absOffsetHours = Math.floor(Math.abs(offset / 60)),
        absOffsetMinutes = Math.abs(offset) - absOffsetHours * 60,
        timezoneoffset =
          (offset > 0 ? "-" : "+") +
          (absOffsetHours.toString().length < 2
            ? "0" + absOffsetHours
            : absOffsetHours) +
          (absOffsetMinutes.toString().length < 2
            ? "0" + absOffsetMinutes
            : absOffsetMinutes);
      if (hour12 > 12) {
        hour12 = hour12 - 12;
      } else if (hour12 === 0) {
        hour12 = 12;
      }
      format = format.replace("%a", options.abbr_day_names[weekDay]);
      format = format.replace("%A", options.day_names[weekDay]);
      format = format.replace("%b", options.abbr_month_names[month]);
      format = format.replace("%B", options.month_names[month]);
      format = format.replace("%d", padding(day));
      format = format.replace("%e", day);
      format = format.replace("%-d", day);
      format = format.replace("%H", padding(hour));
      format = format.replace("%-H", hour);
      format = format.replace("%k", hour);
      format = format.replace("%I", padding(hour12));
      format = format.replace("%-I", hour12);
      format = format.replace("%l", hour12);
      format = format.replace("%m", padding(month));
      format = format.replace("%-m", month);
      format = format.replace("%M", padding(mins));
      format = format.replace("%-M", mins);
      format = format.replace("%p", meridianOptions[meridian]);
      format = format.replace("%P", meridianOptions[meridian].toLowerCase());
      format = format.replace("%S", padding(secs));
      format = format.replace("%-S", secs);
      format = format.replace("%w", weekDay);
      format = format.replace("%y", padding(year));
      format = format.replace("%-y", padding(year).replace(/^0+/, ""));
      format = format.replace("%Y", year);
      format = format.replace("%z", timezoneoffset);
      format = format.replace("%Z", timezoneoffset);
      return format;
    };

    // Convert the given dateString into a formatted date.
    I18n.toTime = function (scope, dateString, options) {
      var date = this.parseDate(dateString),
        format = this.lookup(scope, options);

      // A date input of `null` or `undefined` will be returned as-is
      if (date == null) {
        return date;
      }
      var date_string = date.toString();
      if (date_string.match(/invalid/i)) {
        return date_string;
      }
      if (!format) {
        return date_string;
      }
      return this.strftime(date, format, options);
    };

    // Convert a number into a formatted percentage value.
    I18n.toPercentage = function (number, options) {
      options = this.prepareOptions(
        options,
        this.lookup("number.percentage.format", options),
        this.lookup("number.format", options),
        PERCENTAGE_FORMAT,
      );
      return this.toNumber(number, options);
    };

    // Convert a number into a readable size representation.
    I18n.toHumanSize = function (number, options) {
      var kb = 1024,
        size = number,
        iterations = 0,
        unit,
        precision,
        fullScope;
      while (size >= kb && iterations < 4) {
        size = size / kb;
        iterations += 1;
      }
      if (iterations === 0) {
        fullScope = this.getFullScope(
          "number.human.storage_units.units.byte",
          options,
        );
        unit = this.t(fullScope, {
          count: size,
        });
        precision = 0;
      } else {
        fullScope = this.getFullScope(
          "number.human.storage_units.units." + SIZE_UNITS[iterations],
          options,
        );
        unit = this.t(fullScope);
        precision = size - Math.floor(size) === 0 ? 0 : 1;
      }
      options = this.prepareOptions(options, {
        unit: unit,
        precision: precision,
        format: "%n%u",
        delimiter: "",
      });
      return this.toNumber(size, options);
    };
    I18n.getFullScope = function (scope, options) {
      options = options || {};

      // Deal with the scope as an array.
      if (isArray(scope)) {
        scope = scope.join(options.separator || this.defaultSeparator);
      }

      // Deal with the scope option provided through the second argument.
      //
      //    I18n.t('hello', {scope: 'greetings'});
      //
      if (options.scope) {
        scope = [options.scope, scope].join(
          options.separator || this.defaultSeparator,
        );
      }
      return scope;
    };
    /**
     * Merge obj1 with obj2 (shallow merge), without modifying inputs
     * @param {Object} obj1
     * @param {Object} obj2
     * @returns {Object} Merged values of obj1 and obj2
     *
     * In order to support ES3, `Object.prototype.hasOwnProperty.call` is used
     * Idea is from:
     * https://stackoverflow.com/questions/8157700/object-has-no-hasownproperty-method-i-e-its-undefined-ie8
     */
    I18n.extend = function (obj1, obj2) {
      if (typeof obj1 === "undefined" && typeof obj2 === "undefined") {
        return {};
      }
      return merge(obj1, obj2);
    };

    // Set aliases, so we can save some typing.
    I18n.t = I18n.translate.bind(I18n);
    I18n.l = I18n.localize.bind(I18n);
    I18n.p = I18n.pluralize.bind(I18n);
    return I18n;
  });
})(i18n$1);

var i18nExports = i18n$1.exports;
var i18n = /*@__PURE__*/ getDefaultExportFromCjs(i18nExports);

/**
 * Okta - underscores, locales
 * Okta emails - hyphens, languages
 * Digital - hyphens, languages
 * sfPlatform - underscores, languages
 * Trailhead - hyphens, languages
 * GlobalNav - hyphens, locales
 */
/**
 * @description the full list of digital supported Locales, in Okta's locale format, sorted with the primary locale first for each lang tag (ie. 'es_ES' for just 'es', or 'en_US' for 'en')
 */
const SUPPORTED_LOCALES = [
  "da_DK",
  "de_DE",
  "en_US",
  "en_AP",
  "en_AU",
  "en_CA",
  "en_EU",
  "en_GB",
  "en_IN",
  "eo_US",
  "es_ES",
  "es_MX",
  "fr_FR",
  "fi_FI",
  "fr_CA",
  "it_IT",
  "ja_JP",
  "ko_KR",
  "nl_NL",
  "no_NO",
  "pt_BR",
  "ru_RU",
  "sv_SE",
  "th_TH",
  "zh_CN",
  "zh_TW",
];
const DEFAULT_LOCALE = "en_US";
const DEFAULT_LANG = "en";
/**
 * @description The list of language tags supported by TBID
 */
const DIGITAL_SUPPORTED_LANGUAGES = [
  "da",
  "de",
  "en",
  "eo",
  "es-MX",
  "es",
  "fi",
  "fr",
  "it",
  "ja",
  "ko",
  "nl",
  "no",
  "pt-BR",
  "ru",
  "sv",
  "th",
  "zh-CN",
  "zh-TW",
];
/**
 * @description Mapping of Language tags to Label
 */
const LANGUAGE_LABEL_MAP = {
  da: "Dansk",
  de: "Deutsch",
  en: "English",
  eo: "Esperanto",
  "es-MX": "Español (LATAM)",
  es: "Español (España)",
  fi: "Suomi",
  fr: "Français",
  it: "Italiano",
  ja: "日本語",
  ko: "한국어",
  nl: "Nederlands",
  no: "Norsk",
  "pt-BR": "Português (Brasil)",
  ru: "Русский",
  sv: "Svenska",
  th: "ภาษาไทย",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文",
};
/**
 * @description Profile services
 */
const SF_PLATFORM_SUPPORTED_LANGUAGES = [
  "en_US",
  "es",
  "de",
  "fr",
  "it",
  "ja",
  "ko",
  "nl_NL",
  "es_MX",
  "pt_BR",
  "zh_CN",
];
/**
 * @description List of Salesforce platform supported languages
 */
SF_PLATFORM_SUPPORTED_LANGUAGES.reduce((map, sfLocale) => {
  switch (sfLocale) {
    case "en_US":
      return {
        ...map,
        en: sfLocale,
      };
    case "nl_NL":
      return {
        ...map,
        nl: sfLocale,
      };
    case "es_MX":
    case "pt_BR":
    case "zh_CN": {
      const key = sfLocale.replace("_", "-");
      return {
        ...map,
        [key]: sfLocale,
      };
    }
    default:
      return {
        ...map,
        sfLocale,
      };
  }
}, {});
/**
 * @description List of Trailhead supported languages
 */
const TRAILHEAD_SUPPORTED_LANGUAGES = [
  "en",
  "es",
  "de",
  "fr",
  "it",
  "ja",
  "ko",
  "es-MX",
  "pt-BR",
  "zh-CN",
];
/**
 * @description List of languages supported in translating emails
 */
const OKTA_EMAIL_SUPPORTED_LANGUAGES = [
  "da",
  "de",
  "en",
  "es",
  "fi",
  "fr",
  "it",
  "ja",
  "ko",
  "nb",
  "nl-NL",
  "pt-BR",
  "ru",
  "sv",
  "th",
  "zh-CN",
  "zh-TW",
];
/**
 * Map Supported locales -> Okta values
 */
OKTA_EMAIL_SUPPORTED_LANGUAGES.reduce((map, oktaLocale) => {
  switch (oktaLocale) {
    case "nb":
      // Norwegian language code in Okta is 'nb' instead of 'no'
      return {
        ...map,
        no: oktaLocale,
      };
    case "nl-NL":
      return {
        ...map,
        nl: "nl-NL",
      };
    case "es":
      // Okta doesn't support Mexican Spanish explicitly though we support it
      return {
        ...map,
        oktaLocale,
        "es-MX": oktaLocale,
      };
    default:
      return {
        ...map,
        oktaLocale,
      };
  }
}, {});
function sourceLocaleFromBrowser() {
  if (typeof navigator === "undefined") {
    throw new Error("Unable to get locale, not running in browser");
  }
  let language = navigator.language;
  if (!language) {
    language = navigator.languages[0];
  }
  return language;
}
function getSupportedLocale({ langTag, regionTag }) {
  if (!regionTag) {
    // Unable to lookup locale without country, just use default for langTag
    // Find the first supported full locale for this language
    // NOTE: assumes langTag is supported by the list of locales
    return (
      SUPPORTED_LOCALES.find((supportedLocale) => {
        const [thisLocaleLang] = supportedLocale.split("_");
        return thisLocaleLang === langTag;
      }) ?? DEFAULT_LOCALE
    );
  }
  const desiredLocale = `${langTag}_${regionTag}`;
  let foundLocale = SUPPORTED_LOCALES.find(
    (supportedLocale) => supportedLocale.toLowerCase() === desiredLocale,
  );
  // Attempt to match on just the lang tag and get the default locale for that
  if (!foundLocale) {
    foundLocale = SUPPORTED_LOCALES.find((supportedLocale) => {
      const supportedLang = supportedLocale.split("_")[0];
      return supportedLang.toLowerCase() === langTag.toLowerCase();
    });
  }
  return foundLocale ?? DEFAULT_LOCALE;
}
/**
 * @param {string} [params.locale] - string to get locale from. Defaults to `navigator.language`
 * @param {string} [params.countryCode] - string to use as the country code for the locale
 * @param {LocaleFormat} [params.to=okta] - target format for the locale, defaults to 'okta'
 * @description Use to get a supported and properly formatted locale
 * @returns {SupportedLocale | GlobalNavSupportedLocale}
 */
function getLocale({ locale, countryCode, to = "okta" } = {}) {
  let rawLocale = locale;
  if (!rawLocale) {
    rawLocale = sourceLocaleFromBrowser();
  }
  // Parse out language and locale
  const regex = rawLocale.match(
    /^(?<lang>[a-z]{2})?(?:[_-])?(?<locale>[a-z]{2})?$/i,
  );
  // Create a valid tag
  // https://www.loc.gov/standards/iso639-2/php/English_list.php
  // https://datatracker.ietf.org/doc/html/rfc5646
  const tag =
    [regex?.groups?.lang, regex?.groups?.locale?.toUpperCase()]
      .filter(Boolean)
      .join("_") || rawLocale;
  // Normalize to Okta-style locale
  const normalizedLocale = tag.toLowerCase();
  const [langTag, normalizedCountry] = normalizedLocale.split("_");
  let regionTag = countryCode?.toLowerCase();
  if (!regionTag) {
    regionTag = normalizedCountry;
  }
  const supportedLocale = getSupportedLocale({
    langTag,
    regionTag,
  });
  if (to === "globalNav") {
    const globalNavLocale = langTag === "ru" ? DEFAULT_LOCALE : supportedLocale;
    return globalNavLocale.replace("_", "-");
  }
  return supportedLocale;
}
function getSupportedLang({ locale, supportedLangs }) {
  const mutableArr = [...supportedLangs]; // Simply to appease TS deities
  let foundLang = mutableArr.find(
    (lang) => lang.toLowerCase() === locale.toLowerCase(),
  );
  const langTag = locale.split(/[_|-]/)[0];
  if (!foundLang) {
    foundLang = mutableArr.find(
      (lang) => lang.toLowerCase() === langTag.toLowerCase(),
    );
  }
  // If still not found, fallback to the first locale that is supported for that langTag
  if (!foundLang) {
    foundLang = mutableArr.find((lang) => {
      const langLang = lang.split(/[_|-]/)[0];
      return langLang.toLowerCase() === langTag.toLowerCase();
    });
  }
  return foundLang;
}
/**
 * @param {string} [params.locale] - locale to get lang tag from, otherwise will try to use `navigator.language`
 * @param {LanguageFormat} [params.format=digital] - target to use the lang tag in, defaults to 'digital'
 * @description Use to get the properly formatted language
 * @returns {SupportedLanguage}
 */
function getLanguage({ locale, format = "digital" } = {}) {
  const supportedLocale = getLocale({
    locale,
  });
  const formattedLocale =
    format === "sfPlatform"
      ? supportedLocale.replace("-", "_")
      : supportedLocale.replace("_", "-");
  const supportedLangs =
    format === "trailhead"
      ? TRAILHEAD_SUPPORTED_LANGUAGES
      : format === "sfPlatform"
      ? SF_PLATFORM_SUPPORTED_LANGUAGES
      : DIGITAL_SUPPORTED_LANGUAGES;
  let supportedLang = getSupportedLang({
    locale: formattedLocale,
    supportedLangs,
  });
  if (!supportedLang) {
    supportedLang = format === "sfPlatform" ? DEFAULT_LOCALE : DEFAULT_LANG;
  }
  return format === "sfPlatform"
    ? supportedLang
    : supportedLang.replace("_", "-");
}

const DEFAULT_FALLBACKS = false;
/* i18n Configuration */
i18n.fallbacks = DEFAULT_FALLBACKS;
//@ts-ignore
i18n.missingTranslation = (key) => {
  const message = `missing "${key}" translation for locale "${i18n.locale}"`;
  return `[${message}]`;
};
//@ts-ignore
i18n.missingPlaceholder = (placeholder, label) => {
  return `[missing ${placeholder} value]`;
};
let state = {
  configureHandlers: [],
  changeHandlers: [],
  i18n: [i18n],
  // This is arbitrarily high to avoid conflicting with old versions before the guids were unique
  previousId: 2000,
};
class I18n {
  id = this.getUniqueId();
  constructor(scope) {
    if (scope) this.addScope(scope);
  }
  t(scope, key, options) {
    return i18n.t(`${scope}_${this.id}.${key}`, options);
  }
  addScope(scope) {
    for (const [scopeName, locales] of Object.entries(scope)) {
      for (const [locale, labels] of Object.entries(locales)) {
        const localeKey = getLanguage({
          locale,
        });
        i18n.translations[localeKey] = {
          ...i18n.translations[localeKey],
          [`${scopeName}_${this.id}`]: labels,
        };
      }
    }
  }
  getUniqueId() {
    return (state.previousId += 1);
  }
}
function configure(configHandler) {
  state.configureHandlers.push(configHandler);
  for (const i18n of state.i18n) {
    configHandler(i18n);
  }
}
function setLanguage(locale) {
  const selectedLanguage = getLanguage({
    locale,
  });
  configure((i18n) => {
    i18n.locale = selectedLanguage;
  });
  for (const handler of state.changeHandlers) {
    handler(selectedLanguage);
  }
}
function initializeState(currentState, existingState) {
  if (!existingState) return currentState;
  // Most likely, i18n is the same between modules as the i18n-js module attaches to window and then exports any
  // previously set instance. To ensure backwards compatibility, and to guard against changes to the i18n-js module in
  // the future, we keep the array of instances here.
  if (!existingState.i18n.includes(i18n)) {
    existingState.i18n = [...existingState.i18n, i18n];
  }
  // Run configurations that happened before this module was loaded
  for (const configHandler of existingState.configureHandlers) {
    configHandler(i18n);
  }
  // Ensure the previousId doesn't match between runs
  existingState.previousId += 1;
  return existingState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
  // @ts-ignore
  window["@sfdc-www/digital-i18n"] = state = initializeState(
    state,
    // @ts-ignore
    window["@sfdc-www/digital-i18n"],
  );
}

var status$i = {
  loading: "Indlæser...",
};
var progress$i = {
  steps: "Trin %{currentStepNumber} af %{totalSteps}",
};
var fields$i = {
  email: "Mail",
  country: "Land/område",
  state: "Stat/provins",
  first_name: "Fornavn",
  last_name: "Efternavn",
  company_name: "Firmanavn",
  role: "Rollenavn",
  relationship: "Relation til Salesforce",
  required: "(krævet)",
  select_placeholder: "Vælg en indstilling",
};
var buttons$i = {
  close: "Luk",
  cancel: "Annuller",
  save: "Gem",
  next: "Næste",
  continue: "Fortsæt",
};
var errors$i = {
  something_went_wrong: "Noget gik galt. Prøv igen.",
  fill_required_fields: "Udfyld de krævede felter, før du sender.",
};
var countries$i = {
  AF: "Afghanistan",
  AX: "Ålandsøerne",
  AL: "Albanien",
  DZ: "Algeriet",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Østrig",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia, Den Flernationale Stat",
  BQ: "Bonaire, Saint Eustatius og Saba",
  BA: "Bosnien-Hercegovina",
  BW: "Botswana",
  BV: "Bouvetø",
  BR: "Brasilien",
  IO: "De Britiske Territorier i Det Indiske Ocean",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Kap Verde",
  KY: "Caymanøerne",
  CF: "Den Centralafrikanske Republik",
  TD: "Tchad",
  CL: "Chile",
  CN: "Kina",
  CX: "Juleøen",
  CC: "Cocosøerne (Keelingøerne)",
  CO: "Colombia",
  KM: "Comorerne",
  CG: "Congo",
  CD: "Congo, Den Demokratiske Republik",
  CK: "Cookøerne",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatien",
  CW: "Curaçao",
  CY: "Cypern",
  CZ: "Tjekkiet",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den Dominikanske Republik",
  EC: "Ecuador",
  EG: "Egypten",
  SV: "El Salvador",
  GQ: "Ækvatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopien",
  FK: "Falklandsøerne (Islas Malvinas)",
  FO: "Færøerne",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrig",
  GF: "Fransk Guyana",
  PF: "Fransk Polynesien",
  TF: "Franske oversøiske områder",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grækenland",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard- og McDonaldøerne",
  VA: "Vatikanstaten",
  HK: "Hongkong",
  HN: "Honduras",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IQ: "Irak",
  IE: "Irland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kasakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Korea, Republikken",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos, Den Demokratiske Folkerepublik",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Makedonien, Den Tidligere Jugoslaviske Republik",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldiverne",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinique",
  MR: "Mauritanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  MD: "Moldova, Republikken",
  MC: "Monaco",
  MN: "Mongoliet",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holland",
  NC: "Ny Kaledonien",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palæstina",
  PA: "Panama",
  PG: "Papua Ny Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinerne",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumænien",
  RU: "Den Russiske Føderation",
  RW: "Rwanda",
  BL: "Saint Barthélemy",
  SH: "Sankt Helene, Ascension og Tristan da Cunha",
  KN: "Saint Kitts og Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (fransk del)",
  PM: "Saint Pierre og Miquelon",
  VC: "Saint Vincent og Grenadinerne",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellerne",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (hollandsk del)",
  SK: "Slovakiet",
  SI: "Slovenien",
  SB: "Salomonøerne",
  SO: "Somalia",
  ZA: "Sydafrika",
  GS: "South Georgia og De Sydlige Sandwichøer",
  SS: "Sydsudan",
  ES: "Spanien",
  LK: "Sri Lanka",
  SR: "Surinam",
  SJ: "Svalbard og Jan Mayen",
  SZ: "Swaziland",
  SE: "Sverige",
  CH: "Schweiz",
  TW: "Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania, Den Forenede Republik",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunesien",
  TR: "Tyrkiet",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøerne",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Forenede Arabiske Emirater",
  GB: "UK",
  US: "USA",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela, Den Bolivariske Republik",
  VN: "Vietnam",
  VG: "De Britiske Jomfruøer",
  WF: "Wallis og Futuna",
  EH: "Westsahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
var states$i = {
  AU: {
    ACT: "Australian Capital Territory",
    NSW: "New South Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "Sydaustralien",
    TAS: "Tasmanien",
    VIC: "Victoria",
    WA: "Vestaustralien",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland og Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon Territories",
  },
  CN: {
    11: "Beijing",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Indre Mongoliet",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hongkong",
    92: "Macao",
  },
  IN: {
    AN: "Andamanerne og Nicobarerne",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra og Nagar Haveli",
    DD: "Daman og Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu og Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "Vestbengal",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Kork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Firenze",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genoa",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa og Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milano",
    MO: "Modena",
    MB: "Monza og Brianza",
    NA: "Napoli",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro e Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Rom",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Syracuse",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Turin",
    UD: "Udine",
    VA: "Varese",
    VE: "Venedig",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Føderalt distrikt",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Mexico (stat)",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "Californien",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgien",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var da = {
  status: status$i,
  progress: progress$i,
  fields: fields$i,
  buttons: buttons$i,
  errors: errors$i,
  countries: countries$i,
  states: states$i,
};

var status$h = {
  loading: "Laden...",
};
var progress$h = {
  steps: "Schritt %{currentStepNumber} von %{totalSteps}",
};
var fields$h = {
  email: "E-Mail",
  country: "Land/Region",
  state: "Bundesland",
  first_name: "Vorname",
  last_name: "Nachname",
  company_name: "Firmenname",
  role: "Rollenname",
  relationship: "Beziehung zu Salesforce",
  required: "(erforderlich)",
  select_placeholder: "Wählen Sie eine Option aus",
};
var buttons$h = {
  close: "Schließen",
  cancel: "Abbrechen",
  save: "Speichern",
  next: "Weiter",
  continue: "Weiter",
};
var errors$h = {
  something_went_wrong: "Ein Fehler ist aufgetreten. Versuchen Sie es erneut.",
  fill_required_fields: "Füllen Sie vor dem Senden die Pflichtfelder aus.",
};
var countries$h = {
  AF: "Afghanistan",
  AX: "Aland-Inseln",
  AL: "Albanien",
  DZ: "Algerien",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua und Barbuda",
  AR: "Argentinien",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Österreich",
  AZ: "Aserbaidschan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesch",
  BB: "Barbados",
  BY: "Weißrussland (Belarus)",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivien, Plurinationaler Staat",
  BQ: "Bonaire, Sint Eustatius und Saba",
  BA: "Bosnien und Herzegowina",
  BW: "Botsuana",
  BV: "Bouvetinsel",
  BR: "Brasilien",
  IO: "Britisches Territorium im Indischen Ozean",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodscha",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KY: "Kaimaninseln",
  CF: "Zentralafrikanische Republik",
  TD: "Tschad",
  CL: "Chile",
  CN: "China",
  CX: "Weihnachtsinsel",
  CC: "Kokosinseln (Keelinginseln)",
  CO: "Kolumbien",
  KM: "Komoren",
  CG: "Kongo",
  CD: "Kongo, Demokratische Republik",
  CK: "Cookinseln",
  CR: "Costa Rica",
  CI: "Côte d'Ivoire",
  HR: "Kroatien",
  CW: "Curaçao",
  CY: "Zypern",
  CZ: "Tschechische Republik",
  DK: "Dänemark",
  DJ: "Dschibuti",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  EC: "Ecuador",
  EG: "Ägypten",
  SV: "El Salvador",
  GQ: "Äquatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Äthiopien",
  FK: "Falklandinseln (Malwinen)",
  FO: "Färöer Inseln",
  FJ: "Fidschi",
  FI: "Finnland",
  FR: "Frankreich",
  GF: "Französisch-Guayana",
  PF: "Französisch-Polynesien",
  TF: "Französische Südliche Territorien",
  GA: "Gabun",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Deutschland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griechenland",
  GL: "Grönland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-Insel und McDonald-Inseln",
  VA: "Heiliger Stuhl (Vatikanstadt)",
  HK: "Hongkong",
  HN: "Honduras",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IQ: "Irak",
  IE: "Irland",
  IM: "Insel Man",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaika",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanien",
  KZ: "Kasachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KR: "Korea, Republik",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos, Demokratische Volksrepublik",
  LV: "Lettland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao",
  MK: "Mazedonien, Ehemalige Jugoslawische Republik",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexiko",
  MD: "Moldau, Republik",
  MC: "Monaco",
  MN: "Mongolei",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Niederlande",
  NC: "Neukaledonien",
  NZ: "Neuseeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk-Insel",
  NO: "Norwegen",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palästina",
  PA: "Panama",
  PG: "Papua-Neuguinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippinen",
  PN: "Pitcairninseln",
  PL: "Polen",
  PT: "Portugal",
  QA: "Katar",
  RE: "Réunion",
  RO: "Rumänien",
  RU: "Russische Föderation",
  RW: "Ruanda",
  BL: "Saint-Barthélemy",
  SH: "S. Helena, Ascension und Tristan da Cunha",
  KN: "St. Kitts und Nevis",
  LC: "St. Lucia",
  MF: "Saint Martin (französischer Teil)",
  PM: "St. Pierre und Miquelon",
  VC: "St. Vincent und die Grenadinen",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé und Príncipe",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapur",
  SX: "Sint Maarten (niederländischer Teil)",
  SK: "Slowakei",
  SI: "Slowenien",
  SB: "Salomonen",
  SO: "Somalia",
  ZA: "Südafrika",
  GS: "Südgeorgien und die Südl. Sandwichinseln",
  SS: "Südsudan",
  ES: "Spanien",
  LK: "Sri Lanka",
  SR: "Suriname",
  SJ: "Svalbard und Jan Mayen",
  SZ: "Swasiland",
  SE: "Schweden",
  CH: "Schweiz",
  TW: "Taiwan",
  TJ: "Tadschikistan",
  TZ: "Tansania, Vereinigte Republik",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad und Tobago",
  TN: "Tunesien",
  TR: "Türkei",
  TM: "Turkmenistan",
  TC: "Turks- und Caicosinseln",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Vereinigte Arabische Emirate",
  GB: "Großbritannien",
  US: "USA",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela, Bolivarische Republik",
  VN: "Vietnam",
  VG: "Jungferninseln, Britisch",
  WF: "Wallis und Futuna",
  EH: "Westsahara",
  YE: "Jemen",
  ZM: "Sambia",
  ZW: "Simbabwe",
};
var states$h = {
  AU: {
    ACT: "Australian Capital Territory",
    NSW: "New South Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "South Australia",
    TAS: "Tasmanien",
    VIC: "Victoria",
    WA: "West Australia",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Neufundland und Labrador",
    NT: "Nordwest-Territorien",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon",
  },
  CN: {
    11: "Peking",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Innere Mongolei",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hongkong",
    92: "Macao",
  },
  IN: {
    AN: "Andamanen und Nikobaren",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra und Nagar Haveli",
    DD: "Daman und Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu und Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "Westbengalen",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BZ: "Bozen",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Florenz",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genua",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa und Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Mailand",
    MO: "Modena",
    MB: "Monza und Brianza",
    NA: "Neapel",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro und Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Rom",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Syracuse",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trient",
    TV: "Treviso",
    TS: "Triest",
    TO: "Turin",
    UD: "Udine",
    VA: "Varese",
    VE: "Venedig",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Federal District",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Mexico (Bundesstaat)",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "Kalifornien",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgien",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var de = {
  status: status$h,
  progress: progress$h,
  fields: fields$h,
  buttons: buttons$h,
  errors: errors$h,
  countries: countries$h,
  states: states$h,
};

var status$g = {
  loading: "Loading...",
};
var progress$g = {
  steps: "Step %{currentStepNumber} of %{totalSteps}",
};
var fields$g = {
  email: "Email",
  country: "Country/Region",
  state: "State/Province",
  first_name: "First name",
  last_name: "Last name",
  company_name: "Company name",
  role: "Role name",
  relationship: "Relationship to Salesforce",
  required: "(required)",
  select_placeholder: "Select an option",
};
var buttons$g = {
  close: "Close",
  cancel: "Cancel",
  save: "Save",
  next: "Next",
  continue: "Continue",
};
var errors$g = {
  something_went_wrong: "Something went wrong, please try again",
  fill_required_fields: "Please fill in the required fields before submitting.",
};
var countries$g = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia, Plurinational State of",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote d'Ivoire",
  HR: "Croatia",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HK: "Hong Kong",
  HN: "Honduras",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Korea, Republic of",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthélemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela, Bolivarian Republic of",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
var states$g = {
  AU: {
    ACT: "Australian Capital Territory",
    NSW: "New South Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "South Australia",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Western Australia",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon Territories",
  },
  CN: {
    11: "Beijing",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Nei Mongol",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hong Kong",
    92: "Macao",
  },
  IN: {
    AN: "Andaman and Nicobar Islands",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra and Nagar Haveli",
    DD: "Daman and Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu and Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "West Bengal",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Florence",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genoa",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa and Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milan",
    MO: "Modena",
    MB: "Monza and Brianza",
    NA: "Naples",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro and Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Rome",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Syracuse",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Turin",
    UD: "Udine",
    VA: "Varese",
    VE: "Venice",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Federal District",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Mexico State",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var en = {
  status: status$g,
  progress: progress$g,
  fields: fields$g,
  buttons: buttons$g,
  errors: errors$g,
  countries: countries$g,
  states: states$g,
};

var status$f = {
  loading: "[Loading...]'介引户ה]",
};
var progress$f = {
  steps: "[Step %{currentStepNumber} of %{totalSteps}]'介引户הаí 先ร简 аน取정]",
};
var fields$f = {
  email: "[Email]'介引户הа]",
  country: "[Country/region]'介引户ה]",
  state: "[State]'介引户הа]",
  first_name: "[First name]'介引户ה]",
  last_name: "[Last name]'介引户]",
  company_name: "[Company name]'介引户הа]",
  role: "[Role name]'介引户]",
  relationship: "[Relationship to Salesforce]'介引户הаí 先ร]",
  required: "[(required)]'介引户ה]",
  select_placeholder: "[Select an option]'介引户ה]",
};
var buttons$f = {
  close: "[Close]'介引户הа]",
  cancel: "[Cancel]'介引]",
  save: "[Save]'介引户]",
  next: "[Next]'介引户]",
  continue: "[Continue]'介引户]",
};
var errors$f = {
  something_went_wrong:
    "[Something went wrong, please try again]'介引户הаí 先ร简 аน取]",
  fill_required_fields:
    "[Please fill in the required fields before submitting.]'介引户הаí 先ร简 аน取정úσι м]",
};
var countries$f = {
  AF: "[Afghanistan]'介引户ה]",
  AX: "[Aland Islands]'介引户ה]",
  AL: "[Albania]'介引]",
  DZ: "[Algeria]'介引]",
  AD: "[Andorra]'介引]",
  AO: "[Angola]'介引]",
  AI: "[Anguilla]'介引户]",
  AQ: "[Antarctica]'介引户ה]",
  AG: "[Antigua and Barbuda]'介引户הаí]",
  AR: "[Argentina]'介引户]",
  AM: "[Armenia]'介引]",
  AW: "[Aruba]'介引户הа]",
  AU: "[Australia]'介引户]",
  AT: "[Austria]'介引]",
  AZ: "[Azerbaijan]'介引户ה]",
  BS: "[Bahamas]'介引]",
  BH: "[Bahrain]'介引]",
  BD: "[Bangladesh]'介引户ה]",
  BB: "[Barbados]'介引户]",
  BY: "[Belarus]'介引]",
  BE: "[Belgium]'介引]",
  BZ: "[Belize]'介引]",
  BJ: "[Benin]'介引户הа]",
  BM: "[Bermuda]'介引]",
  BT: "[Bhutan]'介引]",
  BO: "[Bolivia, Plurinational State of]'介引户הаí 先ร简 ]",
  BQ: "[Bonaire, Sint Eustatius and Saba]'介引户הаí 先ร简 ]",
  BA: "[Bosnia and Herzegovina]'介引户הаí ]",
  BW: "[Botswana]'介引户]",
  BV: "[Bouvet Island]'介引户ה]",
  BR: "[Brazil]'介引]",
  IO: "[British Indian Ocean Territory]'介引户הаí 先ร简 ]",
  BN: "[Brunei Darussalam]'介引户הа]",
  BG: "[Bulgaria]'介引户]",
  BF: "[Burkina Faso]'介引户הа]",
  BI: "[Burundi]'介引]",
  KH: "[Cambodia]'介引户]",
  CM: "[Cameroon]'介引户]",
  CA: "[Canada]'介引]",
  CV: "[Cape Verde]'介引户ה]",
  KY: "[Cayman Islands]'介引户ה]",
  CF: "[Central African Republic]'介引户הаí 先]",
  TD: "[Chad]'介引户]",
  CL: "[Chile]'介引户הа]",
  CN: "[China]'介引户הа]",
  CX: "[Christmas Island]'介引户הа]",
  CC: "[Cocos (Keeling) Islands]'介引户הаí 先]",
  CO: "[Colombia]'介引户]",
  KM: "[Comoros]'介引]",
  CG: "[Congo]'介引户הа]",
  CD: "[Congo, the Democratic Republic of the]'介引户הаí 先ร简 аน]",
  CK: "[Cook Islands]'介引户הа]",
  CR: "[Costa Rica]'介引户ה]",
  CI: "[Cote d'Ivoire]'介引户ה]",
  HR: "[Croatia]'介引]",
  CW: "[Curaçao]'介引]",
  CY: "[Cyprus]'介引]",
  CZ: "[Czech Republic]'介引户ה]",
  DK: "[Denmark]'介引]",
  DJ: "[Djibouti]'介引户]",
  DM: "[Dominica]'介引户]",
  DO: "[Dominican Republic]'介引户הаí]",
  EC: "[Ecuador]'介引]",
  EG: "[Egypt]'介引户הа]",
  SV: "[El Salvador]'介引户ה]",
  GQ: "[Equatorial Guinea]'介引户הа]",
  ER: "[Eritrea]'介引]",
  EE: "[Estonia]'介引]",
  ET: "[Ethiopia]'介引户]",
  FK: "[Falkland Islands (Malvinas)]'介引户הаí 先ร]",
  FO: "[Faroe Islands]'介引户ה]",
  FJ: "[Fiji]'介引户]",
  FI: "[Finland]'介引]",
  FR: "[France]'介引]",
  GF: "[French Guiana]'介引户ה]",
  PF: "[French Polynesia]'介引户הа]",
  TF: "[French Southern Territories]'介引户הаí 先ร]",
  GA: "[Gabon]'介引户הа]",
  GM: "[Gambia]'介引]",
  GE: "[Georgia]'介引]",
  DE: "[Germany]'介引]",
  GH: "[Ghana]'介引户הа]",
  GI: "[Gibraltar]'介引户]",
  GR: "[Greece]'介引]",
  GL: "[Greenland]'介引户]",
  GD: "[Grenada]'介引]",
  GP: "[Guadeloupe]'介引户ה]",
  GT: "[Guatemala]'介引户]",
  GG: "[Guernsey]'介引户]",
  GN: "[Guinea]'介引]",
  GW: "[Guinea-Bissau]'介引户ה]",
  GY: "[Guyana]'介引]",
  HT: "[Haiti]'介引户הа]",
  HM: "[Heard Island and McDonald Islands]'介引户הаí 先ร简 а]",
  VA: "[Holy See (Vatican City State)]'介引户הаí 先ร简]",
  HK: "[Hong Kong]'介引户]",
  HN: "[Honduras]'介引户]",
  HU: "[Hungary]'介引]",
  IS: "[Iceland]'介引]",
  IN: "[India]'介引户הа]",
  ID: "[Indonesia]'介引户]",
  IQ: "[Iraq]'介引户]",
  IE: "[Ireland]'介引]",
  IM: "[Isle of Man]'介引户ה]",
  IL: "[Israel]'介引]",
  IT: "[Italy]'介引户הа]",
  JM: "[Jamaica]'介引]",
  JP: "[Japan]'介引户הа]",
  JE: "[Jersey]'介引]",
  JO: "[Jordan]'介引]",
  KZ: "[Kazakhstan]'介引户ה]",
  KE: "[Kenya]'介引户הа]",
  KI: "[Kiribati]'介引户]",
  KR: "[Korea, Republic of]'介引户הаí]",
  KW: "[Kuwait]'介引]",
  KG: "[Kyrgyzstan]'介引户ה]",
  LA: "[Lao People's Democratic Republic]'介引户הаí 先ร简 ]",
  LV: "[Latvia]'介引]",
  LB: "[Lebanon]'介引]",
  LS: "[Lesotho]'介引]",
  LR: "[Liberia]'介引]",
  LY: "[Libya]'介引户הа]",
  LI: "[Liechtenstein]'介引户ה]",
  LT: "[Lithuania]'介引户]",
  LU: "[Luxembourg]'介引户ה]",
  MO: "[Macao]'介引户הа]",
  MK: "[Macedonia, the former Yugoslav Republic of]'介引户הаí 先ร简 аน取정]",
  MG: "[Madagascar]'介引户ה]",
  MW: "[Malawi]'介引]",
  MY: "[Malaysia]'介引户]",
  MV: "[Maldives]'介引户]",
  ML: "[Mali]'介引户]",
  MT: "[Malta]'介引户הа]",
  MQ: "[Martinique]'介引户ה]",
  MR: "[Mauritania]'介引户ה]",
  MU: "[Mauritius]'介引户]",
  YT: "[Mayotte]'介引]",
  MX: "[Mexico]'介引]",
  MD: "[Moldova, Republic of]'介引户הаí ]",
  MC: "[Monaco]'介引]",
  MN: "[Mongolia]'介引户]",
  ME: "[Montenegro]'介引户ה]",
  MS: "[Montserrat]'介引户ה]",
  MA: "[Morocco]'介引]",
  MZ: "[Mozambique]'介引户ה]",
  MM: "[Myanmar]'介引]",
  NA: "[Namibia]'介引]",
  NR: "[Nauru]'介引户הа]",
  NP: "[Nepal]'介引户הа]",
  NL: "[Netherlands]'介引户ה]",
  NC: "[New Caledonia]'介引户ה]",
  NZ: "[New Zealand]'介引户ה]",
  NI: "[Nicaragua]'介引户]",
  NE: "[Niger]'介引户הа]",
  NG: "[Nigeria]'介引]",
  NU: "[Niue]'介引户]",
  NF: "[Norfolk Island]'介引户ה]",
  NO: "[Norway]'介引]",
  OM: "[Oman]'介引户]",
  PK: "[Pakistan]'介引户]",
  PS: "[Palestine]'介引户]",
  PA: "[Panama]'介引]",
  PG: "[Papua New Guinea]'介引户הа]",
  PY: "[Paraguay]'介引户]",
  PE: "[Peru]'介引户]",
  PH: "[Philippines]'介引户ה]",
  PN: "[Pitcairn]'介引户]",
  PL: "[Poland]'介引]",
  PT: "[Portugal]'介引户]",
  QA: "[Qatar]'介引户הа]",
  RE: "[Reunion]'介引]",
  RO: "[Romania]'介引]",
  RU: "[Russian Federation]'介引户הаí]",
  RW: "[Rwanda]'介引]",
  BL: "[Saint Barthélemy]'介引户הа]",
  SH: "[Saint Helena, Ascension and Tristan da Cunha]'介引户הаí 先ร简 аน取정ú]",
  KN: "[Saint Kitts and Nevis]'介引户הаí ]",
  LC: "[Saint Lucia]'介引户ה]",
  MF: "[Saint Martin (French part)]'介引户הаí 先ร]",
  PM: "[Saint Pierre and Miquelon]'介引户הаí 先ร]",
  VC: "[Saint Vincent and the Grenadines]'介引户הаí 先ร简 ]",
  WS: "[Samoa]'介引户הа]",
  SM: "[San Marino]'介引户ה]",
  ST: "[Sao Tome and Principe]'介引户הаí ]",
  SA: "[Saudi Arabia]'介引户הа]",
  SN: "[Senegal]'介引]",
  RS: "[Serbia]'介引]",
  SC: "[Seychelles]'介引户ה]",
  SL: "[Sierra Leone]'介引户הа]",
  SG: "[Singapore]'介引户]",
  SX: "[Sint Maarten (Dutch part)]'介引户הаí 先ร]",
  SK: "[Slovakia]'介引户]",
  SI: "[Slovenia]'介引户]",
  SB: "[Solomon Islands]'介引户הа]",
  SO: "[Somalia]'介引]",
  ZA: "[South Africa]'介引户הа]",
  GS: "[South Georgia and the South Sandwich Islands]'介引户הаí 先ร简 аน取정ú]",
  SS: "[South Sudan]'介引户ה]",
  ES: "[Spain]'介引户הа]",
  LK: "[Sri Lanka]'介引户]",
  SR: "[Suriname]'介引户]",
  SJ: "[Svalbard and Jan Mayen]'介引户הаí ]",
  SZ: "[Swaziland]'介引户]",
  SE: "[Sweden]'介引]",
  CH: "[Switzerland]'介引户ה]",
  TW: "[Taiwan]'介引]",
  TJ: "[Tajikistan]'介引户ה]",
  TZ: "[Tanzania, United Republic of]'介引户הаí 先ร简]",
  TH: "[Thailand]'介引户]",
  TL: "[Timor-Leste]'介引户ה]",
  TG: "[Togo]'介引户]",
  TK: "[Tokelau]'介引]",
  TO: "[Tonga]'介引户הа]",
  TT: "[Trinidad and Tobago]'介引户הаí]",
  TN: "[Tunisia]'介引]",
  TR: "[Turkey]'介引]",
  TM: "[Turkmenistan]'介引户הа]",
  TC: "[Turks and Caicos Islands]'介引户הаí 先]",
  TV: "[Tuvalu]'介引]",
  UG: "[Uganda]'介引]",
  UA: "[Ukraine]'介引]",
  AE: "[United Arab Emirates]'介引户הаí ]",
  GB: "[United Kingdom]'介引户ה]",
  US: "[United States]'介引户ה]",
  UY: "[Uruguay]'介引]",
  UZ: "[Uzbekistan]'介引户ה]",
  VU: "[Vanuatu]'介引]",
  VE: "[Venezuela, Bolivarian Republic of]'介引户הаí 先ร简 а]",
  VN: "[Vietnam]'介引]",
  VG: "[Virgin Islands, British]'介引户הаí 先]",
  WF: "[Wallis and Futuna]'介引户הа]",
  EH: "[Western Sahara]'介引户ה]",
  YE: "[Yemen]'介引户הа]",
  ZM: "[Zambia]'介引]",
  ZW: "[Zimbabwe]'介引户]",
};
var states$f = {
  AU: {
    ACT: "[Australian Capital Territory]'介引户הаí 先ร简]",
    NSW: "[New South Wales]'介引户הа]",
    NT: "[Northern Territory]'介引户הаí]",
    QLD: "[Queensland]'介引户ה]",
    SA: "[South Australia]'介引户הа]",
    TAS: "[Tasmania]'介引户]",
    VIC: "[Victoria]'介引户]",
    WA: "[Western Australia]'介引户הа]",
  },
  BR: {
    AC: "[Acre]'介引户]",
    AL: "[Alagoas]'介引]",
    AP: "[Amapá]'介引户הа]",
    AM: "[Amazonas]'介引户]",
    BA: "[Bahia]'介引户הа]",
    CE: "[Ceará]'介引户הа]",
    DF: "[Distrito Federal]'介引户הа]",
    ES: "[Espírito Santo]'介引户ה]",
    GO: "[Goiás]'介引户הа]",
    MA: "[Maranhão]'介引户]",
    MT: "[Mato Grosso]'介引户ה]",
    MS: "[Mato Grosso do Sul]'介引户הаí]",
    MG: "[Minas Gerais]'介引户הа]",
    PA: "[Pará]'介引户]",
    PB: "[Paraíba]'介引]",
    PR: "[Paraná]'介引]",
    PE: "[Pernambuco]'介引户ה]",
    PI: "[Piauí]'介引户הа]",
    RJ: "[Rio de Janeiro]'介引户ה]",
    RN: "[Rio Grande do Norte]'介引户הаí]",
    RS: "[Rio Grande do Sul]'介引户הа]",
    RO: "[Rondônia]'介引户]",
    RR: "[Roraima]'介引]",
    SC: "[Santa Catarina]'介引户ה]",
    SP: "[São Paulo]'介引户]",
    SE: "[Sergipe]'介引]",
    TO: "[Tocantins]'介引户]",
  },
  CA: {
    AB: "[Alberta]'介引]",
    BC: "[British Columbia]'介引户הа]",
    MB: "[Manitoba]'介引户]",
    NB: "[New Brunswick]'介引户ה]",
    NL: "[Newfoundland and Labrador]'介引户הаí 先ร]",
    NT: "[Northwest Territories]'介引户הаí ]",
    NS: "[Nova Scotia]'介引户ה]",
    NU: "[Nunavut]'介引]",
    ON: "[Ontario]'介引]",
    PE: "[Prince Edward Island]'介引户הаí ]",
    QC: "[Quebec]'介引]",
    SK: "[Saskatchewan]'介引户הа]",
    YT: "[Yukon Territories]'介引户הа]",
  },
  CN: {
    11: "[Beijing]'介引]",
    12: "[Tianjin]'介引]",
    13: "[Hebei]'介引户הа]",
    14: "[Shanxi]'介引]",
    15: "[Nei Mongol]'介引户ה]",
    21: "[Liaoning]'介引户]",
    22: "[Jilin]'介引户הа]",
    23: "[Heilongjiang]'介引户הа]",
    31: "[Shanghai]'介引户]",
    32: "[Jiangsu]'介引]",
    33: "[Zhejiang]'介引户]",
    34: "[Anhui]'介引户הа]",
    35: "[Fujian]'介引]",
    36: "[Jiangxi]'介引]",
    37: "[Shandong]'介引户]",
    41: "[Henan]'介引户הа]",
    42: "[Hubei]'介引户הа]",
    43: "[Hunan]'介引户הа]",
    44: "[Guangdong]'介引户]",
    45: "[Guangxi]'介引]",
    46: "[Hainan]'介引]",
    50: "[Chongqing]'介引户]",
    51: "[Sichuan]'介引]",
    52: "[Guizhou]'介引]",
    53: "[Yunnan]'介引]",
    54: "[Xizang]'介引]",
    61: "[Shaanxi]'介引]",
    62: "[Gansu]'介引户הа]",
    63: "[Qinghai]'介引]",
    64: "[Ningxia]'介引]",
    65: "[Xinjiang]'介引户]",
    71: "[Taiwan]'介引]",
    91: "[Hong Kong]'介引户]",
    92: "[Macao]'介引户הа]",
  },
  IN: {
    AN: "[Andaman and Nicobar Islands]'介引户הаí 先ร]",
    AP: "[Andhra Pradesh]'介引户ה]",
    AR: "[Arunachal Pradesh]'介引户הа]",
    AS: "[Assam]'介引户הа]",
    BR: "[Bihar]'介引户הа]",
    CH: "[Chandigarh]'介引户ה]",
    CT: "[Chhattisgarh]'介引户הа]",
    DN: "[Dadra and Nagar Haveli]'介引户הаí ]",
    DD: "[Daman and Diu]'介引户ה]",
    DL: "[Delhi]'介引户הа]",
    GA: "[Goa]'介引]",
    GJ: "[Gujarat]'介引]",
    HR: "[Haryana]'介引]",
    HP: "[Himachal Pradesh]'介引户הа]",
    JK: "[Jammu and Kashmir]'介引户הа]",
    JH: "[Jharkhand]'介引户]",
    KA: "[Karnataka]'介引户]",
    KL: "[Kerala]'介引]",
    LD: "[Lakshadweep]'介引户ה]",
    MP: "[Madhya Pradesh]'介引户ה]",
    MH: "[Maharashtra]'介引户ה]",
    MN: "[Manipur]'介引]",
    ML: "[Meghalaya]'介引户]",
    MZ: "[Mizoram]'介引]",
    NL: "[Nagaland]'介引户]",
    OR: "[Odisha]'介引]",
    PY: "[Puducherry]'介引户ה]",
    PB: "[Punjab]'介引]",
    RJ: "[Rajasthan]'介引户]",
    SK: "[Sikkim]'介引]",
    TN: "[Tamil Nadu]'介引户ה]",
    TG: "[Telangana]'介引户]",
    TR: "[Tripura]'介引]",
    UT: "[Uttarakhand]'介引户ה]",
    UP: "[Uttar Pradesh]'介引户ה]",
    WB: "[West Bengal]'介引户ה]",
  },
  IE: {
    CW: "[Carlow]'介引]",
    CN: "[Cavan]'介引户הа]",
    CE: "[Clare]'介引户הа]",
    CO: "[Cork]'介引户]",
    DL: "[Donegal]'介引]",
    D: "[Dublin]'介引]",
    G: "[Galway]'介引]",
    KY: "[Kerry]'介引户הа]",
    KE: "[Kildare]'介引]",
    KK: "[Kilkenny]'介引户]",
    LS: "[Laois]'介引户הа]",
    LM: "[Leitrim]'介引]",
    LK: "[Limerick]'介引户]",
    LD: "[Longford]'介引户]",
    LH: "[Louth]'介引户הа]",
    MO: "[Mayo]'介引户]",
    MH: "[Meath]'介引户הа]",
    MN: "[Monaghan]'介引户]",
    OY: "[Offaly]'介引]",
    RN: "[Roscommon]'介引户]",
    SO: "[Sligo]'介引户הа]",
    TA: "[Tipperary]'介引户]",
    WD: "[Waterford]'介引户]",
    WH: "[Westmeath]'介引户]",
    WX: "[Wexford]'介引]",
    WW: "[Wicklow]'介引]",
  },
  IT: {
    AG: "[Agrigento]'介引户]",
    AL: "[Alessandria]'介引户ה]",
    AN: "[Ancona]'介引]",
    AO: "[Aosta]'介引户הа]",
    AR: "[Arezzo]'介引]",
    AP: "[Ascoli Piceno]'介引户ה]",
    AT: "[Asti]'介引户]",
    AV: "[Avellino]'介引户]",
    BA: "[Bari]'介引户]",
    BT: "[Barletta-Andria-Trani]'介引户הаí ]",
    BL: "[Belluno]'介引]",
    BN: "[Benevento]'介引户]",
    BG: "[Bergamo]'介引]",
    BI: "[Biella]'介引]",
    BO: "[Bologna]'介引]",
    BZ: "[Bolzano]'介引]",
    BS: "[Brescia]'介引]",
    BR: "[Brindisi]'介引户]",
    CA: "[Cagliari]'介引户]",
    CL: "[Caltanissetta]'介引户ה]",
    CB: "[Campobasso]'介引户ה]",
    CI: "[Carbonia-Iglesias]'介引户הа]",
    CE: "[Caserta]'介引]",
    CT: "[Catania]'介引]",
    CZ: "[Catanzaro]'介引户]",
    CH: "[Chieti]'介引]",
    CO: "[Como]'介引户]",
    CS: "[Cosenza]'介引]",
    CR: "[Cremona]'介引]",
    KR: "[Crotone]'介引]",
    CN: "[Cuneo]'介引户הа]",
    EN: "[Enna]'介引户]",
    FM: "[Fermo]'介引户הа]",
    FE: "[Ferrara]'介引]",
    FI: "[Florence]'介引户]",
    FG: "[Foggia]'介引]",
    FC: "[Forlì-Cesena]'介引户הа]",
    FR: "[Frosinone]'介引户]",
    GE: "[Genoa]'介引户הа]",
    GO: "[Gorizia]'介引]",
    GR: "[Grosseto]'介引户]",
    IM: "[Imperia]'介引]",
    IS: "[Isernia]'介引]",
    AQ: "[L'Aquila]'介引户]",
    SP: "[La Spezia]'介引户]",
    LT: "[Latina]'介引]",
    LE: "[Lecce]'介引户הа]",
    LC: "[Lecco]'介引户הа]",
    LI: "[Livorno]'介引]",
    LO: "[Lodi]'介引户]",
    LU: "[Lucca]'介引户הа]",
    MC: "[Macerata]'介引户]",
    MN: "[Mantua]'介引]",
    MS: "[Massa and Carrara]'介引户הа]",
    MT: "[Matera]'介引]",
    VS: "[Medio Campidano]'介引户הа]",
    ME: "[Messina]'介引]",
    MI: "[Milan]'介引户הа]",
    MO: "[Modena]'介引]",
    MB: "[Monza and Brianza]'介引户הа]",
    NA: "[Naples]'介引]",
    NO: "[Novara]'介引]",
    NU: "[Nuoro]'介引户הа]",
    OG: "[Ogliastra]'介引户]",
    OT: "[Olbia-Tempio]'介引户הа]",
    OR: "[Oristano]'介引户]",
    PD: "[Padua]'介引户הа]",
    PA: "[Palermo]'介引]",
    PR: "[Parma]'介引户הа]",
    PV: "[Pavia]'介引户הа]",
    PG: "[Perugia]'介引]",
    PU: "[Pesaro and Urbino]'介引户הа]",
    PE: "[Pescara]'介引]",
    PC: "[Piacenza]'介引户]",
    PI: "[Pisa]'介引户]",
    PT: "[Pistoia]'介引]",
    PN: "[Pordenone]'介引户]",
    PZ: "[Potenza]'介引]",
    PO: "[Prato]'介引户הа]",
    RG: "[Ragusa]'介引]",
    RA: "[Ravenna]'介引]",
    RC: "[Reggio Calabria]'介引户הа]",
    RE: "[Reggio Emilia]'介引户ה]",
    RI: "[Rieti]'介引户הа]",
    RN: "[Rimini]'介引]",
    RM: "[Rome]'介引户]",
    RO: "[Rovigo]'介引]",
    SA: "[Salerno]'介引]",
    SS: "[Sassari]'介引]",
    SV: "[Savona]'介引]",
    SI: "[Siena]'介引户הа]",
    SO: "[Sondrio]'介引]",
    SR: "[Syracuse]'介引户]",
    TA: "[Taranto]'介引]",
    TE: "[Teramo]'介引]",
    TR: "[Terni]'介引户הа]",
    TP: "[Trapani]'介引]",
    TN: "[Trento]'介引]",
    TV: "[Treviso]'介引]",
    TS: "[Trieste]'介引]",
    TO: "[Turin]'介引户הа]",
    UD: "[Udine]'介引户הа]",
    VA: "[Varese]'介引]",
    VE: "[Venice]'介引]",
    VB: "[Verbano-Cusio-Ossola]'介引户הаí ]",
    VC: "[Vercelli]'介引户]",
    VR: "[Verona]'介引]",
    VV: "[Vibo Valentia]'介引户ה]",
    VI: "[Vicenza]'介引]",
    VT: "[Viterbo]'介引]",
  },
  MX: {
    AG: "[Aguascalientes]'介引户ה]",
    BC: "[Baja California]'介引户הа]",
    BS: "[Baja California Sur]'介引户הаí]",
    CM: "[Campeche]'介引户]",
    CS: "[Chiapas]'介引]",
    CH: "[Chihuahua]'介引户]",
    CO: "[Coahuila]'介引户]",
    CL: "[Colima]'介引]",
    DG: "[Durango]'介引]",
    DF: "[Federal District]'介引户הа]",
    GT: "[Guanajuato]'介引户ה]",
    GR: "[Guerrero]'介引户]",
    HG: "[Hidalgo]'介引]",
    JA: "[Jalisco]'介引]",
    ME: "[Mexico State]'介引户הа]",
    MI: "[Michoacán]'介引户]",
    MO: "[Morelos]'介引]",
    NA: "[Nayarit]'介引]",
    NL: "[Nuevo León]'介引户ה]",
    OA: "[Oaxaca]'介引]",
    PB: "[Puebla]'介引]",
    QE: "[Querétaro]'介引户]",
    QR: "[Quintana Roo]'介引户הа]",
    SL: "[San Luis Potosí]'介引户הа]",
    SI: "[Sinaloa]'介引]",
    SO: "[Sonora]'介引]",
    TB: "[Tabasco]'介引]",
    TM: "[Tamaulipas]'介引户ה]",
    TL: "[Tlaxcala]'介引户]",
    VE: "[Veracruz]'介引户]",
    YU: "[Yucatán]'介引]",
    ZA: "[Zacatecas]'介引户]",
  },
  US: {
    AL: "[Alabama]'介引]",
    AK: "[Alaska]'介引]",
    AZ: "[Arizona]'介引]",
    AR: "[Arkansas]'介引户]",
    CA: "[California]'介引户ה]",
    CO: "[Colorado]'介引户]",
    CT: "[Connecticut]'介引户ה]",
    DE: "[Delaware]'介引户]",
    DC: "[District of Columbia]'介引户הаí ]",
    FL: "[Florida]'介引]",
    GA: "[Georgia]'介引]",
    HI: "[Hawaii]'介引]",
    ID: "[Idaho]'介引户הа]",
    IL: "[Illinois]'介引户]",
    IN: "[Indiana]'介引]",
    IA: "[Iowa]'介引户]",
    KS: "[Kansas]'介引]",
    KY: "[Kentucky]'介引户]",
    LA: "[Louisiana]'介引户]",
    ME: "[Maine]'介引户הа]",
    MD: "[Maryland]'介引户]",
    MA: "[Massachusetts]'介引户ה]",
    MI: "[Michigan]'介引户]",
    MN: "[Minnesota]'介引户]",
    MS: "[Mississippi]'介引户ה]",
    MO: "[Missouri]'介引户]",
    MT: "[Montana]'介引]",
    NE: "[Nebraska]'介引户]",
    NV: "[Nevada]'介引]",
    NH: "[New Hampshire]'介引户ה]",
    NJ: "[New Jersey]'介引户ה]",
    NM: "[New Mexico]'介引户ה]",
    NY: "[New York]'介引户]",
    NC: "[North Carolina]'介引户ה]",
    ND: "[North Dakota]'介引户הа]",
    OH: "[Ohio]'介引户]",
    OK: "[Oklahoma]'介引户]",
    OR: "[Oregon]'介引]",
    PA: "[Pennsylvania]'介引户הа]",
    PR: "[Puerto Rico]'介引户ה]",
    RI: "[Rhode Island]'介引户הа]",
    SC: "[South Carolina]'介引户ה]",
    SD: "[South Dakota]'介引户הа]",
    TN: "[Tennessee]'介引户]",
    TX: "[Texas]'介引户הа]",
    UT: "[Utah]'介引户]",
    VT: "[Vermont]'介引]",
    VA: "[Virginia]'介引户]",
    WA: "[Washington]'介引户ה]",
    WV: "[West Virginia]'介引户ה]",
    WI: "[Wisconsin]'介引户]",
    WY: "[Wyoming]'介引]",
  },
};
var eo = {
  status: status$f,
  progress: progress$f,
  fields: fields$f,
  buttons: buttons$f,
  errors: errors$f,
  countries: countries$f,
  states: states$f,
};

var status$e = {
  loading: "Cargando...",
};
var progress$e = {
  steps: "Paso %{currentStepNumber} de %{totalSteps}",
};
var fields$e = {
  email: "Correo electrónico",
  country: "País/Región",
  state: "Estado/Provincia",
  first_name: "Nombre",
  last_name: "Apellido",
  company_name: "Nombre de empresa",
  role: "Nombre de función",
  relationship: "Relación con Salesforce",
  required: "(obligatorio)",
  select_placeholder: "Seleccionar una opción",
};
var buttons$e = {
  close: "Cerrar",
  cancel: "Cancelar",
  save: "Guardar",
  next: "Siguiente",
  continue: "Continuar",
};
var errors$e = {
  something_went_wrong: "Se produjo un error, inténtelo de nuevo",
  fill_required_fields: "Complete los campos obligatorios antes de enviar.",
};
var countries$e = {
  AF: "Afganistán",
  AX: "Åland",
  AL: "Albania",
  DZ: "Argelia",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antártida",
  AG: "Antigua y Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaiyán",
  BS: "Bahamas",
  BH: "Baréin",
  BD: "Bangladés",
  BB: "Barbados",
  BY: "Bielorrusia",
  BE: "Bélgica",
  BZ: "Belice",
  BJ: "Benín",
  BM: "Bermudas",
  BT: "Bután",
  BO: "Bolivia",
  BQ: "Bonaire, San Eustaquio y Saba",
  BA: "Bosnia y Herzegovina",
  BW: "Botsuana",
  BV: "Isla Bouvet",
  BR: "Brasil",
  IO: "Territorio Británico del Océano Índico",
  BN: "Brunéi",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Camboya",
  CM: "Camerún",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Islas Caimán",
  CF: "República Centroafricana",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Isla de Navidad",
  CC: "Islas Cocos (Keeling)",
  CO: "Colombia",
  KM: "Comoras",
  CG: "República del Congo",
  CD: "República Democrática del Congo",
  CK: "Islas Cook",
  CR: "Costa Rica",
  CI: "Costa de Marfil (Cote d'Ivoire)",
  HR: "Croacia",
  CW: "Curazao",
  CY: "Chipre",
  CZ: "República Checa",
  DK: "Dinamarca",
  DJ: "Yibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Ecuador",
  EG: "Egipto",
  SV: "El Salvador",
  GQ: "Guinea Ecuatorial",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Etiopía",
  FK: "Islas Malvinas (Falkland)",
  FO: "Islas Feroe",
  FJ: "Fiyi",
  FI: "Finlandia",
  FR: "Francia",
  GF: "Guayana Francesa",
  PF: "Polinesia Francesa",
  TF: "Territorios Australes Franceses",
  GA: "Gabón",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Alemania",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecia",
  GL: "Groenlandia",
  GD: "Granada",
  GP: "Guadalupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bisáu",
  GY: "Guyana",
  HT: "Haití",
  HM: "Islas Heard y McDonald",
  VA: "Ciudad del Vaticano",
  HK: "Hong Kong",
  HN: "Honduras",
  HU: "Hungría",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IQ: "Irak",
  IE: "Irlanda",
  IM: "Isla de Man",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japón",
  JE: "Jersey",
  JO: "Jordania",
  KZ: "Kazajistán",
  KE: "Kenia",
  KI: "Kiribati",
  KR: "Corea del Sur",
  KW: "Kuwait",
  KG: "Kirguistán",
  LA: "República Democrática Popular Lao",
  LV: "Letonia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburgo",
  MO: "Macao",
  MK: "Antigua República Yugoslava de Macedonia",
  MG: "Madagascar",
  MW: "Malaui",
  MY: "Malasia",
  MV: "Maldivas",
  ML: "Malí",
  MT: "Malta",
  MQ: "Martinica",
  MR: "Mauritania",
  MU: "Mauricio",
  YT: "Mayotte",
  MX: "México",
  MD: "Moldavia",
  MC: "Mónaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marruecos",
  MZ: "Mozambique",
  MM: "Birmania",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Países Bajos",
  NC: "Nueva Caledonia",
  NZ: "Nueva Zelanda",
  NI: "Nicaragua",
  NE: "Níger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Isla Norfolk",
  NO: "Noruega",
  OM: "Omán",
  PK: "Pakistán",
  PS: "Palestina",
  PA: "Panamá",
  PG: "Papúa Nueva Guinea",
  PY: "Paraguay",
  PE: "Perú",
  PH: "Filipinas",
  PN: "Islas Pitcairn",
  PL: "Polonia",
  PT: "Portugal",
  QA: "Catar",
  RE: "Reunión",
  RO: "Rumanía",
  RU: "Federación Rusa",
  RW: "Ruanda",
  BL: "San Bartolomé",
  SH: "Santa Elena, Ascensión y Tristán de Acuña",
  KN: "San Cristóbal y Nieves",
  LC: "Santa Lucía",
  MF: "San Martín (parte francesa)",
  PM: "San Pedro y Miquelón",
  VC: "San Vicente y las Granadinas",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Santo Tomé y Príncipe",
  SA: "Arabia Saudí",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leona",
  SG: "Singapur",
  SX: "San Martín (parte holandesa)",
  SK: "Eslovaquia",
  SI: "Eslovenia",
  SB: "Islas Salomón",
  SO: "Somalia",
  ZA: "Sudáfrica",
  GS: "Islas Georgias del Sur y Sandwich del Sur",
  SS: "Sudán del Sur",
  ES: "España",
  LK: "Sri Lanka",
  SR: "Surinam",
  SJ: "Svalbard y Jan Mayen",
  SZ: "Esuatini",
  SE: "Suecia",
  CH: "Suiza",
  TW: "Taiwán",
  TJ: "Tayikistán",
  TZ: "República Unida de Tanzania",
  TH: "Tailandia",
  TL: "Timor Oriental",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad y Tobago",
  TN: "Túnez",
  TR: "Turquía",
  TM: "Turkmenistán",
  TC: "Islas Turcas y Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ucrania",
  AE: "Emiratos Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  VU: "Vanuatu",
  VE: "República Bolivariana de Venezuela",
  VN: "Vietnam",
  VG: "Islas Vírgenes Británicas",
  WF: "Wallis y Futuna",
  EH: "Sahara Occidental",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabue",
};
var states$e = {
  AU: {
    ACT: "Territorio de la Capital Australiana",
    NSW: "Nueva Gales del Sur",
    NT: "Territorio del Norte",
    QLD: "Queensland",
    SA: "Australia del Sur",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Australia del Oeste",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahía",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso del Sur",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Río de Janeiro",
    RN: "Río Grande del Norte",
    RS: "Río Grande del Sur",
    RO: "Rondonia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "Columbia Británica",
    MB: "Manitoba",
    NB: "Nuevo Brunswick",
    NL: "Terranova y Labrador",
    NT: "Territorios del Noroeste",
    NS: "Nueva Escocia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Isla del Príncipe Eduardo",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Territorio del Yucón",
  },
  CN: {
    11: "Pekín",
    12: "Tianjín",
    13: "Hebei",
    14: "Shanxi",
    15: "Mongolia Interior",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghái",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Tíbet",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwán",
    91: "Hong Kong",
    92: "Macao",
  },
  IN: {
    AN: "Islas de Andamán y Nicobar",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra y Nágar Havelí",
    DD: "Damán y Díu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu y Cachemira",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Laquedivas",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "Bengala Occidental",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Corcho",
    DL: "Donegal",
    D: "Dublín",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bérgamo",
    BI: "Biella",
    BO: "Bolonia",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Bríndisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotona",
    CN: "Cúneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Florencia",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Génova",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa y Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Mesina",
    MI: "Milán",
    MO: "Módena",
    MB: "Monza y Brianza",
    NA: "Nápoles",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristán",
    PD: "Padua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavía",
    PG: "Perugia",
    PU: "Pesaro y Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoya",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Rávena",
    RC: "Regio de Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rímini",
    RM: "Roma",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Siracusa",
    TA: "Tarento",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Turín",
    UD: "Údine",
    VA: "Varese",
    VE: "Venecia",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Distrito Federal",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Estado de México",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawái",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Luisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Míchigan",
    MN: "Minnesota",
    MS: "Misisipi",
    MO: "Misuri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "Nuevo Hampshire",
    NJ: "Nueva Jersey",
    NM: "Nuevo México",
    NY: "Nueva York",
    NC: "Carolina del Norte",
    ND: "Dakota del Norte",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregón",
    PA: "Pensilvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "Carolina del Sur",
    SD: "Dakota del Sur",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "Virginia Occidental",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var es = {
  status: status$e,
  progress: progress$e,
  fields: fields$e,
  buttons: buttons$e,
  errors: errors$e,
  countries: countries$e,
  states: states$e,
};

var status$d = {
  loading: "Cargando…",
};
var progress$d = {
  steps: "Paso %{currentStepNumber} de %{totalSteps}",
};
var fields$d = {
  email: "Email",
  country: "País/Región",
  state: "Estado/provincia",
  first_name: "Nombre",
  last_name: "Apellido",
  company_name: "Nombre de compañía",
  role: "Nombre de función",
  relationship: "Relación con Salesforce",
  required: "(obligatorio)",
  select_placeholder: "Seleccionar una opción",
};
var buttons$d = {
  close: "Cerrar",
  cancel: "Cancelar",
  save: "Guardar",
  next: "Siguiente",
  continue: "Continuar",
};
var errors$d = {
  something_went_wrong: "Algo falló. Inténtelo de nuevo",
  fill_required_fields:
    "Complete los campos obligatorios antes de enviar los datos.",
};
var countries$d = {
  AF: "Afganistán",
  AX: "Islas Åland",
  AL: "Albania",
  DZ: "Argelia",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antártida",
  AG: "Antigua y Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaiyán",
  BS: "Bahamas",
  BH: "Baréin",
  BD: "Bangladés",
  BB: "Barbados",
  BY: "Bielorrusia",
  BE: "Bélgica",
  BZ: "Belice",
  BJ: "Benín",
  BM: "Bermuda",
  BT: "Bután",
  BO: "Bolivia, Estado plurinacional",
  BQ: "Bonaire, San Eustaquio y Saba",
  BA: "Bosnia y Herzegovina",
  BW: "Botsuana",
  BV: "Isla Bouvet",
  BR: "Brasil",
  IO: "Territorio Británico del Océano Índico",
  BN: "Brunéi",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Camboya",
  CM: "Camerún",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Islas Caimán",
  CF: "República Centroafricana",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Islas de Navidad",
  CC: "Islas Cocos (Keeling)",
  CO: "Colombia",
  KM: "Comoras",
  CG: "Congo",
  CD: "Congo, República Democrática",
  CK: "Islas Cook",
  CR: "Costa Rica",
  CI: "Costa de Marfil",
  HR: "Croacia",
  CW: "Curaçao",
  CY: "Chipre",
  CZ: "República Checa",
  DK: "Dinamarca",
  DJ: "Yibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Ecuador",
  EG: "Egipto",
  SV: "El Salvador",
  GQ: "Guinea Ecuatorial",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Etiopía",
  FK: "Islas Falkland (Malvinas)",
  FO: "Islas Feroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Francia",
  GF: "Guinea francesa",
  PF: "Polinesia francesa",
  TF: "Territorios Australes Franceses",
  GA: "Gabón",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Alemania",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecia",
  GL: "Groenlandia",
  GD: "Granada",
  GP: "Guadalupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bisáu",
  GY: "Guyana",
  HT: "Haití",
  HM: "Islas Heard y McDonald",
  VA: "Santa Sede (Ciudad del Vaticano)",
  HK: "Hong Kong",
  HN: "Honduras",
  HU: "Hungría",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IQ: "Irak",
  IE: "Irlanda",
  IM: "Isla de Man",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japón",
  JE: "Jersey",
  JO: "Jordania",
  KZ: "Kazajistán",
  KE: "Kenia",
  KI: "Kiribati",
  KR: "Corea, República",
  KW: "Kuwait",
  KG: "Kirguistán",
  LA: "República Democrática Popular Lao",
  LV: "Letonia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburgo",
  MO: "Macao",
  MK: "Macedonia, Antigua República Yugoslava",
  MG: "Madagascar",
  MW: "Malaui",
  MY: "Malasia",
  MV: "Maldivas",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinica",
  MR: "Mauritania",
  MU: "Mauricio",
  YT: "Mayotte",
  MX: "México",
  MD: "Moldavia, República",
  MC: "Mónaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marruecos",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Países Bajos",
  NC: "Nueva Caledonia",
  NZ: "Nueva Zelanda",
  NI: "Nicaragua",
  NE: "Níger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Isla Norfolk",
  NO: "Noruega",
  OM: "Omán",
  PK: "Pakistán",
  PS: "Palestina",
  PA: "Panamá",
  PG: "Papúa Nueva Guinea",
  PY: "Paraguay",
  PE: "Perú",
  PH: "Filipinas",
  PN: "Pitcairn",
  PL: "Polonia",
  PT: "Portugal",
  QA: "Qatar",
  RE: "Reunión",
  RO: "Rumania",
  RU: "Federación Rusa",
  RW: "Ruanda",
  BL: "San Bartolomé",
  SH: "Santa Elena, Ascensión y Tristán de Acuña",
  KN: "San Cristóbal y Nieves",
  LC: "Santa Lucía",
  MF: "San Martín",
  PM: "San Pedro y Miquelón",
  VC: "San Vicente y las Granadinas",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Santo Tomé y Príncipe",
  SA: "Arabia Saudita",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leona",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Eslovaquia",
  SI: "Eslovenia",
  SB: "Islas Salomón",
  SO: "Somalia",
  ZA: "Sudáfrica",
  GS: "Islas Georgias del Sur y Sandwich del Sur",
  SS: "Sudán del Sur",
  ES: "España",
  LK: "Sri Lanka",
  SR: "Surinam",
  SJ: "Svalbard y Jan Mayen",
  SZ: "Esuatini",
  SE: "Suecia",
  CH: "Suiza",
  TW: "Taiwán",
  TJ: "Tayikistán",
  TZ: "Tanzania, República Unida",
  TH: "Tailandia",
  TL: "Timor Oriental",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad y Tobago",
  TN: "Túnez",
  TR: "Turquía",
  TM: "Turkmenistán",
  TC: "Islas Turcas y Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ucrania",
  AE: "Emiratos Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  VU: "Vanuatu",
  VE: "Venezuela, República Bolivariana",
  VN: "Vietnam",
  VG: "Islas Vírgenes Británicas",
  WF: "Wallis y Futuna",
  EH: "Sahara Occidental",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabue",
};
var states$d = {
  AU: {
    ACT: "Territorio de la Capital Australiana",
    NSW: "Nueva Gales del Sur",
    NT: "Territorio del Norte",
    QLD: "Queensland",
    SA: "Australia del Sur",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Australia del Oeste",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahía",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Río de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "Columbia Británica",
    MB: "Manitoba",
    NB: "Nuevo Brunswick",
    NL: "Terranova y Labrador",
    NT: "Territorios del Noroeste",
    NS: "Nueva Escocia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Isla del Príncipe Eduardo",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Territorio del Yukón",
  },
  CN: {
    11: "Pekín",
    12: "Tianjín",
    13: "Hebei",
    14: "Shanxi",
    15: "Nei Mongol",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghái",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwán",
    91: "Hong Kong",
    92: "Macao",
  },
  IN: {
    AN: "Islas Andamán y Nicobar",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra y Nágar Havelí",
    DD: "Damán y Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu y Cachemira",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "Bengala Occidental",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublín",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bérgamo",
    BI: "Biella",
    BO: "Bolonia",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotona",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Florencia",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Génova",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa y Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milán",
    MO: "Módena",
    MB: "Monza y Brianza",
    NA: "Nápoles",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro y Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rímini",
    RM: "Roma",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Siracusa",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Turín",
    UD: "Údine",
    VA: "Varese",
    VE: "Venecia",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Distrito Federal",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Estado de México",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawái",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Luisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Míchigan",
    MN: "Minnesota",
    MS: "Misisipi",
    MO: "Misuri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "Nuevo Hampshire",
    NJ: "Nueva Jersey",
    NM: "Nuevo México",
    NY: "Nueva York",
    NC: "Carolina del Norte",
    ND: "Dakota del Norte",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregón",
    PA: "Pensilvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "Carolina del Sur",
    SD: "Dakota del Sur",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "Virginia Occidental",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var esMX = {
  status: status$d,
  progress: progress$d,
  fields: fields$d,
  buttons: buttons$d,
  errors: errors$d,
  countries: countries$d,
  states: states$d,
};

var status$c = {
  loading: "Ladataan...",
};
var progress$c = {
  steps: "Vaihe %{currentStepNumber}/%{totalSteps}",
};
var fields$c = {
  email: "Sähköposti",
  country: "Maa/Alue",
  state: "Osavaltio/provinssi",
  first_name: "Etunimi",
  last_name: "Sukunimi",
  company_name: "Yrityksen nimi",
  role: "Roolin nimi",
  relationship: "Suhde Salesforceen",
  required: "(pakollinen)",
  select_placeholder: "Valitse vaihtoehto",
};
var buttons$c = {
  close: "Sulje",
  cancel: "Peruuta",
  save: "Tallenna",
  next: "Seuraava",
  continue: "Jatka",
};
var errors$c = {
  something_went_wrong: "Jokin meni vikaan, yritä uudelleen",
  fill_required_fields: "Täytä pakolliset kentät ennen lähettämistä.",
};
var countries$c = {
  AF: "Afganistan",
  AX: "Ahvenanmaa",
  AL: "Albania",
  DZ: "Algeria",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua ja Barbuda",
  AR: "Argentiina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Itävalta",
  AZ: "Azerbaidžan",
  BS: "Bahama",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Valko-Venäjä",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivian monikansallinen valtio",
  BQ: "Bonaire, Sint Eustatius ja Saba",
  BA: "Bosnia ja Hertsegovina",
  BW: "Botswana",
  BV: "Bouvet’nsaari",
  BR: "Brasilia",
  IO: "Brittiläinen Intian valtameren alue",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KY: "Caymansaaret",
  CF: "Keski-Afrikan tasavalta",
  TD: "Tšad",
  CL: "Chile",
  CN: "Kiina",
  CX: "Joulusaari",
  CC: "Kookossaaret",
  CO: "Kolumbia",
  KM: "Komorit",
  CG: "Kongo",
  CD: "Kongon demokraattinen tasavalta",
  CK: "Cookinsaaret",
  CR: "Costa Rica",
  CI: "Norsunluurannikko",
  HR: "Kroatia",
  CW: "Curacao",
  CY: "Kypros",
  CZ: "Tšekin tasavalta",
  DK: "Tanska",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikaaninen tasavalta",
  EC: "Ecuador",
  EG: "Egypti",
  SV: "El Salvador",
  GQ: "Päiväntasaajan Guinea",
  ER: "Eritrea",
  EE: "Viro",
  ET: "Etiopia",
  FK: "Falklandinsaaret (Malvinassaaret)",
  FO: "Färsaaret",
  FJ: "Fidži",
  FI: "Suomi",
  FR: "Ranska",
  GF: "Ranskan Guayana",
  PF: "Ranskan Polynesia",
  TF: "Ranskan eteläiset ja antarktiset alueet",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Saksa",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Kreikka",
  GL: "Grönlanti",
  GD: "Grenada",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard ja MacDonaldinsaaret",
  VA: "Pyhä istuin (Vatikaanivaltio)",
  HK: "Hongkong",
  HN: "Honduras",
  HU: "Unkari",
  IS: "Islanti",
  IN: "Intia",
  ID: "Indonesia",
  IQ: "Irak",
  IE: "Irlanti",
  IM: "Mansaari",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaika",
  JP: "Japani",
  JE: "Jersey",
  JO: "Jordania",
  KZ: "Kazakstan",
  KE: "Kenia",
  KI: "Kiribati",
  KR: "Korean tasavalta",
  KW: "Kuwait",
  KG: "Kirgisia",
  LA: "Laosin demokraattinen kansantasavalta",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Liettua",
  LU: "Luxemburg",
  MO: "Macao",
  MK: "Entinen Jugoslavian tasavalta Makedonia",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malesia",
  MV: "Malediivit",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Meksiko",
  MD: "Moldovan tasavalta",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Alankomaat",
  NC: "Uusi-Kaledonia",
  NZ: "Uusi-Seelanti",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkinsaari",
  NO: "Norja",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestiina",
  PA: "Panama",
  PG: "Papua-Uusi-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippiinit",
  PN: "Pitcairn",
  PL: "Puola",
  PT: "Portugali",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Venäjän federaatio",
  RW: "Ruanda",
  BL: "Saint-Barthélemy",
  SH: "Saint Helena, Ascension ja Tristan da Cunha",
  KN: "Saint Kitts ja Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (ranskalainen osa)",
  PM: "Saint Pierre ja Miquelon",
  VC: "Saint Vincent ja Grenadiinit",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé ja Príncipe",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychellit",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (hollantilainen osa)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Salomonsaaret",
  SO: "Somalia",
  ZA: "Etelä-Afrikka",
  GS: "Etelä-Georgia ja Eteläiset Sandwichsaaret",
  SS: "Etelä-Sudan",
  ES: "Espanja",
  LK: "Sri Lanka",
  SR: "Suriname",
  SJ: "Svalbard ja Jan Mayen",
  SZ: "Swazimaa",
  SE: "Ruotsi",
  CH: "Sveitsi",
  TW: "Taiwan",
  TJ: "Tadžikistan",
  TZ: "Tansanian yhdistynyt tasavalta",
  TH: "Thaimaa",
  TL: "Itä-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad ja Tobago",
  TN: "Tunisia",
  TR: "Turkki",
  TM: "Turkmenistan",
  TC: "Turks- ja Caisossaaret",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Yhdistyneet arabiemiirikunnat",
  GB: "Yhdistynyt kuningaskunta",
  US: "Yhdysvallat",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuelan bolivariaaninen tasavalta",
  VN: "Vietnam",
  VG: "Brittiläiset Neitsytsaaret",
  WF: "Wallis ja Futuna",
  EH: "Länsi-Sahara",
  YE: "Jemen",
  ZM: "Sambia",
  ZW: "Zimbabwe",
};
var states$c = {
  AU: {
    ACT: "Australian pääkaupunkiterritorio",
    NSW: "Uusi Etelä-Wales",
    NT: "Pohjoisterritorio",
    QLD: "Queensland",
    SA: "Etelä-Australia",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Länsi-Australia",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "Brittiläinen Kolumbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland ja Labrador",
    NT: "Luoteisterritoriot",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prinssi Edwardin saari",
    QC: "Québec",
    SK: "Saskatchewan",
    YT: "Yukonin territorio",
  },
  CN: {
    11: "Beijing",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Sisä-Mongolia",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hongkong",
    92: "Macao",
  },
  IN: {
    AN: "Andamaanit ja Nikobaarit",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra ja Nagar Haveli",
    DD: "Daman ja Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu ja Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "Länsi-Bengali",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Firenze",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genova",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa ja Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milano",
    MO: "Modena",
    MB: "Monza ja Brianza",
    NA: "Napoli",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padova",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro ja Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Rooma",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Syracuse",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Torino",
    UD: "Udine",
    VA: "Varese",
    VE: "Venetsia",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Federal District",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Mexico State",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "Kalifornia",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Havaiji",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "Pohjois-Carolina",
    ND: "Pohjois-Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "Etelä-Carolina",
    SD: "Etelä-Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var fi = {
  status: status$c,
  progress: progress$c,
  fields: fields$c,
  buttons: buttons$c,
  errors: errors$c,
  countries: countries$c,
  states: states$c,
};

var status$b = {
  loading: "Chargement…",
};
var progress$b = {
  steps: "Étape %{currentStepNumber} sur %{totalSteps}",
};
var fields$b = {
  email: "Adresse e-mail",
  country: "Pays/Région",
  state: "Région/Province",
  first_name: "Prénom",
  last_name: "Nom",
  company_name: "Nom de la société",
  role: "Nom de rôle",
  relationship: "Lien avec Salesforce",
  required: "(requis)",
  select_placeholder: "Sélectionner une option",
};
var buttons$b = {
  close: "Fermer",
  cancel: "Annuler",
  save: "Enregistrer",
  next: "Suivant",
  continue: "Continuer",
};
var errors$b = {
  something_went_wrong: "Une erreur s'est produite, veuillez réessayer",
  fill_required_fields:
    "Veuillez remplir les champs obligatoires avant de soumettre le formulaire.",
};
var countries$b = {
  AF: "Afghanistan",
  AX: "Îles Aland",
  AL: "Albanie",
  DZ: "Algérie",
  AD: "Andorre",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctique",
  AG: "Antigua et Barbuda",
  AR: "Argentine",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Australie",
  AT: "Autriche",
  AZ: "Azerbaïdjan",
  BS: "Bahamas",
  BH: "Bahreïn",
  BD: "Bangladesh",
  BB: "Barbade",
  BY: "Biélorussie",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermudes",
  BT: "Bhoutan",
  BO: "Bolivie, État plurinational",
  BQ: "Bonaire, Saint-Eustache et Saba",
  BA: "Bosnie-Herzégovine",
  BW: "Bostwana",
  BV: "Île Bouvet",
  BR: "Brésil",
  IO: "Territoire britannique de l'océan Indien",
  BN: "Brunéi Darussalam",
  BG: "Bulgarie",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodge",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Cap-Vert",
  KY: "Îles Caïmans",
  CF: "République centrafricaine",
  TD: "Tchad",
  CL: "Chili",
  CN: "Chine",
  CX: "Île Christmas",
  CC: "Îles Cocos (Keeling)",
  CO: "Colombie",
  KM: "Comores",
  CG: "Congo",
  CD: "Congo, République démocratique",
  CK: "Îles Cook",
  CR: "Costa Rica",
  CI: "Côte d'Ivoire",
  HR: "Croatie",
  CW: "Curaçao",
  CY: "Chypre",
  CZ: "République tchèque",
  DK: "Danemark",
  DJ: "Djibouti",
  DM: "Dominique",
  DO: "République dominicaine",
  EC: "Équateur",
  EG: "Égypte",
  SV: "Salvador",
  GQ: "Guinée équatoriale",
  ER: "Érythrée",
  EE: "Estonie",
  ET: "Éthiopie",
  FK: "Îles Malouines",
  FO: "Îles Féroé",
  FJ: "Fidji",
  FI: "Finlande",
  FR: "France",
  GF: "Guyane française",
  PF: "Polynésie française",
  TF: "Terres australes françaises",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Géorgie",
  DE: "Allemagne",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grèce",
  GL: "Groenland",
  GD: "Grenade",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernesey",
  GN: "Guinée",
  GW: "Guinée-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Îles Heard-et-MacDonald",
  VA: "Saint-Siège (État de la Cité du Vatican)",
  HK: "Hong Kong",
  HN: "Honduras",
  HU: "Hongrie",
  IS: "Islande",
  IN: "Inde",
  ID: "Indonésie",
  IQ: "Iraq",
  IE: "Irlande",
  IM: "Île de Man",
  IL: "Israël",
  IT: "Italie",
  JM: "Jamaïque",
  JP: "Japon",
  JE: "Jersey",
  JO: "Jordanie",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Corée du Sud",
  KW: "Koweït",
  KG: "Kyrgyzstan",
  LA: "Laos, République démocratique populaire lao",
  LV: "Lettonie",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Libye",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macédoine du Nord, Ancienne république yougoslave de Macédoine",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaisie",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malte",
  MQ: "Martinique",
  MR: "Mauritanie",
  MU: "Maurice",
  YT: "Mayotte",
  MX: "Mexique",
  MD: "Moldavie, République",
  MC: "Monaco",
  MN: "Mongolie",
  ME: "Monténégro",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambique",
  MM: "Birmanie",
  NA: "Namibie",
  NR: "Nauru",
  NP: "Népal",
  NL: "Pays-Bas",
  NC: "Nouvelle Calédonie",
  NZ: "Nouvelle-Zélande",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niué",
  NF: "Île Norfolk",
  NO: "Norvège",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papouasie-Nouvelle-Guinée",
  PY: "Paraguay",
  PE: "Pérou",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Pologne",
  PT: "Portugal",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roumanie",
  RU: "Fédération de Russie",
  RW: "Rwanda",
  BL: "Saint-Barthélemy",
  SH: "Sainte-Hélène, Ascension et Tristan da Cunha",
  KN: "Saint-Christophe-et-Niévès",
  LC: "Sainte-Lucie",
  MF: "Saint-Martin (partie française)",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "Saint-Vincent-et-les-Grenadines",
  WS: "Samoa",
  SM: "Saint-Marin",
  ST: "Sao Tomé-et-Principe",
  SA: "Arabie Saoudite",
  SN: "Sénégal",
  RS: "Serbie",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapour",
  SX: "Saint-Martin (partie néerlandaise)",
  SK: "Slovaquie",
  SI: "Slovénie",
  SB: "Îles Salomon",
  SO: "Somalie",
  ZA: "Afrique du Sud",
  GS: "Géorgie du Sud et les Îles Sandwich du Sud",
  SS: "Soudan du Sud",
  ES: "Espagne",
  LK: "Sri Lanka",
  SR: "Suriname",
  SJ: "Svalbard et Jan Mayen",
  SZ: "Swaziland",
  SE: "Suède",
  CH: "Suisse",
  TW: "Taïwan",
  TJ: "Tadjikistan",
  TZ: "Tanzanie, République unie",
  TH: "Thaïlande",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinité-et-Tobago",
  TN: "Tunisie",
  TR: "Turquie",
  TM: "Turkménistan",
  TC: "Îles Turques-et-Caïques",
  TV: "Tuvalu",
  UG: "Ouganda",
  UA: "Ukraine",
  AE: "Émirats arabes unis",
  GB: "Royaume-Uni",
  US: "États-Unis",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VU: "Vanuatu",
  VE: "Venezuela, République bolivarienne",
  VN: "Vietnam",
  VG: "Îles Vierges britanniques",
  WF: "Wallis-et-Futuna",
  EH: "Sahara occidental",
  YE: "Yémen",
  ZM: "Zambie",
  ZW: "Zimbabwe",
};
var states$b = {
  AU: {
    ACT: "Territoire de la capitale australienne",
    NSW: "Nouvelle-Galles du Sud",
    NT: "Territoire nord",
    QLD: "Queensland",
    SA: "Sud de l'Australie",
    TAS: "Tasmanie",
    VIC: "Victoria",
    WA: "Ouest de l'Australie",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazone",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "Colombie-Britannique",
    MB: "Manitoba",
    NB: "Nouveau-Brunswick",
    NL: "Terre-Neuve-et-Labrador",
    NT: "Territoires du Nord-Ouest",
    NS: "Nouvelle-Écosse",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Île-du-Prince-Édouard",
    QC: "Québec",
    SK: "Saskatchewan",
    YT: "Territoires du Yukon",
  },
  CN: {
    11: "Pékin",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Mongolie-Intérieure",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Région autonome du Tibet",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taïwan",
    91: "Hong Kong",
    92: "Macao",
  },
  IN: {
    AN: "Îles Andaman-et-Nicobar",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra et Nagar Haveli",
    DD: "Daman et Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu-et-Cachemire",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Pondichéry",
    PB: "Penjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Télangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "Bengale-Occidental",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigente",
    AL: "Alexandrie",
    AN: "Ancône",
    AO: "Aoste",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Bénévent",
    BG: "Bergame",
    BI: "Biella",
    BO: "Bologne",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserte",
    CT: "Catane",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Côme",
    CS: "Cosenza",
    CR: "Crémone",
    KR: "Crotone",
    CN: "Coni",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrare",
    FI: "Florence",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Gênes",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livourne",
    LO: "Lodi",
    LU: "Lucques",
    MC: "Macerata",
    MN: "Mantoue",
    MS: "Massa-Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messine",
    MI: "Milan",
    MO: "Modène",
    MB: "Monza et Brianza",
    NA: "Naples",
    NO: "Novare",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padoue",
    PA: "Palerme",
    PR: "Parme",
    PV: "Pavie",
    PG: "Pérouse",
    PU: "Pesaro et Urbino",
    PE: "Pescara",
    PC: "Plaisance",
    PI: "Pise",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Raguse",
    RA: "Ravenne",
    RC: "Reggio de Calabre",
    RE: "Reggio d'Émilie",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Rome",
    RO: "Rovigo",
    SA: "Salerne",
    SS: "Sassari",
    SV: "Savone",
    SI: "Sienne",
    SO: "Sondrio",
    SR: "Syracuse",
    TA: "Tarente",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trente",
    TV: "Trévise",
    TS: "Trieste",
    TO: "Turin",
    UD: "Udine",
    VA: "Varèse",
    VE: "Venise",
    VB: "Verbano-Cusio-Ossola",
    VC: "Verceil",
    VR: "Vérone",
    VV: "Vibo Valentia",
    VI: "Vicence",
    VT: "Viterbe",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Basse-Californie",
    BS: "Basse-Californie du Sud",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "District fédéral",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "État du Mexique",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "Californie",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District de Columbia",
    FL: "Floride",
    GA: "Géorgie",
    HI: "Hawaï",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiane",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "Nouveau Mexique",
    NY: "New York",
    NC: "Caroline du Nord",
    ND: "Dakota du Nord",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvanie",
    PR: "Porto-Rico",
    RI: "Rhode Island",
    SC: "Caroline du Sud",
    SD: "Dakota du Sud",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginie",
    WA: "Washington",
    WV: "Virginie de l'Ouest",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var fr = {
  status: status$b,
  progress: progress$b,
  fields: fields$b,
  buttons: buttons$b,
  errors: errors$b,
  countries: countries$b,
  states: states$b,
};

var status$a = {
  loading: "Caricamento in corso...",
};
var progress$a = {
  steps: "Fase %{currentStepNumber} di %{totalSteps}",
};
var fields$a = {
  email: "Email",
  country: "Paese/Area geografica",
  state: "Stato/Provincia",
  first_name: "Nome",
  last_name: "Cognome",
  company_name: "Nome società",
  role: "Nome ruolo",
  relationship: "Relazione con Salesforce",
  required: "(obbligatorio)",
  select_placeholder: "Seleziona un'opzione",
};
var buttons$a = {
  close: "Chiudi",
  cancel: "Annulla",
  save: "Salva",
  next: "Avanti",
  continue: "Continua",
};
var errors$a = {
  something_went_wrong: "Si è verificato un errore. Riprova",
  fill_required_fields: "Compila i campi obbligatori prima dell'invio.",
};
var countries$a = {
  AF: "Afghanistan",
  AX: "Åland, Isole",
  AL: "Albania",
  DZ: "Algeria",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antartide",
  AG: "Antigua e Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaigian",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bielorussia",
  BE: "Belgio",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia, Stato plurinazionale di",
  BQ: "Bonaire, Sint Eustatius e Saba",
  BA: "Bosnia-Erzegovina",
  BW: "Botswana",
  BV: "Bouvet, Isola di",
  BR: "Brasile",
  IO: "Territorio britannico dell’Oceano Indiano",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambogia",
  CM: "Camerun",
  CA: "Canada",
  CV: "Cabo Verde",
  KY: "Cayman, Isole",
  CF: "Repubblica centrafricana",
  TD: "Ciad",
  CL: "Cile",
  CN: "Cina",
  CX: "Christmas, Isola",
  CC: "Cocos (Keeling), Isole",
  CO: "Colombia",
  KM: "Comore",
  CG: "Congo",
  CD: "Congo, Repubblica democratica del",
  CK: "Cook, Isole",
  CR: "Costa Rica",
  CI: "Costa d'Avorio",
  HR: "Croazia",
  CW: "Curaçao",
  CY: "Cipro",
  CZ: "Repubblica ceca",
  DK: "Danimarca",
  DJ: "Gibuti",
  DM: "Dominica",
  DO: "Repubblica dominicana",
  EC: "Ecuador",
  EG: "Egitto",
  SV: "El Salvador",
  GQ: "Guinea equatoriale",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Etiopia",
  FK: "Falkland, Isole (Malvine)",
  FO: "Faroe, Isole",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Francia",
  GF: "Guyana francese",
  PF: "Polinesia francese",
  TF: "Terre australi francesi",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germania",
  GH: "Ghana",
  GI: "Gibilterra",
  GR: "Grecia",
  GL: "Groenlandia",
  GD: "Grenada",
  GP: "Guadalupa",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard e McDonald, Isole",
  VA: "Santa Sede (Stato della Città del Vaticano)",
  HK: "Hong Kong",
  HN: "Honduras",
  HU: "Ungheria",
  IS: "Islanda",
  IN: "India",
  ID: "Indonesia",
  IQ: "Iraq",
  IE: "Irlanda",
  IM: "Man, Isola di",
  IL: "Israele",
  IT: "Italia",
  JM: "Giamaica",
  JP: "Giappone",
  JE: "Jersey",
  JO: "Giordania",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Corea, Repubblica di",
  KW: "Kuwait",
  KG: "Kirghizistan",
  LA: "Laos, Repubblica democratica popolare del",
  LV: "Lettonia",
  LB: "Libano",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Lussemburgo",
  MO: "Macao",
  MK: "Macedonia, Ex Repubblica jugoslava di",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldive",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinica",
  MR: "Mauritania",
  MU: "Maurizio",
  YT: "Mayotte",
  MX: "Messico",
  MD: "Moldova, Repubblica di",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marocco",
  MZ: "Mozambico",
  MM: "Myanmar/Birmania",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Paesi Bassi",
  NC: "Nuova Caledonia",
  NZ: "Nuova Zelanda",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk, Isola",
  NO: "Norvegia",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papua Nuova Guinea",
  PY: "Paraguay",
  PE: "Perù",
  PH: "Filippine",
  PN: "Pitcairn",
  PL: "Polonia",
  PT: "Portogallo",
  QA: "Qatar",
  RE: "Riunione",
  RO: "Romania",
  RU: "Federazione russa",
  RW: "Ruanda",
  BL: "Saint-Barthélemy",
  SH: "Sant’Elena, Ascensione e Tristan da Cunha",
  KN: "Saint Kitts e Nevis",
  LC: "Santa Lucia",
  MF: "Saint-Martin (parte francese)",
  PM: "Saint Pierre e Miquelon",
  VC: "Saint Vincent e Grenadine",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tomé e Principe",
  SA: "Arabia Saudita",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (parte olandese)",
  SK: "Slovacchia",
  SI: "Slovenia",
  SB: "Salomone, Isole",
  SO: "Somalia",
  ZA: "Sud Africa",
  GS: "Georgia del sud e Isole Sandwich australi",
  SS: "Sud Sudan",
  ES: "Spagna",
  LK: "Sri Lanka",
  SR: "Suriname",
  SJ: "Svalbard e Jan Mayen",
  SZ: "Swaziland",
  SE: "Svezia",
  CH: "Svizzera",
  TW: "Taiwan",
  TJ: "Tagikistan",
  TZ: "Tanzania, Repubblica unita della",
  TH: "Thailandia",
  TL: "Timor Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad e Tobago",
  TN: "Tunisia",
  TR: "Turchia",
  TM: "Turkmenistan",
  TC: "Turks e Caicos, Isole",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ucraina",
  AE: "Emirati arabi uniti",
  GB: "Regno Unito",
  US: "Stati Uniti",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela, Repubblica bolivariana del",
  VN: "Vietnam",
  VG: "Isole Vergini britanniche",
  WF: "Wallis e Futuna",
  EH: "Sahara occidentale",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
var states$a = {
  AU: {
    ACT: "Australian Capital Territory",
    NSW: "New South Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "South Australia",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Western Australia",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distretto Federale",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "San Paolo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Terranova e Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Territorio dello Yukon",
  },
  CN: {
    11: "Pechino",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Mongolia Interna",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Tibet",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hong Kong",
    92: "Macao",
  },
  IN: {
    AN: "Isole Andamane e Nicobare",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra e Nagar Haveli",
    DD: "Daman e Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu e Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Laccadive",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Pondicherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "West Bengal",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublino",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Firenze",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genova",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantova",
    MS: "Massa-Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milano",
    MO: "Modena",
    MB: "Monza e Brianza",
    NA: "Napoli",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padova",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro e Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Roma",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Siracusa",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Torino",
    UD: "Udine",
    VA: "Varese",
    VE: "Venezia",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Bassa California",
    BS: "Bassa California del Sud",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Distretto Federale",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Stato del Messico",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var it = {
  status: status$a,
  progress: progress$a,
  fields: fields$a,
  buttons: buttons$a,
  errors: errors$a,
  countries: countries$a,
  states: states$a,
};

var status$9 = {
  loading: "読み込んでいます...",
};
var progress$9 = {
  steps: "%{currentStepNumber}/%{totalSteps} ステップ",
};
var fields$9 = {
  email: "メール",
  country: "国/地域",
  state: "都道府県",
  first_name: "名",
  last_name: "姓",
  company_name: "会社名",
  role: "ロール名",
  relationship: "Salesforce との関係",
  required: "(必須)",
  select_placeholder: "オプションを選択",
};
var buttons$9 = {
  close: "閉じる",
  cancel: "キャンセル",
  save: "保存",
  next: "次へ",
  continue: "続行",
};
var errors$9 = {
  something_went_wrong: "問題が発生しました。もう一度お試しください。",
  fill_required_fields: "必須項目を入力してから送信してください。",
};
var countries$9 = {
  AF: "アフガニスタン",
  AX: "オーランド諸島",
  AL: "アルバニア",
  DZ: "アルジェリア",
  AD: "アンドラ",
  AO: "アンゴラ",
  AI: "アンギラ",
  AQ: "南極大陸",
  AG: "アンチグアバーブーダ",
  AR: "アルゼンチン",
  AM: "アルメニア",
  AW: "アルバ",
  AU: "オーストラリア",
  AT: "オーストリア",
  AZ: "アゼルバイジャン",
  BS: "バハマ",
  BH: "バーレーン",
  BD: "バングラデッシュ",
  BB: "バルバドス",
  BY: "ベラルーシ",
  BE: "ベルギー",
  BZ: "ベリーズ",
  BJ: "ベナン",
  BM: "バミューダ",
  BT: "ブータン",
  BO: "ボリビア多民族国",
  BQ: "ボネール島、シントユースタティウス島およびサバ島",
  BA: "ボスニア・ヘルツェゴビナ",
  BW: "ボツワナ",
  BV: "ブーヴェ島",
  BR: "ブラジル",
  IO: "英領インド洋植民地",
  BN: "ブルネイ・ダルサラーム国",
  BG: "ブルガリア",
  BF: "ブルキナファソ",
  BI: "ブルンジ",
  KH: "カンボジア",
  CM: "カメルーン",
  CA: "カナダ",
  CV: "カーボベルデ",
  KY: "ケイマン諸島",
  CF: "中央アフリカ共和国",
  TD: "チャド",
  CL: "チリ",
  CN: "中国",
  CX: "クリスマス島",
  CC: "ココス (キーリング) 諸島",
  CO: "コロンビア",
  KM: "コモロ",
  CG: "コンゴ",
  CD: "コンゴ民主共和国",
  CK: "クック諸島",
  CR: "コスタリカ",
  CI: "コートジボアール",
  HR: "クロアチア",
  CW: "キュラソー島",
  CY: "キプロス",
  CZ: "チェコ共和国",
  DK: "デンマーク",
  DJ: "ジブチ",
  DM: "ドミニカ",
  DO: "ドミニカ共和国",
  EC: "エクアドル",
  EG: "エジプト",
  SV: "エルサルバドル",
  GQ: "赤道ギニア",
  ER: "エリトリア",
  EE: "エストニア",
  ET: "エチオピア",
  FK: "フォークランド諸島 (マルビナス)",
  FO: "フェロー諸島",
  FJ: "フィジー",
  FI: "フィンランド",
  FR: "フランス",
  GF: "フランス領ギアナ",
  PF: "フランス領ポリネシア",
  TF: "フランス南方領土",
  GA: "ガボン",
  GM: "ガンビア",
  GE: "ジョージア",
  DE: "ドイツ",
  GH: "ガーナ",
  GI: "ジブラルタル",
  GR: "ギリシャ",
  GL: "グリーンランド",
  GD: "グレナダ",
  GP: "グアドループ",
  GT: "グアテマラ",
  GG: "ガーンジー島",
  GN: "ギニア",
  GW: "ギニアビサウ",
  GY: "ガイアナ",
  HT: "ハイチ",
  HM: "ハード島とマクドナルド諸島",
  VA: "ローマ教皇庁 (バチカン市国)",
  HK: "香港",
  HN: "ホンジュラス",
  HU: "ハンガリー",
  IS: "アイスランド",
  IN: "インド",
  ID: "インドネシア",
  IQ: "イラク",
  IE: "アイルランド",
  IM: "マン島",
  IL: "イスラエル",
  IT: "イタリア",
  JM: "ジャマイカ",
  JP: "日本",
  JE: "ジャージー",
  JO: "ヨルダン",
  KZ: "カザフスタン",
  KE: "ケニア",
  KI: "キリバス",
  KR: "大韓民国",
  KW: "クウェート",
  KG: "キルギスタン",
  LA: "ラオス人民民主共和国",
  LV: "ラトビア",
  LB: "レバノン",
  LS: "レソト",
  LR: "リベリア",
  LY: "リビア",
  LI: "リヒテンシュタイン",
  LT: "リトアニア",
  LU: "ルクセンブルグ",
  MO: "マカオ",
  MK: "マケドニア旧ユーゴスラビア共和国",
  MG: "マダガスカル",
  MW: "マラウイ",
  MY: "マレーシア",
  MV: "モルジブ",
  ML: "マリ",
  MT: "マルタ",
  MQ: "マルティニーク島",
  MR: "モーリタニア",
  MU: "モーリシャス",
  YT: "マヨット島",
  MX: "メキシコ",
  MD: "モルドバ共和国",
  MC: "モナコ",
  MN: "モンゴル",
  ME: "モンテネグロ",
  MS: "モントセラト",
  MA: "モロッコ",
  MZ: "モザンビーク",
  MM: "ミャンマー",
  NA: "ナミビア",
  NR: "ナウル",
  NP: "ネパール",
  NL: "オランダ",
  NC: "ニューカレドニア",
  NZ: "ニュージーランド",
  NI: "ニカラグア",
  NE: "ニジェール",
  NG: "ナイジェリア",
  NU: "ニウエ",
  NF: "ノーフォーク島",
  NO: "ノルウェー",
  OM: "オマーン",
  PK: "パキスタン",
  PS: "パレスチナ",
  PA: "パナマ",
  PG: "パプアニューギニア",
  PY: "パラグアイ",
  PE: "ペルー",
  PH: "フィリピン",
  PN: "ピトケアン",
  PL: "ポーランド",
  PT: "ポルトガル",
  QA: "カタール",
  RE: "レユニオン",
  RO: "ルーマニア",
  RU: "ロシア連邦",
  RW: "ルワンダ",
  BL: "サン・バルテルミー島",
  SH: "セントヘレナ・アセンションおよびトリスタンダクーニャ",
  KN: "セントクリストファー・ネイビス",
  LC: "セントルシア",
  MF: "サン・マルタン (フランス領)",
  PM: "サンピエール島・ミクロン島",
  VC: "セントビンセントおよびグレナディーン諸島",
  WS: "サモア",
  SM: "サンマリノ",
  ST: "サントメ・プリンシペ",
  SA: "サウジアラビア",
  SN: "セネガル",
  RS: "セルビア",
  SC: "セイシェル",
  SL: "シエラレオネ",
  SG: "シンガポール",
  SX: "シントマールテン (オランダ領)",
  SK: "スロバキア",
  SI: "スロベニア",
  SB: "ソロモン諸島",
  SO: "ソマリア",
  ZA: "南アフリカ",
  GS: "サウスジョージア・サウスサンドウィッチ諸島",
  SS: "南スーダン",
  ES: "スペイン",
  LK: "スリランカ",
  SR: "スリナム",
  SJ: "スバールバル諸島・ヤンマイエン島",
  SZ: "スワジランド",
  SE: "スウェーデン",
  CH: "スイス",
  TW: "台湾",
  TJ: "タジキスタン",
  TZ: "タンザニア連合共和国",
  TH: "タイ",
  TL: "東ティモール",
  TG: "トーゴ",
  TK: "トケラウ",
  TO: "トンガ",
  TT: "トリニダード・トバゴ",
  TN: "チュニジア",
  TR: "トルコ",
  TM: "トルクメニスタン",
  TC: "タークス・カイコス諸島",
  TV: "ツバル",
  UG: "ウガンダ",
  UA: "ウクライナ",
  AE: "アラブ首長国連邦",
  GB: "英国",
  US: "米国",
  UY: "ウルグアイ",
  UZ: "ウズベキスタン",
  VU: "バヌアツ",
  VE: "ベネズエラ・ボリバル共和国",
  VN: "ベトナム",
  VG: "英領バージン諸島",
  WF: "ウォリス・フトゥーナ",
  EH: "西サハラ",
  YE: "イエメン",
  ZM: "ザンビア",
  ZW: "ジンバブエ",
};
var states$9 = {
  AU: {
    ACT: "オーストラリア首都特別地域",
    NSW: "ニューサウスウェールズ",
    NT: "ノーザンテリトリー",
    QLD: "クイーンズランド",
    SA: "サウスオーストラリア",
    TAS: "タスマニア",
    VIC: "ビクトリア",
    WA: "ウエスタンオーストラリア",
  },
  BR: {
    AC: "アクレ",
    AL: "アラゴアス",
    AP: "アマパー",
    AM: "アマゾナス",
    BA: "バイーア",
    CE: "セアラー",
    DF: "連邦特別区",
    ES: "エスピリトサント",
    GO: "ゴイアス",
    MA: "マラニョン",
    MT: "マトグロッソ",
    MS: "マトグロッソドスル",
    MG: "ミナスジェライス",
    PA: "パラー",
    PB: "パライーバ",
    PR: "パラナ",
    PE: "ペルナンブーコ",
    PI: "ピアウイ",
    RJ: "リオデジャネイロ",
    RN: "リオグランデドノルテ",
    RS: "リオグランデドスル",
    RO: "ロンドーニア",
    RR: "ロライマ",
    SC: "サンタカタリナ島",
    SP: "サンパウロ",
    SE: "セルジペ",
    TO: "トカンチンス",
  },
  CA: {
    AB: "アルバータ",
    BC: "ブリティッシュコロンビア",
    MB: "マニトバ",
    NB: "ニューブランズウィック",
    NL: "ニューファウンドランドラブラドル",
    NT: "ノースウェストテリトリーズ",
    NS: "ノバスコシア",
    NU: "ヌナブート",
    ON: "オンタリオ",
    PE: "プリンスエドワードアイランド",
    QC: "ケベック",
    SK: "サスカチェワン",
    YT: "ユーコン准州",
  },
  CN: {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内モンゴル",
    21: "遼寧",
    22: "吉林省",
    23: "黒竜江",
    31: "上海",
    32: "江蘇省",
    33: "浙江",
    34: "安徽",
    35: "苻堅",
    36: "江西",
    37: "山東",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "広東",
    45: "広西",
    46: "海南",
    50: "崇慶",
    51: "四川",
    52: "貴州",
    53: "雲南",
    54: "西蔵",
    61: "陜西",
    62: "甘粛",
    63: "青海",
    64: "寧夏",
    65: "新絳",
    71: "台湾",
    91: "香港",
    92: "マカオ",
  },
  IN: {
    AN: "アンダマンニコバル諸島",
    AP: "アンドラプラデシュ",
    AR: "アルナチャルプラデシュ",
    AS: "アッサム",
    BR: "ビハール",
    CH: "チャンディガル",
    CT: "チャッティースガル",
    DN: "ダードラーおよびナガルハヴェーリー",
    DD: "ダマンディーウ連邦直轄領",
    DL: "デリー",
    GA: "ゴア",
    GJ: "グジャラート",
    HR: "ハリアナ",
    HP: "ヒマチャルプラデシュ",
    JK: "ジャムカシミール",
    JH: "ジャールカンド",
    KA: "カルナータカ",
    KL: "ケララ",
    LD: "ラクシャディープ諸島",
    MP: "マディヤプラデシュ",
    MH: "マハラシュトラ",
    MN: "マニプル",
    ML: "メガラーヤ",
    MZ: "ミゾラム",
    NL: "ナガランド",
    OR: "オディシャ",
    PY: "ポンディシェリ",
    PB: "パンジャブ",
    RJ: "ラージャスタン",
    SK: "シッキム",
    TN: "タミルナドゥ",
    TG: "テランガーナ",
    TR: "トリプラ",
    UT: "ウッタラーカンド",
    UP: "ウッタルプラデシュ",
    WB: "西ベンガル",
  },
  IE: {
    CW: "カーロウ",
    CN: "キャバン",
    CE: "クレア",
    CO: "コーク",
    DL: "ドニゴール",
    D: "ダブリン",
    G: "ゴールウェイ",
    KY: "ケリー",
    KE: "キルデア",
    KK: "キルケニー",
    LS: "リーシュ",
    LM: "リートリム",
    LK: "リメリック",
    LD: "ロングフォード",
    LH: "ラウス.",
    MO: "メイヨー",
    MH: "ミーズ",
    MN: "モナハン",
    OY: "オファリー",
    RN: "ロスコモン",
    SO: "スライゴー",
    TA: "ティペラリー",
    WD: "ウォーターフォード（",
    WH: "ウェストミーズ",
    WX: "ウェックスフォード",
    WW: "ウィックロー",
  },
  IT: {
    AG: "アグリジェント.",
    AL: "アレッサンドリア",
    AN: "アンコーナ",
    AO: "アオスタ",
    AR: "アレッツォ",
    AP: "アスコリピチェーノ",
    AT: "アスティ",
    AV: "アヴェリーノ",
    BA: "バーリ",
    BT: "バルレッタアンドリアトラーニ",
    BL: "ベルーノ",
    BN: "ベネヴェント",
    BG: "ベルガモ",
    BI: "ビエッラ",
    BO: "ボローニャ",
    BZ: "ボルツァーノ",
    BS: "ブレシア",
    BR: "ブリンディジ",
    CA: "カリアリ",
    CL: "カルタニッセッタ",
    CB: "カンポバッソ",
    CI: "カルボニーアイグレージアス",
    CE: "カゼルタ",
    CT: "カターニア",
    CZ: "カタンザーロ",
    CH: "キエーティ",
    CO: "コモ",
    CS: "コゼンツァ",
    CR: "クレモナ",
    KR: "クロトーネ",
    CN: "クーネオ",
    EN: "エンナ",
    FM: "フェルモ",
    FE: "フェラーラ",
    FI: "フィレンツェ",
    FG: "フォッジャ",
    FC: "フォルリチェゼーナ",
    FR: "フロジノーネ",
    GE: "ジェノバ",
    GO: "ゴリツィア",
    GR: "グロッセート",
    IM: "インペリア",
    IS: "イゼルニア",
    AQ: "ラクイラ",
    SP: "ラスペツィア",
    LT: "ラティーナ",
    LE: "レッチェ",
    LC: "レッコ",
    LI: "リボルノ",
    LO: "ローディ",
    LU: "ルッカ",
    MC: "マチェラータ",
    MN: "マントゥア",
    MS: "マッサカッラーラ",
    MT: "マテーラ",
    VS: "メディオカンピダーノ",
    ME: "メッシーナ",
    MI: "ミラノ",
    MO: "モデナ",
    MB: "モンツァエブリアンツァ",
    NA: "ナポリ",
    NO: "ノヴァーラ",
    NU: "ヌーオロ",
    OG: "オリアストラ",
    OT: "オルビアテンピオ",
    OR: "オリスターノ",
    PD: "パドヴァ",
    PA: "パレルモ",
    PR: "パルマ",
    PV: "パヴィーア",
    PG: "ペルージャ",
    PU: "ペーザロエウルビーノ",
    PE: "ペスカーラ",
    PC: "ピアチェンツァ",
    PI: "ピサ",
    PT: "ピストイア",
    PN: "ポルデノーネ",
    PZ: "ポテンザ",
    PO: "プラート",
    RG: "ラグーザ",
    RA: "ラベンナ",
    RC: "レッジョカラブリア",
    RE: "レッジョエミリア",
    RI: "リエティ",
    RN: "リミニ",
    RM: "ローマ",
    RO: "ロヴィーゴ",
    SA: "サレルノ",
    SS: "サッサリ",
    SV: "サヴォーナ",
    SI: "シエーナ",
    SO: "ソンドリオ",
    SR: "シラクサ",
    TA: "ターラント",
    TE: "テーラモ",
    TR: "テルニ",
    TP: "トラパニ",
    TN: "トレント",
    TV: "トレビス",
    TS: "トリエステ",
    TO: "トリノ",
    UD: "ウディネ",
    VA: "ヴァレーゼ",
    VE: "ベネチア",
    VB: "ヴェルバーノクジオオッソラ",
    VC: "ヴェルチェッリ",
    VR: "ヴェローナ",
    VV: "ヴィボ・ヴァレンツィア",
    VI: "ヴィチェンツァ",
    VT: "ヴィテルボ",
  },
  MX: {
    AG: "アグアスカリエンテス",
    BC: "バハカリフォルニア",
    BS: "バハカリフォルニアスル",
    CM: "カンペチェ",
    CS: "チアパス",
    CH: "チワワ",
    CO: "コアウイラ",
    CL: "コリマ",
    DG: "デュランゴ",
    DF: "メキシコシティ",
    GT: "グアナフアト",
    GR: "ゲレーロ",
    HG: "ヒダルゴ",
    JA: "ハリスコ",
    ME: "メキシコ州",
    MI: "ミチョアカン",
    MO: "モレロス",
    NA: "ナヤリット",
    NL: "ヌエボレオーネ",
    OA: "オアハカ",
    PB: "プエブラ",
    QE: "ケレタロ",
    QR: "キンタナロー",
    SL: "サンルイスポトシ",
    SI: "シナロア",
    SO: "ソノラ",
    TB: "タバスコ",
    TM: "タマウリパス",
    TL: "トラスカラ",
    VE: "ベラクルス",
    YU: "ユカタン",
    ZA: "サカテカス",
  },
  US: {
    AL: "アラバマ",
    AK: "アラスカ",
    AZ: "アリゾナ",
    AR: "アーカンソー",
    CA: "カリフォルニア",
    CO: "コロラド",
    CT: "コネティカット",
    DE: "デラウェア",
    DC: "コロンビア特別区",
    FL: "フロリダ",
    GA: "ジョージア",
    HI: "ハワイ",
    ID: "アイダホ",
    IL: "イリノイ",
    IN: "インディアナ",
    IA: "アイオワ",
    KS: "カンザス",
    KY: "ケンタッキー",
    LA: "ルイジアナ",
    ME: "メイン",
    MD: "メリーランド",
    MA: "マサチューセッツ",
    MI: "ミシガン",
    MN: "ミネソタ",
    MS: "ミシシッピ",
    MO: "ミズーリ",
    MT: "モンタナ",
    NE: "ネブラスカ",
    NV: "ネバダ",
    NH: "ニューハンプシャー",
    NJ: "ニュージャージー",
    NM: "ニューメキシコ",
    NY: "ニューヨーク",
    NC: "ノースカロライナ",
    ND: "ノースダコタ",
    OH: "オハイオ",
    OK: "オクラホマ",
    OR: "オレゴン",
    PA: "ペンシルベニア",
    PR: "プエルトリコ",
    RI: "ロードアイランド",
    SC: "サウスカロライナ",
    SD: "サウスダコタ",
    TN: "テネシー",
    TX: "テキサス",
    UT: "ユタ",
    VT: "バーモント",
    VA: "バージニア",
    WA: "ワシントン",
    WV: "ウェストバージニア",
    WI: "ウィスコンシン",
    WY: "ワイオミング",
  },
};
var ja = {
  status: status$9,
  progress: progress$9,
  fields: fields$9,
  buttons: buttons$9,
  errors: errors$9,
  countries: countries$9,
  states: states$9,
};

var status$8 = {
  loading: "로드 중...",
};
var progress$8 = {
  steps: "총 %{totalSteps} 단계 중 %{currentStepNumber}단계",
};
var fields$8 = {
  email: "이메일",
  country: "국가/지역",
  state: "주/도",
  first_name: "이름",
  last_name: "성",
  company_name: "회사 이름",
  role: "역할 이름",
  relationship: "Salesforce와의 관계",
  required: "(필수)",
  select_placeholder: "옵션 선택",
};
var buttons$8 = {
  close: "닫기",
  cancel: "취소",
  save: "저장",
  next: "다음",
  continue: "계속",
};
var errors$8 = {
  something_went_wrong: "문제가 발생했습니다. 다시 시도하세요.",
  fill_required_fields: "제출하기 전에 필수 입력란을 작성하세요.",
};
var countries$8 = {
  AF: "아프가니스탄",
  AX: "올란드제도",
  AL: "알바니아",
  DZ: "알제리",
  AD: "안도라",
  AO: "앙골라",
  AI: "앵귈라",
  AQ: "남극",
  AG: "앤티가바부다",
  AR: "아르헨티나",
  AM: "아르메니아",
  AW: "아루바",
  AU: "오스트레일리아",
  AT: "오스트리아",
  AZ: "아제르바이잔",
  BS: "바하마",
  BH: "바레인",
  BD: "방글라데시",
  BB: "바베이도스",
  BY: "벨라루스",
  BE: "벨기에",
  BZ: "벨리즈",
  BJ: "베냉",
  BM: "버뮤다",
  BT: "부탄",
  BO: "볼리비아다민족국",
  BQ: "보나이러",
  BA: "보스니아헤르체고비나",
  BW: "보츠와나",
  BV: "부베 섬",
  BR: "브라질",
  IO: "영국령인도양식민지",
  BN: "브루나이 다루살람",
  BG: "불가리아",
  BF: "부르키나파소",
  BI: "브루나이",
  KH: "캄보디아",
  CM: "카메룬",
  CA: "캐나다",
  CV: "카보베르데",
  KY: "케이맨제도",
  CF: "중앙아프리카공화국",
  TD: "차드",
  CL: "칠레",
  CN: "중국",
  CX: "크리스마스섬",
  CC: "코코스제도",
  CO: "콜롬비아",
  KM: "코모로",
  CG: "콩고",
  CD: "콩고민주공화국",
  CK: "쿡제도",
  CR: "코스타리카",
  CI: "코트디부아르",
  HR: "크로아티아",
  CW: "퀴라소",
  CY: "사이프러스",
  CZ: "체코",
  DK: "덴마크",
  DJ: "지부티",
  DM: "도미니카",
  DO: "도미니카공화국",
  EC: "에콰도르",
  EG: "이집트",
  SV: "엘살바도르",
  GQ: "적도기니",
  ER: "에리트레아",
  EE: "에스토니아",
  ET: "에티오피아",
  FK: "포클랜드제도(말비나스)",
  FO: "패로제도",
  FJ: "피지",
  FI: "핀란드",
  FR: "프랑스",
  GF: "프랑스령기아나",
  PF: "프랑스령폴리네시아",
  TF: "프랑스령남부지방",
  GA: "가봉",
  GM: "감비아",
  GE: "조지아",
  DE: "독일",
  GH: "가나",
  GI: "지브롤터",
  GR: "그리스",
  GL: "그린란드",
  GD: "그레나다",
  GP: "과들루프",
  GT: "과테말라",
  GG: "건지",
  GN: "기니",
  GW: "기니비사우",
  GY: "가이아나",
  HT: "아이티",
  HM: "허드맥도널드제도",
  VA: "바티칸시국",
  HK: "홍콩",
  HN: "온두라스",
  HU: "헝가리",
  IS: "아이슬란드",
  IN: "인도",
  ID: "인도네시아",
  IQ: "이라크",
  IE: "아일랜드",
  IM: "맨섬",
  IL: "이스라엘",
  IT: "이탈리아",
  JM: "자메이카",
  JP: "일본",
  JE: "저지",
  JO: "요르단",
  KZ: "카자흐스탄",
  KE: "케냐",
  KI: "키리바시",
  KR: "대한민국",
  KW: "쿠웨이트",
  KG: "키르기스스탄",
  LA: "라오인민민주공화국",
  LV: "라트비아",
  LB: "레바논",
  LS: "레소토",
  LR: "라이베리아",
  LY: "리비아",
  LI: "리히텐슈타인",
  LT: "리투아니아",
  LU: "룩셈부르크",
  MO: "마카오",
  MK: "마케도니아공화국",
  MG: "마다가스카르",
  MW: "말라위",
  MY: "말레이시아",
  MV: "몰디브",
  ML: "말리",
  MT: "몰타",
  MQ: "마르티니크",
  MR: "모리타니아",
  MU: "모리셔스",
  YT: "마요트섬",
  MX: "멕시코",
  MD: "몰도바공화국",
  MC: "모나코",
  MN: "몽골",
  ME: "몬테네그로",
  MS: "몬세라트",
  MA: "모로코",
  MZ: "모잠비크",
  MM: "미얀마",
  NA: "나미비아",
  NR: "나우루",
  NP: "네팔",
  NL: "네덜란드",
  NC: "뉴칼레도니아",
  NZ: "뉴질랜드",
  NI: "니카라과",
  NE: "니제르",
  NG: "나이지리아",
  NU: "니우에",
  NF: "노퍽섬",
  NO: "노르웨이",
  OM: "오만",
  PK: "파키스탄",
  PS: "팔레스타인",
  PA: "파나마",
  PG: "파푸아뉴기니",
  PY: "파라과이",
  PE: "페루",
  PH: "필리핀",
  PN: "핏케언",
  PL: "폴란드",
  PT: "포르투갈",
  QA: "카타르",
  RE: "레위니옹",
  RO: "루마니아",
  RU: "러시아",
  RW: "르완다",
  BL: "생바르텔레미",
  SH: "세인트헬레나 어센션 트리스탄다쿠냐",
  KN: "세인트키츠네비스",
  LC: "세인트루시아",
  MF: "세인트마틴(프랑스령)",
  PM: "생피에르미쿨롱",
  VC: "세인트빈센트그레나딘",
  WS: "사모아",
  SM: "산마리노",
  ST: "상투메프린시페",
  SA: "사우디아라비아",
  SN: "세네갈",
  RS: "세르비아",
  SC: "세이셸",
  SL: "시에라리온",
  SG: "싱가포르",
  SX: "신트마르턴(네덜란드령)",
  SK: "슬로바키아",
  SI: "슬로베니아",
  SB: "솔로몬제도",
  SO: "소말리아",
  ZA: "남아프리카공화국",
  GS: "사우스조지아사우스샌드위치제도",
  SS: "남수단",
  ES: "스페인",
  LK: "스리랑카",
  SR: "수리남",
  SJ: "스발바르얀마옌",
  SZ: "에스와티니",
  SE: "스웨덴",
  CH: "스위스",
  TW: "대만",
  TJ: "타지키스탄",
  TZ: "탄자니아합중국",
  TH: "태국",
  TL: "동티모르",
  TG: "토고",
  TK: "토켈라우",
  TO: "통가",
  TT: "트리니다드토바고",
  TN: "튀니지",
  TR: "튀르키예",
  TM: "투르크메니스탄",
  TC: "터크스케이커스제도",
  TV: "투발루",
  UG: "우간다",
  UA: "우크라이나",
  AE: "아랍에미리트연합국",
  GB: "영국",
  US: "미합중국",
  UY: "우루과이",
  UZ: "우즈베키스탄",
  VU: "바누아투",
  VE: "베네수엘라볼리바르공화국",
  VN: "베트남",
  VG: "영국령버진아일랜드",
  WF: "왈리스푸투나",
  EH: "서사하라",
  YE: "예멘",
  ZM: "잠비아",
  ZW: "짐바브웨",
};
var states$8 = {
  AU: {
    ACT: "오스트레일리아 수도 특별 지역",
    NSW: "뉴사우스웨일스 주",
    NT: "노던 주",
    QLD: "퀸즐랜드",
    SA: "사우스 오스트레일리아",
    TAS: "태즈메이니아",
    VIC: "빅토리아",
    WA: "웨스턴 오스트레일리아",
  },
  BR: {
    AC: "아크리",
    AL: "알라고아스",
    AP: "아마파",
    AM: "아마조나스",
    BA: "바이아",
    CE: "세아라",
    DF: "브라질 연방구",
    ES: "이스피리투산투",
    GO: "고이아스",
    MA: "마라냥",
    MT: "마투그로수",
    MS: "마투그로수두술",
    MG: "미나스제라이스",
    PA: "파라",
    PB: "파라이바",
    PR: "파라나",
    PE: "페르남부쿠",
    PI: "피아우이",
    RJ: "리우데자네이루",
    RN: "히우그란지두노르치",
    RS: "히우그란지두술",
    RO: "혼도니아",
    RR: "호라이마",
    SC: "산타카타리나",
    SP: "상파울루",
    SE: "세르지피",
    TO: "토칸칭스",
  },
  CA: {
    AB: "알버타",
    BC: "브리티시 컬럼비아",
    MB: "매니토바",
    NB: "뉴브런즈윅",
    NL: "뉴펀들랜드 래브라도",
    NT: "노스웨스트 준주",
    NS: "노바스코샤",
    NU: "누나부트",
    ON: "온타리오",
    PE: "프린스 에드워드 아일랜드",
    QC: "퀘벡",
    SK: "서스캐처원",
    YT: "유콘 준주",
  },
  CN: {
    11: "베이징",
    12: "톈진",
    13: "허베이",
    14: "산시",
    15: "내몽골자치구",
    21: "랴오닝",
    22: "지린",
    23: "헤이룽장",
    31: "상하이",
    32: "장쑤",
    33: "저장",
    34: "안후이",
    35: "푸젠",
    36: "장시",
    37: "산둥",
    41: "허난",
    42: "후베이",
    43: "후난",
    44: "광둥",
    45: "광시좡족자치구",
    46: "하이난",
    50: "충칭",
    51: "쓰촨",
    52: "구이저우",
    53: "윈난",
    54: "시짱자치구",
    61: "섬서",
    62: "간쑤",
    63: "칭하이",
    64: "닝샤",
    65: "신장",
    71: "대만",
    91: "홍콩",
    92: "마카오",
  },
  IN: {
    AN: "안다만 니코바르 제도",
    AP: "안드라 프라데시",
    AR: "아루나찰 프라",
    AS: "아삼",
    BR: "비하",
    CH: "찬디가르",
    CT: "차티스가르",
    DN: "다드라 나가르하벨리",
    DD: "다만 디우",
    DL: "델리",
    GA: "고아",
    GJ: "구자라트",
    HR: "하리아나",
    HP: "히마찰 프라데시",
    JK: "잠무 카슈미르",
    JH: "자르칸드",
    KA: "카나타카",
    KL: "케랄라",
    LD: "락샤드위프",
    MP: "마디야 프라데시",
    MH: "마하라슈트라",
    MN: "마니푸르",
    ML: "메갈라야",
    MZ: "미조람",
    NL: "나갈랜드",
    OR: "오디샤",
    PY: "푸두체리",
    PB: "펀자브",
    RJ: "라자스탄",
    SK: "시킴",
    TN: "타밀나두",
    TG: "텔랑가나",
    TR: "트리풀라",
    UT: "우타라칸드",
    UP: "우타르프라데시",
    WB: "서벵갈",
  },
  IE: {
    CW: "카로우",
    CN: "캐번",
    CE: "클래어",
    CO: "코르크",
    DL: "도니골",
    D: "더블린",
    G: "골웨이",
    KY: "케리",
    KE: "킬데어",
    KK: "킬케니",
    LS: "레이시",
    LM: "리트림",
    LK: "리머릭",
    LD: "롱퍼드",
    LH: "라우스",
    MO: "메이요",
    MH: "미스",
    MN: "모너핸",
    OY: "오펄리",
    RN: "로스커먼",
    SO: "슬라이고",
    TA: "티퍼레리",
    WD: "워터퍼드",
    WH: "웨스트미스",
    WX: "웩스퍼드",
    WW: "위클로",
  },
  IT: {
    AG: "아그리젠토",
    AL: "알레산드리아",
    AN: "안코나",
    AO: "아오스타",
    AR: "아레초",
    AP: "아스콜리피체노",
    AT: "아스티",
    AV: "아벨리노",
    BA: "바리",
    BT: "바를레타안드리아트라니",
    BL: "벨루노",
    BN: "베네벤토",
    BG: "베르가모",
    BI: "비엘라",
    BO: "볼로냐",
    BZ: "볼차노",
    BS: "브레시아",
    BR: "브린디시",
    CA: "칼리아리",
    CL: "칼타니세타",
    CB: "캄포바소",
    CI: "카르보니아이글레시아스",
    CE: "카세르타",
    CT: "카타니아",
    CZ: "카탄차로",
    CH: "키에티",
    CO: "코모",
    CS: "코센차",
    CR: "크레모나",
    KR: "크로토네",
    CN: "쿠네오",
    EN: "엔나",
    FM: "페르모",
    FE: "페라라",
    FI: "플로렌스",
    FG: "포자",
    FC: "포를리체세나",
    FR: "프로시노네",
    GE: "제노바",
    GO: "고리치아",
    GR: "그로세토",
    IM: "임페리아",
    IS: "이세르니아",
    AQ: "라퀼라",
    SP: "라스페치아",
    LT: "라티나",
    LE: "레체",
    LC: "레코",
    LI: "리보르노",
    LO: "로디",
    LU: "루카",
    MC: "마체라타",
    MN: "만토바",
    MS: "마사 카라라",
    MT: "마테라",
    VS: "메디오 캄피다노",
    ME: "메시나",
    MI: "밀라노",
    MO: "모데나",
    MB: "몬차에브리안차",
    NA: "나폴리",
    NO: "노바라",
    NU: "누오로",
    OG: "올리아스트라",
    OT: "올비아템피오",
    OR: "오리스타노",
    PD: "파도바",
    PA: "팔레르모",
    PR: "파르마",
    PV: "파비아",
    PG: "페루자",
    PU: "페사로에우르비노",
    PE: "페스카라",
    PC: "피아첸차",
    PI: "피사",
    PT: "피스토이아",
    PN: "포르데노네",
    PZ: "포텐차",
    PO: "프라토",
    RG: "라구사",
    RA: "라벤나",
    RC: "레조칼라브리아",
    RE: "레조에밀리아",
    RI: "리에티",
    RN: "리미니",
    RM: "로마",
    RO: "로비고",
    SA: "살레르노",
    SS: "사사리",
    SV: "사보나",
    SI: "시에나",
    SO: "손드리오",
    SR: "시라쿠사",
    TA: "타란토",
    TE: "테라모",
    TR: "테르니",
    TP: "트라파니",
    TN: "트렌토",
    TV: "트레비소",
    TS: "트리에스테",
    TO: "토리노",
    UD: "우디네",
    VA: "바레세",
    VE: "베니스",
    VB: "베르바노쿠시오오솔라",
    VC: "베르첼리",
    VR: "베로나",
    VV: "비보발렌티아",
    VI: "비첸차",
    VT: "비테르보",
  },
  MX: {
    AG: "아과스칼리엔테스",
    BC: "바하칼리포르니아",
    BS: "바하칼리포르니아수르",
    CM: "캄페체",
    CS: "치아파스",
    CH: "치와와",
    CO: "코아우일라",
    CL: "콜리마",
    DG: "두랑고",
    DF: "멕시코 연방구(멕시코시티)",
    GT: "과나후아토",
    GR: "게레로",
    HG: "이달고",
    JA: "할리스코",
    ME: "멕시코주",
    MI: "미초아칸",
    MO: "모렐로스",
    NA: "나야리트",
    NL: "누에보레온",
    OA: "오악사카",
    PB: "푸에블라",
    QE: "케레타로",
    QR: "킨타나로오",
    SL: "산루이스포토시",
    SI: "시날로아",
    SO: "소노라",
    TB: "타바스코",
    TM: "타마울리파스",
    TL: "틀락스칼라",
    VE: "베라크루스",
    YU: "유카탄",
    ZA: "사카테카스",
  },
  US: {
    AL: "앨라배마",
    AK: "알래스카",
    AZ: "애리조나",
    AR: "아칸소",
    CA: "캘리포니아",
    CO: "콜로라도",
    CT: "코네티컷",
    DE: "델라웨어",
    DC: "컬럼비아 특별구",
    FL: "플로리다",
    GA: "조지아",
    HI: "하와이",
    ID: "아이다호",
    IL: "일리노이",
    IN: "인디애나",
    IA: "아이오와",
    KS: "캔자스",
    KY: "켄터키",
    LA: "루이지애나",
    ME: "메인",
    MD: "메릴랜드",
    MA: "매사추세츠",
    MI: "미시간",
    MN: "미네소타",
    MS: "미시시피",
    MO: "미주리",
    MT: "몬태나",
    NE: "네브래스카",
    NV: "네바다",
    NH: "뉴햄프셔",
    NJ: "뉴저지",
    NM: "뉴멕시코",
    NY: "뉴욕",
    NC: "노스캐롤라이나",
    ND: "노스다코타",
    OH: "오하이오",
    OK: "오클라호마",
    OR: "오리건",
    PA: "펜실베이니아",
    PR: "푸에르토리코",
    RI: "로드아일랜드",
    SC: "사우스캐롤라이나",
    SD: "사우스다코타",
    TN: "테네시",
    TX: "텍사스",
    UT: "유타",
    VT: "버몬트",
    VA: "버지니아",
    WA: "워싱턴",
    WV: "웨스트버지니아",
    WI: "위스콘신",
    WY: "와이오밍",
  },
};
var ko = {
  status: status$8,
  progress: progress$8,
  fields: fields$8,
  buttons: buttons$8,
  errors: errors$8,
  countries: countries$8,
  states: states$8,
};

var status$7 = {
  loading: "Bezig met laden...",
};
var progress$7 = {
  steps: "Stap %{currentStepNumber} van %{totalSteps}",
};
var fields$7 = {
  email: "E-mail",
  country: "Land/regio",
  state: "Staat/Provincie",
  first_name: "Voornaam",
  last_name: "Achternaam",
  company_name: "Bedrijfsnaam",
  role: "Rolnaam",
  relationship: "Relatie met Salesforce",
  required: "(vereist)",
  select_placeholder: "Selecteer een optie",
};
var buttons$7 = {
  close: "Sluiten",
  cancel: "Annuleren",
  save: "Opslaan",
  next: "Volgende",
  continue: "Doorgaan",
};
var errors$7 = {
  something_went_wrong: "Er is iets verkeerd gegaan, probeer het opnieuw",
  fill_required_fields: "Vul de verplichte velden in vóór het indienen.",
};
var countries$7 = {
  AF: "Afghanistan",
  AX: "Aland",
  AL: "Albanië",
  DZ: "Algerije",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua en Barbuda",
  AR: "Argentinië",
  AM: "Armenië",
  AW: "Aruba",
  AU: "Australië",
  AT: "Oostenrijk",
  AZ: "Azerbeidzjan",
  BS: "Bahama's",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Wit-Rusland",
  BE: "België",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius en Saba",
  BA: "Bosnië en Herzegovina",
  BW: "Botswana",
  BV: "Bouveteiland",
  BR: "Brazilië",
  IO: "Brits Indische Oceaanterritorium",
  BN: "Brunei",
  BG: "Bulgarije",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Kameroen",
  CA: "Canada",
  CV: "Kaapverdië",
  KY: "Kaaimaneilanden",
  CF: "Centraal-Afrikaanse Republiek",
  TD: "Tsjaad",
  CL: "Chili",
  CN: "China",
  CX: "Christmaseiland",
  CC: "Cocoseilanden",
  CO: "Colombia",
  KM: "Comoren",
  CG: "Congo",
  CD: "Democratische Republiek Congo",
  CK: "Cookeilanden",
  CR: "Costa Rica",
  CI: "Ivoorkust",
  HR: "Kroatië",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Tsjechië",
  DK: "Denemarken",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominicaanse Republiek",
  EC: "Ecuador",
  EG: "Egypte",
  SV: "El Salvador",
  GQ: "Equatoriaal-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Ethiopië",
  FK: "Falklandeilanden",
  FO: "Faeröer",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrijk",
  GF: "Frans-Guyana",
  PF: "Frans-Polynesië",
  TF: "Franse Zuidelijke Gebieden",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgië",
  DE: "Duitsland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griekenland",
  GL: "Groenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinee",
  GW: "Guinee-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Heard en McDonaldeilanden",
  VA: "Vaticaanstad",
  HK: "Hongkong",
  HN: "Honduras",
  HU: "Hongarije",
  IS: "IJsland",
  IN: "India",
  ID: "Indonesië",
  IQ: "Irak",
  IE: "Ierland",
  IM: "Isle of Man",
  IL: "Israël",
  IT: "Italië",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanië",
  KZ: "Kazakhstan",
  KE: "Kenia",
  KI: "Kiribati",
  KR: "Zuid-Korea",
  KW: "Koeweit",
  KG: "Kirgistan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libië",
  LI: "Liechtenstein",
  LT: "Litouwen",
  LU: "Luxemburg",
  MO: "Macau",
  MK: "Noord-Macedonië",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Maleisië",
  MV: "Maldiven",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinique",
  MR: "Mauritanië",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  MD: "Moldavië",
  MC: "Monaco",
  MN: "Mongolië",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibië",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederland",
  NC: "Nieuw-Caledonië",
  NZ: "Nieuw-Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  NO: "Noorwegen",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papoea-Nieuw-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippijnen",
  PN: "Pitcairneilanden",
  PL: "Polen",
  PT: "Portugal",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roemenië",
  RU: "Rusland",
  RW: "Rwanda",
  BL: "Saint-Barthélemy",
  SH: "Sint-Helena, Ascension en Tristan da Cunha",
  KN: "Saint Kitts en Nevis",
  LC: "Saint Lucia",
  MF: "Sint Maarten (Franse deel)",
  PM: "Saint-Pierre en Miquelon",
  VC: "Saint Vincent en de Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tomé en Principe",
  SA: "Saoedi-Arabië",
  SN: "Senegal",
  RS: "Servië",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Nederlandse deel)",
  SK: "Slowakije",
  SI: "Slovenië",
  SB: "Salomonseilanden",
  SO: "Somalië",
  ZA: "Zuid-Afrika",
  GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
  SS: "Zuid-Soedan",
  ES: "Spanje",
  LK: "Sri Lanka",
  SR: "Suriname",
  SJ: "Spitsbergen en Jan Mayen",
  SZ: "Swaziland",
  SE: "Zweden",
  CH: "Zwitserland",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Oost-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad en Tobago",
  TN: "Tunesië",
  TR: "Turkije",
  TM: "Turkmenistan",
  TC: "Turks- en Caicoseilanden",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Oekraïne",
  AE: "Verenigde Arabische Emiraten",
  GB: "Verenigd Koninkrijk",
  US: "Verenigde Staten",
  UY: "Uruguay",
  UZ: "Oezbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Britse Maagdeneilanden",
  WF: "Wallis en Futuna",
  EH: "Westelijke Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
var states$7 = {
  AU: {
    ACT: "Australian Capital Territory",
    NSW: "Nieuw Zuid-Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "Zuid-Australië",
    TAS: "Tasmanië",
    VIC: "Victoria",
    WA: "West-Australië",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "Brits-Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland en Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prins Edwardeiland",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon Territories",
  },
  CN: {
    11: "Beijing",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Nei Mongol",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hongkong",
    92: "Macau",
  },
  IN: {
    AN: "Andaman en Nicobar-eilanden",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra en Nagar Haveli",
    DD: "Daman en Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu en Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "West-Bengalen",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Florence",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genua",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa-Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milaan",
    MO: "Modena",
    MB: "Monza e Brianza",
    NA: "Napels",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro en Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Rome",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Syracuse",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Triëst",
    TO: "Turijn",
    UD: "Udine",
    VA: "Varese",
    VE: "Venetië",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Mexico-Stad",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Mexico",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "Californië",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgië",
    HI: "Hawaï",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var nl = {
  status: status$7,
  progress: progress$7,
  fields: fields$7,
  buttons: buttons$7,
  errors: errors$7,
  countries: countries$7,
  states: states$7,
};

var status$6 = {
  loading: "Laster...",
};
var progress$6 = {
  steps: "Trinn %{currentStepNumber} av %{totalSteps}",
};
var fields$6 = {
  email: "E-postadresse",
  country: "Land/region",
  state: "Delstat/provins",
  first_name: "Fornavn",
  last_name: "Etternavn",
  company_name: "Firmanavn",
  role: "Rollenavn",
  relationship: "Relasjon til Salesforce",
  required: "(obligatorisk)",
  select_placeholder: "Velg et alternativ",
};
var buttons$6 = {
  close: "Lukk",
  cancel: "Avbryt",
  save: "Lagre",
  next: "Neste",
  continue: "Fortsett",
};
var errors$6 = {
  something_went_wrong: "Noe gikk galt. Prøv på nytt.",
  fill_required_fields: "Fyll ut de obligatoriske feltene før du sender inn.",
};
var countries$6 = {
  AF: "Afghanistan",
  AX: "Åland",
  AL: "Albania",
  DZ: "Algerie",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Østerrike",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia, den flernasjonale staten",
  BQ: "Bonaire, Sint Eustatius og Saba",
  BA: "Bosnia og Herzegovina",
  BW: "Botswana",
  BV: "Bouvet-øya",
  BR: "Brasil",
  IO: "Det britiske territoriet i Indiahavet",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodsja",
  CM: "Kamerun",
  CA: "Canada",
  CV: "Kapp Verde",
  KY: "Cayman-øyene",
  CF: "Den sentralafrikanske republikk",
  TD: "Chad",
  CL: "Chile",
  CN: "Kina",
  CX: "Christmas-øya",
  CC: "Kokosøyene (Keeling)",
  CO: "Colombia",
  KM: "Komorene",
  CG: "Kongo",
  CD: "Kongo, Den demokratiske republikken",
  CK: "Cook-øyene",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatia",
  CW: "Curaçao",
  CY: "Kypros",
  CZ: "Tsjekkia",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den dominikanske republikk",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Ekvatorial-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopia",
  FK: "Falklandsøyene (Malvinas)",
  FO: "Færøyene",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrike",
  GF: "Fransk Guyana",
  PF: "Frensk Polynesia",
  TF: "Fransk sørlig territorium",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Hellas",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-øya og McDonald-øyene",
  VA: "Den hellige stol (Vatikanstaten)",
  HK: "Hongkong",
  HN: "Honduras",
  HU: "Ungarn",
  IS: "Island",
  IN: "India",
  ID: "Indonesia",
  IQ: "Irak",
  IE: "Irland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Sør-Korea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos, den demokratiske folkerepublikken",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Makedonia, den tidligere jugoslaviske republikk",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldivene",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  MD: "Moldova, republikken",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederland",
  NC: "Ny-Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkøya",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinene",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russland",
  RW: "Rwanda",
  BL: "Saint-Barthélemy",
  SH: "St. Helena, Ascension og Tristan da Cunha",
  KN: "Saint Kitts og Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (fransk del)",
  PM: "Saint Pierre og Miquelon",
  VC: "Saint Vincent og Grenadinene",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychellene",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (nederlandsk del)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon-øyene",
  SO: "Somalia",
  ZA: "Sør-Afrika",
  GS: "Sør-Georgia og Sør-Sandwichøyene",
  SS: "Sør-Sudan",
  ES: "Spania",
  LK: "Sri Lanka",
  SR: "Surinam",
  SJ: "Svalbard og Jan Mayen",
  SZ: "Swaziland",
  SE: "Sverige",
  CH: "Sveits",
  TW: "Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania, den forente republikken",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunisia",
  TR: "Tyrkia",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøyene",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Forente arabiske emirater",
  GB: "Storbritannia",
  US: "USA",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Jomfruøyene, britiske",
  WF: "Wallis og Futuna",
  EH: "Vest-Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
var states$6 = {
  AU: {
    ACT: "Australias hovedstadsområde",
    NSW: "New South Wales",
    NT: "Nordterritoriet",
    QLD: "Queensland",
    SA: "Sør-Australia",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Vest-Australia",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "Britisk Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland og Labrador",
    NT: "Nordvestterritoriene",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon",
  },
  CN: {
    11: "Beijing",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Nei Mongol",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hongkong",
    92: "Macao",
  },
  IN: {
    AN: "Andamanene og Nikobarene",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra og Nagar Haveli",
    DD: "Daman og Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu og Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "Vest-Bengal",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Firenze",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genoa",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa og Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milano",
    MO: "Modena",
    MB: "Monza og Brianza",
    NA: "Napoli",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro og Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Roma",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Syracuse",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Turin",
    UD: "Udine",
    VA: "Varese",
    VE: "Venezia",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Federal District",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Mexico",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "Nord-Carolina",
    ND: "Nord-Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "Sør-Carolina",
    SD: "Sør-Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var no = {
  status: status$6,
  progress: progress$6,
  fields: fields$6,
  buttons: buttons$6,
  errors: errors$6,
  countries: countries$6,
  states: states$6,
};

var status$5 = {
  loading: "Carregando...",
};
var progress$5 = {
  steps: "Etapa %{currentStepNumber} de %{totalSteps}",
};
var fields$5 = {
  email: "Email",
  country: "País/Região",
  state: "Estado/Província",
  first_name: "Nome",
  last_name: "Sobrenome",
  company_name: "Nome da empresa",
  role: "Nome da função",
  relationship: "Relacionamento com o Salesforce",
  required: "(obrigatório)",
  select_placeholder: "Selecionar uma opção",
};
var buttons$5 = {
  close: "Fechar",
  cancel: "Cancelar",
  save: "Salvar",
  next: "Avançar",
  continue: "Continuar",
};
var errors$5 = {
  something_went_wrong: "Ocorreu algo errado. Tente novamente",
  fill_required_fields: "Preencha os campos obrigatórios antes de enviar.",
};
var countries$5 = {
  AF: "Afeganistão",
  AX: "Ilhas Aland",
  AL: "Albânia",
  DZ: "Argélia",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antártida",
  AG: "Antígua e Barbuda",
  AR: "Argentina",
  AM: "Armênia",
  AW: "Aruba",
  AU: "Austrália",
  AT: "Áustria",
  AZ: "Azerbaijão",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bielo-Rússia",
  BE: "Bélgica",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Butão",
  BO: "Bolívia, Estado Plurinacional da",
  BQ: "Bonaire, Santo Eustáquio e Saba",
  BA: "Bósnia e Herzegovina",
  BW: "Botsuana",
  BV: "Ilha Bouvet",
  BR: "Brasil",
  IO: "Território Britânico do Oceano Índico",
  BN: "Brunei Darussalam",
  BG: "Bulgária",
  BF: "Burkina Fasso",
  BI: "Burundi",
  KH: "Camboja",
  CM: "Camarões",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Ilhas Caimã",
  CF: "República Centro-Africana",
  TD: "Chade",
  CL: "Chile",
  CN: "China",
  CX: "Ilha Christmas",
  CC: "Ilhas Cocos (Keeling)",
  CO: "Colômbia",
  KM: "Comores",
  CG: "Congo",
  CD: "Congo, a República Democrática do",
  CK: "Ilhas Cook",
  CR: "Costa Rica",
  CI: "Costa do Marfim",
  HR: "Croácia",
  CW: "Curaçao",
  CY: "Chipre",
  CZ: "República Tcheca",
  DK: "Dinamarca",
  DJ: "Djibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Equador",
  EG: "Egito",
  SV: "El Salvador",
  GQ: "Guiné Equatorial",
  ER: "Eritreia",
  EE: "Estônia",
  ET: "Etiópia",
  FK: "Ilhas Falkland (Malvinas)",
  FO: "Ilhas Faroé",
  FJ: "Fiji",
  FI: "Finlândia",
  FR: "França",
  GF: "Guiana Francesa",
  PF: "Polinésia Francesa",
  TF: "Territórios Franceses do Sul",
  GA: "Gabão",
  GM: "Gâmbia",
  GE: "Geórgia",
  DE: "Alemanha",
  GH: "Gana",
  GI: "Gibraltar",
  GR: "Grécia",
  GL: "Groenlândia",
  GD: "Granada",
  GP: "Guadalupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guiné",
  GW: "Guiné-Bissau",
  GY: "Guiana",
  HT: "Haiti",
  HM: "Ilha Heard e Ilhas McDonald",
  VA: "Santa Sé (Estado da Cidade do Vaticano)",
  HK: "Hong Kong",
  HN: "Honduras",
  HU: "Hungria",
  IS: "Islândia",
  IN: "Índia",
  ID: "Indonésia",
  IQ: "Iraque",
  IE: "Irlanda",
  IM: "Ilha de Man",
  IL: "Israel",
  IT: "Itália",
  JM: "Jamaica",
  JP: "Japão",
  JE: "Jersey",
  JO: "Jordânia",
  KZ: "Cazaquistão",
  KE: "Quênia",
  KI: "Quiribati",
  KR: "Coreia, República da",
  KW: "Kuwait",
  KG: "Quirguistão",
  LA: "República Democrática Popular do Laos",
  LV: "Letônia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Lituânia",
  LU: "Luxemburgo",
  MO: "Macau",
  MK: "Macedônia, a ex-república iugoslava da",
  MG: "Madagáscar",
  MW: "Malawi",
  MY: "Malásia",
  MV: "Maldivas",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinica",
  MR: "Mauritânia",
  MU: "Maurício",
  YT: "Maiote",
  MX: "México",
  MD: "Moldávia, República da",
  MC: "Mônaco",
  MN: "Mongólia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marrocos",
  MZ: "Moçambique",
  MM: "Mianmar",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Países Baixos",
  NC: "Nova Caledônia",
  NZ: "Nova Zelândia",
  NI: "Nicarágua",
  NE: "Níger",
  NG: "Nigéria",
  NU: "Niuê",
  NF: "Ilha Norfolk",
  NO: "Noruega",
  OM: "Omã",
  PK: "Paquistão",
  PS: "Palestina",
  PA: "Panamá",
  PG: "Papua Nova Guiné",
  PY: "Paraguai",
  PE: "Peru",
  PH: "Filipinas",
  PN: "Pitcairn",
  PL: "Polônia",
  PT: "Portugal",
  QA: "Qatar",
  RE: "Reunião",
  RO: "Romênia",
  RU: "Federação Russa",
  RW: "Ruanda",
  BL: "São Bartolomeu",
  SH: "Santa Helena, Ascensão e Tristão da Cunha",
  KN: "São Cristóvão e Névis",
  LC: "Santa Lúcia",
  MF: "São Martinho (parte francesa)",
  PM: "São Pedro e Miquelon",
  VC: "São Vicente e Granadinas",
  WS: "Samoa",
  SM: "São Marino",
  ST: "São Tomé e Príncipe",
  SA: "Arábia Saudita",
  SN: "Senegal",
  RS: "Sérvia",
  SC: "Seicheles",
  SL: "Serra Leoa",
  SG: "Singapura",
  SX: "São Martinho (parte dos Países Baixos)",
  SK: "Eslováquia",
  SI: "Eslovênia",
  SB: "Ilhas Salomão",
  SO: "Somália",
  ZA: "África do Sul",
  GS: "Ilhas Geórgia do Sul e Sandwich do Sul",
  SS: "Sudão do Sul",
  ES: "Espanha",
  LK: "Sri Lanka",
  SR: "Suriname",
  SJ: "Svalbard e Jan Mayen",
  SZ: "Suazilândia",
  SE: "Suécia",
  CH: "Suíça",
  TW: "Taiwan",
  TJ: "Tajiquistão",
  TZ: "Tanzânia, República Unida da",
  TH: "Tailândia",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Toquelau",
  TO: "Tonga",
  TT: "Trinidad e Tobago",
  TN: "Tunísia",
  TR: "Turquia",
  TM: "Turquemenistão",
  TC: "Ilhas Turcas e Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ucrânia",
  AE: "Emirados Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UY: "Uruguai",
  UZ: "Uzbequistão",
  VU: "Vanuatu",
  VE: "Venezuela, República Bolivariana da",
  VN: "Vietnã",
  VG: "Ilhas Virgens, Britânicas",
  WF: "Wallis e Futuna",
  EH: "Saara Ocidental",
  YE: "Iêmen",
  ZM: "Zâmbia",
  ZW: "Zimbábue",
};
var states$5 = {
  AU: {
    ACT: "Território da capital australiana",
    NSW: "Nova Gales do Sul",
    NT: "Território do Norte",
    QLD: "Queensland",
    SA: "Sul da Austrália",
    TAS: "Tasmânia",
    VIC: "Victoria",
    WA: "Oeste da Austrália",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "Colúmbia Britânica",
    MB: "Manitoba",
    NB: "Nova Brunswick",
    NL: "Terra Nova e Labrador",
    NT: "Territórios do Noroeste",
    NS: "Nova Escócia",
    NU: "Nunavut",
    ON: "Ontário",
    PE: "Ilha do Príncipe Eduardo",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Territórios de Yukon",
  },
  CN: {
    11: "Pequim",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Nei Mongol",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Xangai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hong Kong",
    92: "Macau",
  },
  IN: {
    AN: "Ilhas Andaman e Nicobar",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra e Nagar Haveli",
    DD: "Damão e Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jamu e Caxemira",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "Bengala Ocidental",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alexandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avelino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bolonha",
    BZ: "Bolzano",
    BS: "Bréscia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catânia",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Florença",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Gênova",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Impéria",
    IS: "Isernia",
    AQ: "Áquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mântua",
    MS: "Massa e Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milão",
    MO: "Módena",
    MB: "Monza e Brianza",
    NA: "Nápoles",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Pádua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro e Urbino",
    PE: "Pescara",
    PC: "Placência",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Régio da Calábria",
    RE: "Régio da Emília",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Roma",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sássari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Siracusa",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Turim",
    UD: "Údine",
    VA: "Varese",
    VE: "Veneza",
    VB: "Verbano Cusio Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baixa Califórnia",
    BS: "Baixa Califórnia do Sul",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Distrito Federal",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Estado do México",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Iucatã",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alasca",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "Califórnia",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "Distrito de Colúmbia",
    FL: "Flórida",
    GA: "Geórgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "Nova Hampshire",
    NJ: "Nova Jersey",
    NM: "Novo México",
    NY: "Nova York",
    NC: "Carolina do Norte",
    ND: "Dakota do Norte",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pensilvânia",
    PR: "Porto Rico",
    RI: "Rhode Island",
    SC: "Carolina do Sul",
    SD: "Dakota do Sul",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virgínia",
    WA: "Washington",
    WV: "Virgínia Ocidental",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var ptBR = {
  status: status$5,
  progress: progress$5,
  fields: fields$5,
  buttons: buttons$5,
  errors: errors$5,
  countries: countries$5,
  states: states$5,
};

var status$4 = {
  loading: "Загрузка…",
};
var progress$4 = {
  steps: "Действие %{currentStepNumber} из %{totalSteps}",
};
var fields$4 = {
  email: "Эл. почта",
  country: "Страна/регион",
  state: "Штат/провинция",
  first_name: "Имя",
  last_name: "Фамилия",
  company_name: "Название компании",
  role: "Название роли",
  relationship: "Взаимосвязь с Salesforce",
  required: "(обязательно)",
  select_placeholder: "Выбрать параметр",
};
var buttons$4 = {
  close: "Закрыть",
  cancel: "Отмена",
  save: "Сохранить",
  next: "Далее",
  continue: "Продолжить",
};
var errors$4 = {
  something_went_wrong: "Произошла ошибка. Повторите попытку.",
  fill_required_fields: "Заполните обязательные поля перед отправкой.",
};
var countries$4 = {
  AF: "Афганистан",
  AX: "Аландские острова",
  AL: "Албания",
  DZ: "Алжир",
  AD: "Андорра",
  AO: "Ангола",
  AI: "Ангилья",
  AQ: "Антарктида",
  AG: "Антигуа и Барбуда",
  AR: "Аргентина",
  AM: "Армения",
  AW: "Аруба",
  AU: "Австралия",
  AT: "Австрия",
  AZ: "Азербайджан",
  BS: "Багамы",
  BH: "Бахрейн",
  BD: "Бангладеш",
  BB: "Барбадос",
  BY: "Белоруссия",
  BE: "Бельгия",
  BZ: "Белиз",
  BJ: "Бенин",
  BM: "Бермуды",
  BT: "Бутан",
  BO: "Боливия",
  BQ: "Бонайре, Синт-Эстатиус и Саба",
  BA: "Босния и Герцеговина",
  BW: "Ботсвана",
  BV: "Остров Буве",
  BR: "Бразилия",
  IO: "Британская территория Индийского океана",
  BN: "Бруней-Даруссалам",
  BG: "Болгария",
  BF: "Буркина-Фасо",
  BI: "Бурунди",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  CV: "Кабо-Верде",
  KY: "Каймановы острова",
  CF: "Центрально-Африканская Республика",
  TD: "Чад",
  CL: "Чили",
  CN: "Китай",
  CX: "Остров Рождества",
  CC: "Кокосовые острова",
  CO: "Колумбия",
  KM: "Коморские острова",
  CG: "Конго",
  CD: "Демократическая Республика Конго",
  CK: "Острова Кука",
  CR: "Коста-Рика",
  CI: "Кот-д'Ивуар",
  HR: "Хорватия",
  CW: "Кюрасао",
  CY: "Кипр",
  CZ: "Чехия",
  DK: "Дания",
  DJ: "Джибути",
  DM: "Доминика",
  DO: "Доминиканская Республика",
  EC: "Эквадор",
  EG: "Египет",
  SV: "Сальвадор",
  GQ: "Экваториальная Гвинея",
  ER: "Эритрея",
  EE: "Эстония",
  ET: "Эфиопия",
  FK: "Фолклендские (Мальвинские) острова",
  FO: "Фарерские острова",
  FJ: "Фиджи",
  FI: "Финляндия",
  FR: "Франция",
  GF: "Французская Гвиана",
  PF: "Французская Полинезия",
  TF: "Французские южные территории",
  GA: "Габон",
  GM: "Гамбия",
  GE: "Грузия",
  DE: "Германия",
  GH: "Гана",
  GI: "Гибралтар",
  GR: "Греция",
  GL: "Гренландия",
  GD: "Гренада",
  GP: "Гваделупа",
  GT: "Гватемала",
  GG: "Гернси",
  GN: "Гвинея",
  GW: "Гвинея-Бисау",
  GY: "Гайана",
  HT: "Гаити",
  HM: "Остров Херд и острова Макдональд",
  VA: "Ватикан",
  HK: "Гонконг",
  HN: "Гондурас",
  HU: "Венгрия",
  IS: "Исландия",
  IN: "Индия",
  ID: "Индонезия",
  IQ: "Ирак",
  IE: "Ирландия",
  IM: "Остров Мэн",
  IL: "Израиль",
  IT: "Италия",
  JM: "Ямайка",
  JP: "Япония",
  JE: "Джерси",
  JO: "Иордания",
  KZ: "Казахстан",
  KE: "Кения",
  KI: "Кирибати",
  KR: "Республика Корея",
  KW: "Кувейт",
  KG: "Киргизия",
  LA: "Лаосская Народно-Демократическая Республика",
  LV: "Латвия",
  LB: "Ливан",
  LS: "Лесото",
  LR: "Либерия",
  LY: "Ливия",
  LI: "Лихтенштейн",
  LT: "Литва",
  LU: "Люксембург",
  MO: "Макао",
  MK: "Македония (Бывшая Югославская Республика)",
  MG: "Мадагаскар",
  MW: "Малави",
  MY: "Малайзия",
  MV: "Мальдивы",
  ML: "Мали",
  MT: "Мальта",
  MQ: "Мартиника",
  MR: "Мавритания",
  MU: "Маврикий",
  YT: "Майотта",
  MX: "Мексика",
  MD: "Республика Молдова",
  MC: "Монако",
  MN: "Монголия",
  ME: "Черногория",
  MS: "Монтсеррат",
  MA: "Марокко",
  MZ: "Мозамбик",
  MM: "Мьянма",
  NA: "Намибия",
  NR: "Науру",
  NP: "Непал",
  NL: "Нидерланды",
  NC: "Новая Каледония",
  NZ: "Новая Зеландия",
  NI: "Никарагуа",
  NE: "Нигер",
  NG: "Нигерия",
  NU: "Ниуэ",
  NF: "Остров Норфолк",
  NO: "Норвегия",
  OM: "Оман",
  PK: "Пакистан",
  PS: "Палестина",
  PA: "Панама",
  PG: "Папуа-Новая Гвинея",
  PY: "Парагвай",
  PE: "Перу",
  PH: "Филиппины",
  PN: "Питкерн",
  PL: "Польша",
  PT: "Португалия",
  QA: "Катар",
  RE: "Реюньон",
  RO: "Румыния",
  RU: "Российская Федерация",
  RW: "Руанда",
  BL: "Сент-Бартелеми",
  SH: "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
  KN: "Сент-Китс и Невис",
  LC: "Сент-Люсия",
  MF: "Сен-Мартен (французская часть)",
  PM: "Сен-Пьер и Микелон",
  VC: "Сен-Винсент и Гренадины",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе и Принсипи",
  SA: "Саудовская Аравия",
  SN: "Сенегал",
  RS: "Сербия",
  SC: "Сейшелы",
  SL: "Сьерра-Леоне",
  SG: "Сингапур",
  SX: "Синт-Мартен (нидерландская часть)",
  SK: "Словакия",
  SI: "Словения",
  SB: "Соломоновы острова",
  SO: "Сомали",
  ZA: "ЮАР",
  GS: "Южная Джорджия и Южные Сандвичевы Острова",
  SS: "Южный Судан",
  ES: "Испания",
  LK: "Шри-Ланка",
  SR: "Суринам",
  SJ: "Шпицберген и Ян-Майен",
  SZ: "Свазиленд",
  SE: "Швеция",
  CH: "Швейцария",
  TW: "Тайвань",
  TJ: "Таджикистан",
  TZ: "Объединенная Республика Танзания",
  TH: "Таиланд",
  TL: "Восточный Тимор",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринидад и Тобаго",
  TN: "Тунис",
  TR: "Турция",
  TM: "Туркменистан",
  TC: "Острова Теркс и Кайкос",
  TV: "Тувалу",
  UG: "Уганда",
  UA: "Украина",
  AE: "ОАЭ",
  GB: "Соединенное Королевство",
  US: "США",
  UY: "Уругвай",
  UZ: "Узбекистан",
  VU: "Вануату",
  VE: "Боливарианская республика Венесуэла",
  VN: "Вьетнам",
  VG: "Британские Виргинские острова",
  WF: "Уоллис и Футуна",
  EH: "Западная Сахара",
  YE: "Йемен",
  ZM: "Замбия",
  ZW: "Зимбабве",
};
var states$4 = {
  AU: {
    ACT: "Территория федеральной столицы",
    NSW: "Новый Южный Уэльс",
    NT: "Северная территория",
    QLD: "Квинсленд",
    SA: "Южная Австралия",
    TAS: "Тасмания",
    VIC: "Виктория",
    WA: "Западная Австралия",
  },
  BR: {
    AC: "Акри",
    AL: "Алагоас",
    AP: "Амапа",
    AM: "Амазонас",
    BA: "Баия",
    CE: "Сеара",
    DF: "Федеральный округ",
    ES: "Эспириту-Санто",
    GO: "Гояс",
    MA: "Мараньян",
    MT: "Мату-Гросу",
    MS: "Мату-Гросу-ду-Сул",
    MG: "Минас-Жерайс",
    PA: "Пара",
    PB: "Параиба",
    PR: "Парана",
    PE: "Пернамбуку",
    PI: "Пиауи",
    RJ: "Рио-де-Жанейро",
    RN: "Риу-Гранди-ду-Норти",
    RS: "Риу-Гранди-ду-Сул",
    RO: "Рондония",
    RR: "Рорайма",
    SC: "Санта-Катарина",
    SP: "Сан-Паулу",
    SE: "Сержипи",
    TO: "Токантинс",
  },
  CA: {
    AB: "Альберта",
    BC: "Британская Колумбия",
    MB: "Манитоба",
    NB: "Нью-Брансуик",
    NL: "Ньюфаундленд и Лабрадор",
    NT: "Северо-Западная Территория",
    NS: "Новая Шотландия",
    NU: "Нунавут",
    ON: "Онтарио",
    PE: "Остров Принца Эдуарда",
    QC: "Квебек",
    SK: "Саскачеван",
    YT: "Территории Юкон",
  },
  CN: {
    11: "Пекин",
    12: "Тяньцзинь",
    13: "Хэбэй",
    14: "Шаньси",
    15: "Внутренняя Монголия",
    21: "Ляонин",
    22: "Гирин",
    23: "Хейлунцзян",
    31: "Шанхай",
    32: "Цзянсу",
    33: "Чжэцзян",
    34: "Аньхой",
    35: "Фуцзянь",
    36: "Цзянси",
    37: "Шаньдун",
    41: "Хэнань",
    42: "Хубэй",
    43: "Хунань",
    44: "Гуандун",
    45: "Гуанси",
    46: "Хайнань",
    50: "Чунцин",
    51: "Сычуань",
    52: "Гуйчжоу",
    53: "Юньнань",
    54: "Сицзан",
    61: "Шэньси",
    62: "Ганьсу",
    63: "Цинхай",
    64: "Нинся",
    65: "Синьцзян",
    71: "Тайвань",
    91: "Гонконг",
    92: "Макао",
  },
  IN: {
    AN: "Андаманские и Никобарские острова",
    AP: "Андхра-Прадеш",
    AR: "Аруначал-Прадеш",
    AS: "Ассам",
    BR: "Бихар",
    CH: "Чандигарх",
    CT: "Чхаттисгарх",
    DN: "Дадра и Нагархавели",
    DD: "Даман и Диу",
    DL: "Дели",
    GA: "Гоа",
    GJ: "Гуджарат",
    HR: "Хариана",
    HP: "Химачал-Прадеш",
    JK: "Джамму и Кашмир",
    JH: "Джаркханд",
    KA: "Карнатака",
    KL: "Керала",
    LD: "Лакшадвип",
    MP: "Мадхья-Прадеш",
    MH: "Махараштра",
    MN: "Манипур",
    ML: "Мегхалая",
    MZ: "Мизорам",
    NL: "Нагаленд",
    OR: "Одиша",
    PY: "Пудуччери",
    PB: "Пенджаб",
    RJ: "Раджастхан",
    SK: "Сикким",
    TN: "Тамилнад",
    TG: "Телингана",
    TR: "Трипура",
    UT: "Уттаракханд",
    UP: "Уттар-Прадеш",
    WB: "Западная Бенгалия",
  },
  IE: {
    CW: "Карлоу",
    CN: "Каван",
    CE: "Клэр",
    CO: "Корк",
    DL: "Донегал",
    D: "Дублин",
    G: "Голуэй",
    KY: "Керри",
    KE: "Килдэр",
    KK: "Килкенни",
    LS: "Лиш",
    LM: "Лейтрим",
    LK: "Лимерик",
    LD: "Лонгфорд",
    LH: "Лаут",
    MO: "Майо",
    MH: "Мит",
    MN: "Монахан",
    OY: "Оффали",
    RN: "Роскоммон",
    SO: "Слиго",
    TA: "Типперери",
    WD: "Уотерфорд",
    WH: "Уэстмит",
    WX: "Вексфорд",
    WW: "Уиклоу",
  },
  IT: {
    AG: "Агридженто",
    AL: "Александрия",
    AN: "Анкона",
    AO: "Аоста",
    AR: "Ареццо",
    AP: "Асколи-Пичено",
    AT: "Асти",
    AV: "Авеллино",
    BA: "Бари",
    BT: "Барлетта-Андрия-Трани",
    BL: "Беллуно",
    BN: "Беневенто",
    BG: "Бергамо",
    BI: "Биелла",
    BO: "Болонья",
    BZ: "Больцано",
    BS: "Брешия",
    BR: "Бриндизи",
    CA: "Каглиари",
    CL: "Кальтанисетта",
    CB: "Кампобассо",
    CI: "Карбония-Иглезиас",
    CE: "Касерта",
    CT: "Катания",
    CZ: "Катандзаро",
    CH: "Кьети",
    CO: "Комо",
    CS: "Косенца",
    CR: "Кремона",
    KR: "Кротоне",
    CN: "Кунео",
    EN: "Энна",
    FM: "Фермо",
    FE: "Феррара",
    FI: "Флоренция",
    FG: "Фоджа",
    FC: "Форли-Чезена",
    FR: "Фрозиноне",
    GE: "Генуя",
    GO: "Гориция",
    GR: "Гроссето",
    IM: "Империя",
    IS: "Изерния",
    AQ: "Л'Акуила",
    SP: "Ла Специя",
    LT: "Латина",
    LE: "Лечче",
    LC: "Лекко",
    LI: "Ливорно",
    LO: "Лоди",
    LU: "Лукка",
    MC: "Масерата",
    MN: "Мантуя",
    MS: "Масса и Каррара",
    MT: "Матера",
    VS: "Медио-Кампидано",
    ME: "Мессина",
    MI: "Милан",
    MO: "Модена",
    MB: "Монца и Брианца",
    NA: "Неаполь",
    NO: "Новара",
    NU: "Нуоро",
    OG: "Ольястра",
    OT: "Ольбия-Темпьо",
    OR: "Ористано",
    PD: "Падуя",
    PA: "Пелермо",
    PR: "Парма",
    PV: "Павия",
    PG: "Перуджа",
    PU: "Пезаро и Урбино",
    PE: "Пескара",
    PC: "Пьяченца",
    PI: "Пиза",
    PT: "Пистоя",
    PN: "Порденоне",
    PZ: "Потенца",
    PO: "Прато",
    RG: "Рагуза",
    RA: "Равенна",
    RC: "Реджо-ди-Калабрия",
    RE: "Реджо-нель-Эмилия",
    RI: "Риети",
    RN: "Римини",
    RM: "Рим",
    RO: "Ровиго",
    SA: "Салерно",
    SS: "Сассари",
    SV: "Савона",
    SI: "Сиена",
    SO: "Сондрио",
    SR: "Сиракузы",
    TA: "Таранто",
    TE: "Терамо",
    TR: "Терни",
    TP: "Трапани",
    TN: "Тренто",
    TV: "Тревизо",
    TS: "Триест",
    TO: "Турин",
    UD: "Удине",
    VA: "Варесе",
    VE: "Венеция",
    VB: "Вербано-Кусио-Оссола",
    VC: "Верчелли",
    VR: "Верона",
    VV: "Вибо-Валентия",
    VI: "Виченца",
    VT: "Витербо",
  },
  MX: {
    AG: "Агуаскальентес",
    BC: "Байя-Калифорния",
    BS: "Байя-Калифорния Сур",
    CM: "Кампече",
    CS: "Чапас",
    CH: "Чиуауа",
    CO: "Коауила",
    CL: "Колима",
    DG: "Дуранго",
    DF: "Федеральный округ",
    GT: "Гуанахуато",
    GR: "Гуэрреро",
    HG: "Идальго",
    JA: "Халиско",
    ME: "Штат Мексика",
    MI: "Мичоакан",
    MO: "Морелос",
    NA: "Наярит",
    NL: "Нуэво-Леон",
    OA: "Оахака",
    PB: "Пуэбла",
    QE: "Керетаро",
    QR: "Квинтана-Роо",
    SL: "Сан-Луис-Потоси",
    SI: "Синалоа",
    SO: "Сонора",
    TB: "Табаско",
    TM: "Тамаулипас",
    TL: "Тлакскала",
    VE: "Веракрус",
    YU: "Юкатан",
    ZA: "Закатекас",
  },
  US: {
    AL: "Алабама",
    AK: "Аляска",
    AZ: "Аризона",
    AR: "Арканзас",
    CA: "Калифорния",
    CO: "Колорадо",
    CT: "Коннектикут",
    DE: "Делавэр",
    DC: "Округ Колумбия",
    FL: "Флорида",
    GA: "Грузия",
    HI: "Гавайи",
    ID: "Айдахо",
    IL: "Иллинойс",
    IN: "Индиана",
    IA: "Айова",
    KS: "Канзас",
    KY: "Кентукки",
    LA: "Луизиана",
    ME: "Мэн",
    MD: "Мэриленд",
    MA: "Массачусетс",
    MI: "Мичиган",
    MN: "Миннесота",
    MS: "Миссисипи",
    MO: "Миссури",
    MT: "Монтана",
    NE: "Небраска",
    NV: "Невада",
    NH: "Нью-Гемпшир",
    NJ: "Нью-Джерси",
    NM: "Нью-Мексико",
    NY: "Нью-Йорк",
    NC: "Северная Каролина",
    ND: "Северная Дакота",
    OH: "Огайо",
    OK: "Оклахома",
    OR: "Орегон",
    PA: "Пенсильвания",
    PR: "Пуэрто-Рико",
    RI: "Род-Айленд",
    SC: "Южная Каролина",
    SD: "Южная Дакота",
    TN: "Теннесси",
    TX: "Техас",
    UT: "Юта",
    VT: "Вермонт",
    VA: "Вирджиния",
    WA: "Вашингтон",
    WV: "Западная Вирджиния",
    WI: "Висконсин",
    WY: "Вайоминг",
  },
};
var ru = {
  status: status$4,
  progress: progress$4,
  fields: fields$4,
  buttons: buttons$4,
  errors: errors$4,
  countries: countries$4,
  states: states$4,
};

var status$3 = {
  loading: "Läser in...",
};
var progress$3 = {
  steps: "Steg %{currentStepNumber} av %{totalSteps}",
};
var fields$3 = {
  email: "E-post",
  country: "Land/Region",
  state: "Delstat/provins",
  first_name: "Förnamn",
  last_name: "Efternamn",
  company_name: "Företagsnamn",
  role: "Rollnamn",
  relationship: "Relation till Salesforce",
  required: "(obligatoriskt)",
  select_placeholder: "Välj ett alternativ",
};
var buttons$3 = {
  close: "Stäng",
  cancel: "Avbryt",
  save: "Spara",
  next: "Nästa",
  continue: "Fortsätt",
};
var errors$3 = {
  something_went_wrong: "Något gick fel, försök igen",
  fill_required_fields: "Fyll i de obligatoriska fälten innan du skickar iväg.",
};
var countries$3 = {
  AF: "Afghanistan",
  AX: "Åland",
  AL: "Albanien",
  DZ: "Algeriet",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua och Barbuda",
  AR: "Argentina",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Österrike",
  AZ: "Azerbajdzjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Vitryssland",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia (mångnationella staten)",
  BQ: "Karibiska Nederländerna",
  BA: "Bosnien och Hercegovina",
  BW: "Botswana",
  BV: "Bouvetön",
  BR: "Brasilien",
  IO: "Brittiska territoriet i Indiska Oceanen",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodja",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KY: "Caymanöarna",
  CF: "Centralafrikanska republiken",
  TD: "Tchad",
  CL: "Chile",
  CN: "Kina",
  CX: "Julöarna",
  CC: "Kokosöarna",
  CO: "Colombia",
  KM: "Komorerna",
  CG: "Kongo",
  CD: "Kongo (demokratiska republiken)",
  CK: "Cooköarna",
  CR: "Costa Rica",
  CI: "Elfenbenskusten",
  HR: "Kroatien",
  CW: "Curaçao",
  CY: "Cypern",
  CZ: "Tjeckiska Republiken",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikanska republiken",
  EC: "Ecuador",
  EG: "Egypten",
  SV: "El Salvador",
  GQ: "Ekvatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopien",
  FK: "Falklandsöarna (Malvinas)",
  FO: "Färöarna",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrike",
  GF: "Franska Guyana",
  PF: "Franska Polynesien",
  TF: "Franska sydterritorierna",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grekland",
  GL: "Grönland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard- och McDonaldsöarna",
  VA: "Vatikanstaten",
  HK: "Hongkong",
  HN: "Honduras",
  HU: "Ungern",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IQ: "Irak",
  IE: "Irland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanien",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Korea (republiken)",
  KW: "Kuwait",
  KG: "Kirgizistan",
  LA: "Laos (demokratiska folkrepubliken)",
  LV: "Lettland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao",
  MK: "Makedonien (tidigare jugoslaviska republiken)",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldiverna",
  ML: "Mali",
  MT: "Malta",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexiko",
  MD: "Moldavien (republiken)",
  MC: "Monaco",
  MN: "Mongoliet",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marocko",
  MZ: "Moçambique",
  MM: "Burma",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederländerna",
  NC: "Nya Kaledonien",
  NZ: "Nya Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkön",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papua Nya Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinerna",
  PN: "Pitcairnöarna",
  PL: "Polen",
  PT: "Portugal",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Rumänien",
  RU: "Ryska federationen",
  RW: "Rwanda",
  BL: "Saint-Barthélemy",
  SH: "Sankta Helena",
  KN: "Saint Kitts och Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (fransk del)",
  PM: "Saint Pierre och Miquelon",
  VC: "Saint Vincent och Grenadinerna",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tomé och Principe",
  SA: "Saudiarabien",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellerna",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (holländska delen)",
  SK: "Slovakien",
  SI: "Slovenien",
  SB: "Solomonöarna",
  SO: "Somalia",
  ZA: "Sydafrika",
  GS: "Sydgeorgien och Sydsandwichöarna",
  SS: "Sydsudan",
  ES: "Spanien",
  LK: "Sri Lanka",
  SR: "Surinam",
  SJ: "Svalbard och Jan Mayen",
  SZ: "Swaziland",
  SE: "Sverige",
  CH: "Schweiz",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: "Tanzania (förenade republiken)",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad och Tobago",
  TN: "Tunisien",
  TR: "Turkiet",
  TM: "Turkmenistan",
  TC: "Turks- och Caiscosöarna",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Förenade Arabemiraten",
  GB: "Storbritannien",
  US: "USA",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela (Bolivarianska republiken)",
  VN: "Vietnam",
  VG: "Brittiska Jungfruöarna",
  WF: "Wallis- och Futunaöarna",
  EH: "Västsahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
var states$3 = {
  AU: {
    ACT: "Australian Capital Territory",
    NSW: "New South Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "South Australia",
    TAS: "Tasmanien",
    VIC: "Victoria",
    WA: "Western Australia",
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  },
  CA: {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland och Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edvards ö",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon Territories",
  },
  CN: {
    11: "Peking",
    12: "Tianjin",
    13: "Hebei",
    14: "Shanxi",
    15: "Inre Mongoliet",
    21: "Liaoning",
    22: "Jilin",
    23: "Heilongjiang",
    31: "Shanghai",
    32: "Jiangsu",
    33: "Zhejiang",
    34: "Anhui",
    35: "Fujian",
    36: "Jiangxi",
    37: "Shandong",
    41: "Henan",
    42: "Hubei",
    43: "Hunan",
    44: "Guangdong",
    45: "Guangxi",
    46: "Hainan",
    50: "Chongqing",
    51: "Sichuan",
    52: "Guizhou",
    53: "Yunnan",
    54: "Xizang",
    61: "Shaanxi",
    62: "Gansu",
    63: "Qinghai",
    64: "Ningxia",
    65: "Xinjiang",
    71: "Taiwan",
    91: "Hongkong",
    92: "Macao",
  },
  IN: {
    AN: "Andamanerna och Nicobarerna",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra och Nagar Haveli",
    DD: "Daman och Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu och Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UT: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "West Bengal",
  },
  IE: {
    CW: "Carlow",
    CN: "Cavan",
    CE: "Clare",
    CO: "Cork",
    DL: "Donegal",
    D: "Dublin",
    G: "Galway",
    KY: "Kerry",
    KE: "Kildare",
    KK: "Kilkenny",
    LS: "Laois",
    LM: "Leitrim",
    LK: "Limerick",
    LD: "Longford",
    LH: "Louth",
    MO: "Mayo",
    MH: "Meath",
    MN: "Monaghan",
    OY: "Offaly",
    RN: "Roscommon",
    SO: "Sligo",
    TA: "Tipperary",
    WD: "Waterford",
    WH: "Westmeath",
    WX: "Wexford",
    WW: "Wicklow",
  },
  IT: {
    AG: "Agrigento",
    AL: "Alessandria",
    AN: "Ancona",
    AO: "Aosta",
    AR: "Arezzo",
    AP: "Ascoli Piceno",
    AT: "Asti",
    AV: "Avellino",
    BA: "Bari",
    BT: "Barletta-Andria-Trani",
    BL: "Belluno",
    BN: "Benevento",
    BG: "Bergamo",
    BI: "Biella",
    BO: "Bologna",
    BZ: "Bolzano",
    BS: "Brescia",
    BR: "Brindisi",
    CA: "Cagliari",
    CL: "Caltanissetta",
    CB: "Campobasso",
    CI: "Carbonia-Iglesias",
    CE: "Caserta",
    CT: "Catania",
    CZ: "Catanzaro",
    CH: "Chieti",
    CO: "Como",
    CS: "Cosenza",
    CR: "Cremona",
    KR: "Crotone",
    CN: "Cuneo",
    EN: "Enna",
    FM: "Fermo",
    FE: "Ferrara",
    FI: "Florens",
    FG: "Foggia",
    FC: "Forlì-Cesena",
    FR: "Frosinone",
    GE: "Genoa",
    GO: "Gorizia",
    GR: "Grosseto",
    IM: "Imperia",
    IS: "Isernia",
    AQ: "L'Aquila",
    SP: "La Spezia",
    LT: "Latina",
    LE: "Lecce",
    LC: "Lecco",
    LI: "Livorno",
    LO: "Lodi",
    LU: "Lucca",
    MC: "Macerata",
    MN: "Mantua",
    MS: "Massa och Carrara",
    MT: "Matera",
    VS: "Medio Campidano",
    ME: "Messina",
    MI: "Milano",
    MO: "Modena",
    MB: "Monza och Brianza",
    NA: "Neapel",
    NO: "Novara",
    NU: "Nuoro",
    OG: "Ogliastra",
    OT: "Olbia-Tempio",
    OR: "Oristano",
    PD: "Padua",
    PA: "Palermo",
    PR: "Parma",
    PV: "Pavia",
    PG: "Perugia",
    PU: "Pesaro och Urbino",
    PE: "Pescara",
    PC: "Piacenza",
    PI: "Pisa",
    PT: "Pistoia",
    PN: "Pordenone",
    PZ: "Potenza",
    PO: "Prato",
    RG: "Ragusa",
    RA: "Ravenna",
    RC: "Reggio Calabria",
    RE: "Reggio Emilia",
    RI: "Rieti",
    RN: "Rimini",
    RM: "Rom",
    RO: "Rovigo",
    SA: "Salerno",
    SS: "Sassari",
    SV: "Savona",
    SI: "Siena",
    SO: "Sondrio",
    SR: "Syrakusa",
    TA: "Taranto",
    TE: "Teramo",
    TR: "Terni",
    TP: "Trapani",
    TN: "Trento",
    TV: "Treviso",
    TS: "Trieste",
    TO: "Turin",
    UD: "Udine",
    VA: "Varese",
    VE: "Venedig",
    VB: "Verbano-Cusio-Ossola",
    VC: "Vercelli",
    VR: "Verona",
    VV: "Vibo Valentia",
    VI: "Vicenza",
    VT: "Viterbo",
  },
  MX: {
    AG: "Aguascalientes",
    BC: "Baja California",
    BS: "Baja California Sur",
    CM: "Campeche",
    CS: "Chiapas",
    CH: "Chihuahua",
    CO: "Coahuila",
    CL: "Colima",
    DG: "Durango",
    DF: "Federalt distrikt",
    GT: "Guanajuato",
    GR: "Guerrero",
    HG: "Hidalgo",
    JA: "Jalisco",
    ME: "Mexiko delstat",
    MI: "Michoacán",
    MO: "Morelos",
    NA: "Nayarit",
    NL: "Nuevo León",
    OA: "Oaxaca",
    PB: "Puebla",
    QE: "Querétaro",
    QR: "Quintana Roo",
    SL: "San Luis Potosí",
    SI: "Sinaloa",
    SO: "Sonora",
    TB: "Tabasco",
    TM: "Tamaulipas",
    TL: "Tlaxcala",
    VE: "Veracruz",
    YU: "Yucatán",
    ZA: "Zacatecas",
  },
  US: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgien",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
};
var sv = {
  status: status$3,
  progress: progress$3,
  fields: fields$3,
  buttons: buttons$3,
  errors: errors$3,
  countries: countries$3,
  states: states$3,
};

var status$2 = {
  loading: "กำลังโหลด…",
};
var progress$2 = {
  steps: "ขั้นตอนที่ %{currentStepNumber} จาก %{totalSteps}",
};
var fields$2 = {
  email: "อีเมล",
  country: "ประเทศ/ภูมิภาค",
  state: "รัฐ/จังหวัด",
  first_name: "ชื่อ",
  last_name: "นามสกุล",
  company_name: "ชื่อบริษัท",
  role: "ชื่อบทบาท",
  relationship: "ความสัมพันธ์กับ Salesforce",
  required: "(จำเป็น)",
  select_placeholder: "เลือกหนึ่งตัวเลือก",
};
var buttons$2 = {
  close: "ปิด",
  cancel: "ยกเลิก",
  save: "บันทึก",
  next: "ถัดไป",
  continue: "ดำเนินการต่อ",
};
var errors$2 = {
  something_went_wrong: "มีบางอย่างไม่ถูกต้อง โปรดลองอีกครั้งโปรดลองอีกครั้ง",
  fill_required_fields: "โปรดกรอกข้อมูลลงในฟิลด์ที่กำหนดก่อนส่ง",
};
var countries$2 = {
  AF: "อัฟกานิสถาน",
  AX: "หมู่เกาะโอลันด์",
  AL: "แอลเบเนีย",
  DZ: "แอลจีเรีย",
  AD: "อันดอร์รา",
  AO: "แองโกลา",
  AI: "แองกวิลลา",
  AQ: "แอนตาร์กติกา",
  AG: "แอนติกาและบาร์บูดา",
  AR: "อาร์เจนตินา",
  AM: "อาร์เมเนีย",
  AW: "อารูบา",
  AU: "ออสเตรเลีย",
  AT: "ออสเตรีย",
  AZ: "อาเซอร์ไบจาน",
  BS: "บาฮามาส",
  BH: "บาห์เรน",
  BD: "บังกลาเทศ",
  BB: "บาร์เบโดส",
  BY: "เบลารุส",
  BE: "เบลเยียม",
  BZ: "เบลีช",
  BJ: "เบนิน",
  BM: "เบอร์มิวดา",
  BT: "ภูฏาน",
  BO: "รัฐพหุชนชาติแห่งโบลิเวีย",
  BQ: "โบแนร์ ซินท์อุสตาทิอุส และซาบา",
  BA: "บอสเนียและเฮอร์เซโกวีนา",
  BW: "บอตสวานา",
  BV: "เกาะบูเวต์",
  BR: "บราซิล",
  IO: "บริติชอินเดียนโอเชียนเทร์ริทอรี",
  BN: "บรูไนดารุสซาลาม",
  BG: "บัลแกเรีย",
  BF: "บูร์กินาฟาโซ",
  BI: "บุรุนดี",
  KH: "กัมพูชา",
  CM: "แคเมอรูน",
  CA: "แคนาดา",
  CV: "เคปเวิร์ด",
  KY: "หมู่เกาะเคย์แมน",
  CF: "สาธารณรัฐแอฟริกากลาง",
  TD: "ชาด",
  CL: "ชิลี",
  CN: "จีน",
  CX: "เกาะคริสต์มาส",
  CC: "หมู่เกาะโคคอส (คีลลิง)",
  CO: "โคลัมเบีย",
  KM: "คอโมโรส",
  CG: "คองโก",
  CD: "สาธารณรัฐประชาธิปไตยคองโก",
  CK: "หมู่เกาะคุก",
  CR: "คอสตาริกา",
  CI: "โกตดิวัวร์",
  HR: "โครเอเชีย",
  CW: "คูราโซ",
  CY: "ไซปรัส",
  CZ: "สาธารณรัฐเช็ก",
  DK: "เดนมาร์ก",
  DJ: "จิบูตี",
  DM: "โดมินิกา",
  DO: "สาธารณรัฐโดมินิกัน",
  EC: "เอกวาดอร์",
  EG: "อียิปต์",
  SV: "เอลซัลวาดอร์",
  GQ: "อิเควทอเรียลกินี",
  ER: "เอริเทรีย",
  EE: "เอสโตเนีย",
  ET: "เอธิโอเปีย",
  FK: "หมู่เกาะฟอล์คแลนด์ (มัลวินัส)",
  FO: "หมู่เกาะแฟโร",
  FJ: "ฟิจิ",
  FI: "ฟินแลนด์",
  FR: "ฝรั่งเศส",
  GF: "เฟรนช์กียานา",
  PF: "เฟรนช์โปลินีเซีย",
  TF: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์",
  GA: "กาบอง",
  GM: "แกมเบีย",
  GE: "จอร์เจีย",
  DE: "เยอรมนี",
  GH: "กานา",
  GI: "ยิบรอลตาร์",
  GR: "กรีซ",
  GL: "กรีนแลนด์",
  GD: "เกรเนดา",
  GP: "กวาเดอลูป",
  GT: "กัวเตมาลา",
  GG: "เกอร์นเซย์",
  GN: "กินี",
  GW: "กินี-บิสเซา",
  GY: "กายอานา",
  HT: "เฮติ",
  HM: "เกาะเฮิร์ตและหมู่เกาะแมกดอนัลด์",
  VA: "สังฆมณฑลศักดิ์สิทธิ์ (นครรัฐวาติกัน)",
  HK: "ฮ่องกง",
  HN: "ฮอนดูรัส",
  HU: "ฮังการี",
  IS: "ไอซ์แลนด์",
  IN: "อินเดีย",
  ID: "อินโดนีเซีย",
  IQ: "อิรัก",
  IE: "ไอร์แลนด์",
  IM: "เกาะแมน",
  IL: "อิสราเอล",
  IT: "อิตาลี",
  JM: "จาเมกา",
  JP: "ญี่ปุ่น",
  JE: "เจอร์ซี",
  JO: "จอร์แดน",
  KZ: "คาซัคสถาน",
  KE: "เคนยา",
  KI: "คิริบาส",
  KR: "สาธารณรัฐเกาหลี",
  KW: "คูเวต",
  KG: "คีร์กีซสถาน",
  LA: "สาธารณรัฐประชาธิปไตยประชาชนลาว",
  LV: "ลัตเวีย",
  LB: "เลบานอน",
  LS: "เลโซโท",
  LR: "ไลบีเรีย",
  LY: "ลิเบีย",
  LI: "ลิกเตนสไตน์",
  LT: "ลิทัวเนีย",
  LU: "ลักเซมเบิร์ก",
  MO: "มาเก๊า",
  MK: "สาธารณรัฐมาซิโดเนีย (ยูโกสลาเวียเดิม)",
  MG: "มาดากัสการ์",
  MW: "มาลาวี",
  MY: "มาเลเซีย",
  MV: "มัลดีฟส์",
  ML: "มาลี",
  MT: "มอลตา",
  MQ: "มาร์ตินีก",
  MR: "มอริเตเนีย",
  MU: "มอริเชียส",
  YT: "มายอต",
  MX: "เม็กซิโก",
  MD: "สาธารณรัฐมอลโดวา",
  MC: "โมนาโก",
  MN: "มองโกเลีย",
  ME: "มอนเตเนโกร",
  MS: "มอนต์เซอร์รัต",
  MA: "โมร็อกโก",
  MZ: "โมซัมบิก",
  MM: "พม่า",
  NA: "นามิเบีย",
  NR: "นาอูรู",
  NP: "เนปาล",
  NL: "เนเธอร์แลนด์",
  NC: "นิวแคลิโดเนีย",
  NZ: "นิวซีแลนด์",
  NI: "นิการากัว",
  NE: "ไนเจอร์",
  NG: "ไนจีเรีย",
  NU: "นีอูเอ",
  NF: "เกาะนอร์ฟอล์ก",
  NO: "นอร์เวย์",
  OM: "โอมาน",
  PK: "ปากีสถาน",
  PS: "ปาเลสไตน์",
  PA: "ปานามา",
  PG: "ปาปัวนิวกีนี",
  PY: "ปารากวัย",
  PE: "เปรู",
  PH: "ฟิลิปปินส์",
  PN: "พิตแคร์น",
  PL: "โปแลนด์",
  PT: "โปรตุเกส",
  QA: "กาตาร์",
  RE: "เรอูเนียง",
  RO: "โรมาเนีย",
  RU: "สหพันธรัฐรัสเซีย",
  RW: "รวันดา",
  BL: "แซ็งบาร์เตเลอมี",
  SH: "เซนต์เฮเลนา แอสเซนชัน และตริสตันดากูนยา",
  KN: "เซนต์คิตส์และเนวิส",
  LC: "เซนต์ลูเซีย",
  MF: "แซ็งมาร์แต็ง (อาณานิคมของฝรั่งเศส)",
  PM: "แซงปีแยร์และมีเกอลง",
  VC: "เซนต์วินเซนต์และเกรนาดีนส์",
  WS: "ซามัว",
  SM: "ซานมารีโน",
  ST: "เซาตูเมและปรินซิปี",
  SA: "ซาอุดิอาราเบีย",
  SN: "เซเนกัล",
  RS: "เซอร์เบีย",
  SC: "เซเชลส์",
  SL: "เซียร์ราลีโอน",
  SG: "สิงคโปร์",
  SX: "ซินท์มาร์เทิน (ดินแดนของเนเธอร์แลนด์)",
  SK: "สโลวัก",
  SI: "สโลวีเนีย",
  SB: "หมู่เกาะโซโลมอน",
  SO: "โซมาเลีย",
  ZA: "แอฟริกาใต้",
  GS: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช",
  SS: "ซูดานใต้",
  ES: "สเปน",
  LK: "ศรีลังกา",
  SR: "ซูรินาเม",
  SJ: "ฟาลบาร์และยานไมเอน",
  SZ: "สวาซิแลนด์",
  SE: "สวีเดน",
  CH: "สวิตเซอร์แลนด์",
  TW: "ไต้หวัน",
  TJ: "ทาจิกิสถาน",
  TZ: "สหสาธารณรัฐแทนซาเนีย",
  TH: "ไทย",
  TL: "ติมอร์-เลสเต",
  TG: "โตโก",
  TK: "โตเกเลา",
  TO: "ตองกา",
  TT: "ตรินิแดดและโตเบโก",
  TN: "ตูนิเซีย",
  TR: "ตุรกี",
  TM: "เติร์กเมนิสถาน",
  TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
  TV: "ตูวาลู",
  UG: "ยูกันดา",
  UA: "ยูเครน",
  AE: "สหรัฐอาหรับเอมิเรตส์",
  GB: "สหราชอาณาจักร",
  US: "สหรัฐอเมริกา",
  UY: "อุรุกวัย",
  UZ: "อุซเบกิสถาน",
  VU: "วานูอาตู",
  VE: "สาธารณรัฐโบลีวาร์แห่งเวเนซุเอลา",
  VN: "เวียดนาม",
  VG: "หมู่เกาะบริติชเวอร์จิน",
  WF: "วาลลิสและฟุตูนา",
  EH: "ซาฮาราตะวันตก",
  YE: "เยเมน",
  ZM: "แซมเบีย",
  ZW: "ซิมบับเว",
};
var states$2 = {
  AU: {
    ACT: "เขตเมืองหลวงของออสเตรเลีย",
    NSW: "นิวเซาท์เวลส์",
    NT: "นอร์เทิร์นเทร์ริทอรี",
    QLD: "ควีนส์แลนด์",
    SA: "เซาท์ออสเตรเลีย",
    TAS: "ทัสมาเนีย",
    VIC: "วิกตอเรีย",
    WA: "เวสเทิร์นออสเตรเลีย",
  },
  BR: {
    AC: "อาเกร",
    AL: "อาลาโกอัส",
    AP: "อะมาปา",
    AM: "อามาโซนัส",
    BA: "บาเยีย",
    CE: "เซรา",
    DF: "เฟเดอรัลดิสตริกต์ (บราซเลีย)",
    ES: "เอสพิริโตซานโต",
    GO: "โกยาส",
    MA: "มารันเยา",
    MT: "มาร์ตูโกรสซู",
    MS: "มาร์ตูโกรสซูโดซูล",
    MG: "มีนัสเชไรส์",
    PA: "พารา",
    PB: "พาไรบา",
    PR: "พารานา",
    PE: "เปร์นัมบูกู",
    PI: "เปียอู",
    RJ: "รีโอเดจาเนโร",
    RN: "รีโอกรันดีโดนอร์เต",
    RS: "รีโอกรันดีโดซูล",
    RO: "โรโดนยา",
    RR: "รอไรมา",
    SC: "ซันตากาตารีนา",
    SP: "เซาเปาโล",
    SE: "เซร์ซิเป",
    TO: "โตกันตินส์",
  },
  CA: {
    AB: "อัลแบร์ตา",
    BC: "บริติชโคลัมเบีย",
    MB: "มานิโตบา",
    NB: "นิวบรุนสวิค",
    NL: "นิวฟาวนด์แลนด์แอนด์แลบราดอร์",
    NT: "นอร์ทเวสต์เทร์ริทอรีส์",
    NS: "โนวาสโกเชีย",
    NU: "นูนาวุต",
    ON: "ออนตาริโอ",
    PE: "พรินซ์ เอ็ดเวิร์ด ไอร์แลนด์",
    QC: "ควิเบก",
    SK: "ซัสแคตเชวัน",
    YT: "ยูคอนเทร์ริทอรีส์",
  },
  CN: {
    11: "ปักกิ่ง",
    12: "เทียนจิน",
    13: "เหอเป่ย์",
    14: "ชานซี",
    15: "มองโกเลียใน",
    21: "เหลียวหนิง",
    22: "จี๋หลิน",
    23: "เฮย์หลงเจียง",
    31: "เซี่ยงไฮ้",
    32: "เจียงซู",
    33: "เจ้อเจียง",
    34: "อานฮุย",
    35: "ฝูเจี้ยน",
    36: "เจียงซี",
    37: "ชานตง",
    41: "เหอหนาน",
    42: "หูเป่ย์",
    43: "หูหนาน",
    44: "กวางตุ้ง",
    45: "กวางสี",
    46: "ไหหลำ",
    50: "ฉงชิ่ง",
    51: "เสฉวน",
    52: "กุ้ยโจว",
    53: "ยูนนาน",
    54: "ทิเบต",
    61: "ฉ่านซี",
    62: "กานซู",
    63: "ซิงไฮ",
    64: "หนิงเซี่ย",
    65: "ซินเจียง",
    71: "ไต้หวัน",
    91: "ฮ่องกง",
    92: "มาเก๊า",
  },
  IN: {
    AN: "หมู่เกาะอันดามันและนิโครบาร์",
    AP: "อานธรประเทศ",
    AR: "อรุณาจัลประเทศ",
    AS: "อัสสัม",
    BR: "พิหาร",
    CH: "ฉานดิรา",
    CT: "ฉัตติสครห์",
    DN: "ดาดราและนครหเวลี",
    DD: "ดามันและดีอู",
    DL: "เดลลี",
    GA: "กัว",
    GJ: "คุชราต",
    HR: "หรยาณา",
    HP: "หิมาจัลประเทศ",
    JK: "ชัมมูร์และกัศมีร์",
    JH: "ฌาร์ขัณฑ์",
    KA: "กรณาฏกะ",
    KL: "เกรละ",
    LD: "ลักษทวีป",
    MP: "มัธยประเทศ",
    MH: "มหาราษฏระ",
    MN: "มณีปุระ",
    ML: "เมฆาลัย",
    MZ: "มิโซรัม",
    NL: "นาคาแลนด์",
    OR: "โอริสสา",
    PY: "ปุทุจเจจี",
    PB: "ปัญจาบ",
    RJ: "ราชสถาน",
    SK: "สิกขิม",
    TN: "ทมิฬนาฑู",
    TG: "Telangana",
    TR: "ตริปุระ",
    UT: "อุตตราขัณฑ์",
    UP: "อุตตรประเทศ",
    WB: "เบงกอลตะวันตก",
  },
  IE: {
    CW: "คาร์ลอ",
    CN: "คาวาน",
    CE: "แคลร์",
    CO: "คอร์ก",
    DL: "โดเนกัล",
    D: "ดับบลิน",
    G: "กัลเวย์",
    KY: "เคอรี",
    KE: "คิลแดร์",
    KK: "คิลเคนนี",
    LS: "ลาโออิส",
    LM: "ไลอิทริม",
    LK: "ลิมริค",
    LD: "ลองฟอร์ด",
    LH: "เลาท์",
    MO: "มาโย",
    MH: "มีธ",
    MN: "โมนากาน",
    OY: "ออฟาลี",
    RN: "รอสคอมมอน",
    SO: "สลิโก",
    TA: "ทิเพรารี",
    WD: "วอเตอร์ฟอร์ด",
    WH: "เวสท์มีธ",
    WX: "เว็กซ์ฟอร์",
    WW: "วิกลอ",
  },
  IT: {
    AG: "อากริเจนโต",
    AL: "อเลสซานเดรีย",
    AN: "อันโกนา",
    AO: "เฮาสตา",
    AR: "อาเรซโซ",
    AP: "อัสโกลี ปิเชโน",
    AT: "อัสตี",
    AV: "อเวลลิโน่",
    BA: "บารี",
    BT: "บาร์เล็ตตา-อันเดรีย-ทานิ",
    BL: "เบลลูโน",
    BN: "เบเนเวนโต",
    BG: "เบอร์กาโม",
    BI: "บิเอลลา",
    BO: "โบลอนยา",
    BZ: "โบลซาโน",
    BS: "เบรสเชีย",
    BR: "บรินดิซิ",
    CA: "แคลิอาริ",
    CL: "คาลตานิสเซตตา",
    CB: "คัมโปบาสโซ",
    CI: "การ์โบเนีย-อีเกลเซียส",
    CE: "คาแซร์ตา",
    CT: "คาตาเนีย",
    CZ: "คาตันซาโร",
    CH: "เชียติ",
    CO: "โคโม",
    CS: "โคเซนซา",
    CR: "ครีโมนา",
    KR: "โครโทน",
    CN: "คูนีโอ",
    EN: "เอ็นนา",
    FM: "แฟร์โม",
    FE: "เฟอร์รารา",
    FI: "ฟลอเรนซ์",
    FG: "ฟอจจา",
    FC: "ฟอร์ลิ-เชเซน่า",
    FR: "โฟรซิโนเน่",
    GE: "เจนัว",
    GO: "โกรีเซีย",
    GR: "กรอสเซตโต",
    IM: "อิมเปเรีย",
    IS: "ไอเซอร์เนีย",
    AQ: "ลากวีลา",
    SP: "ลาสเปซเซีย",
    LT: "ลาตินา",
    LE: "เลชเช่",
    LC: "เลกโก",
    LI: "ลิวอร์โน",
    LO: "โลดิ",
    LU: "ลุคกา",
    MC: "มาเซเรตา",
    MN: "มานตัว",
    MS: "มาสซ่าและคาร์ราร่า",
    MT: "มาเทรา",
    VS: "เมดีโอกัมปีดาโน",
    ME: "เมสซินา",
    MI: "มิลาน",
    MO: "โมเดนา",
    MB: "มอนซาและบริอันซา",
    NA: "เนเปิลส์",
    NO: "โนวารา",
    NU: "นูออโร",
    OG: "โอลยัสตรา",
    OT: "ออลเบีย-เตมปีโอ",
    OR: "โอริสตาโน",
    PD: "แพดัว",
    PA: "พาเลอโม",
    PR: "พาร์มา",
    PV: "พาเวีย",
    PG: "พารูเจีย",
    PU: "ปีซาโรและอูร์บีโน",
    PE: "เปสการา",
    PC: "เพียเชนซา",
    PI: "ปิซ่า",
    PT: "ปิสโตยา",
    PN: "ปอร์เดโนเน่",
    PZ: "โปเตนซา",
    PO: "ปราโต",
    RG: "รากูซา",
    RA: "ราเวนนา",
    RC: "เรจโจกาลาเบรีย",
    RE: "เรจโจเอมิเลีย",
    RI: "ริเอติ",
    RN: "ริมินิ",
    RM: "โรม",
    RO: "โรวีโก",
    SA: "ซาเลอร์โน",
    SS: "ซัสซารี",
    SV: "ซาวอนา",
    SI: "ซิเอนา",
    SO: "โซนดริโอ",
    SR: "ซีราคิวส์",
    TA: "ตารันโต",
    TE: "เตราโม",
    TR: "เตอร์นิ",
    TP: "ตราปานิ",
    TN: "เตรนโต",
    TV: "เตรวิโซ",
    TS: "ตรีเอสเต",
    TO: "ตูริน",
    UD: "อูดิเน",
    VA: "วาเรเซ",
    VE: "เวนิส",
    VB: "เวอบาโน-คูซิโอ-ออสโซลา",
    VC: "เวอเชลลิ",
    VR: "เวโรนา",
    VV: "วีโบ วาเลเตีย",
    VI: "วิเชนซา",
    VT: "วิแตร์โบ",
  },
  MX: {
    AG: "อากวัสกาเลียนเตส",
    BC: "บาฮากาลิฟอร์เนีย",
    BS: "บาฮากาลิฟอร์เนียซูร์",
    CM: "กัมเปเช",
    CS: "เชียปัส",
    CH: "ชีวาวา",
    CO: "โกอาวีลา",
    CL: "โกลีมา",
    DG: "ดูรังโก",
    DF: "เฟเดอรัลดิสตริกต์",
    GT: "กวานาคัวโต",
    GR: "เกร์เรโร",
    HG: "อีดัลโก",
    JA: "ฮาลิสโก",
    ME: "เม็กซิโก",
    MI: "มิโชอากัง",
    MO: "มอเรโลส",
    NA: "นายาริต",
    NL: "นวยโวเลออง",
    OA: "วาฮากา",
    PB: "ปวยบลา",
    QE: "เกเรตาโร",
    QR: "กินตานาโร",
    SL: "ซันลุยส์โปโตซี",
    SI: "ซีนาโลอา",
    SO: "โซโนรา",
    TB: "ตาบัสโก",
    TM: "ตาเมาลีปัส",
    TL: "ตลัซกาลา",
    VE: "เวรากรูซ",
    YU: "ยูกาตัง",
    ZA: "ซากาเตกัส",
  },
  US: {
    AL: "อลาบามา",
    AK: "อลาสก้า",
    AZ: "อะริโซนา",
    AR: "อาร์คันซัส",
    CA: "แคลิฟอร์เนีย",
    CO: "โคโลราโด",
    CT: "คอนเน็กติกัต",
    DE: "เดลาแวร์",
    DC: "ดิสตริกออฟโคลัมเบีย",
    FL: "ฟลอริดา",
    GA: "จอร์เจีย",
    HI: "ฮาวาย",
    ID: "ไอดาโฮ",
    IL: "อิลลินอยส์",
    IN: "อินเดียน่า",
    IA: "ไอโอวา",
    KS: "แคนซัส",
    KY: "เคนตั๊กกี้",
    LA: "หลุยเซียนา",
    ME: "เมน",
    MD: "แมรี่แลนด์",
    MA: "แมสซาชูเซตต์",
    MI: "มิชิแกน",
    MN: "มินเนโซตา",
    MS: "มิสซิสซิปปี้",
    MO: "มิสซูรี",
    MT: "มอนตานา",
    NE: "เนบราสกา",
    NV: "เนวาดา",
    NH: "นิวแฮมเชียร์",
    NJ: "นิวเจอร์ซีย์",
    NM: "นิวเม็กซิโก",
    NY: "นิวยอร์ค",
    NC: "นอร์ธแคโรไลนา",
    ND: "นอร์ธดาโกต้า",
    OH: "โอไฮโอ",
    OK: "โอกลาโฮมา",
    OR: "โอเรกอน",
    PA: "เพนซิลเวเนีย",
    PR: "เปอร์โตริโก",
    RI: "โรดไอร์แลนด์",
    SC: "เซาธ์แคโรไลนา",
    SD: "เซาธ์ดาโกต้า",
    TN: "เทนเนสซี",
    TX: "เท็กซัส",
    UT: "ยูท่าห์",
    VT: "เวอร์มองต์",
    VA: "เวอร์จิเนีย",
    WA: "วอชิงตัน",
    WV: "เวสต์เวอร์จิเนีย",
    WI: "วิสคอนซิน",
    WY: "ไวโอมิง",
  },
};
var th = {
  status: status$2,
  progress: progress$2,
  fields: fields$2,
  buttons: buttons$2,
  errors: errors$2,
  countries: countries$2,
  states: states$2,
};

var status$1 = {
  loading: "正在加载...",
};
var progress$1 = {
  steps: "第 %{currentStepNumber} 步，共 %{totalSteps} 步",
};
var fields$1 = {
  email: "电子邮件",
  country: "国家/地区",
  state: "州/省",
  first_name: "名",
  last_name: "姓",
  company_name: "公司名称",
  role: "角色名称",
  relationship: "与 Salesforce 的关系",
  required: "（必填项）",
  select_placeholder: "选择一个选项",
};
var buttons$1 = {
  close: "关闭",
  cancel: "取消",
  save: "保存",
  next: "下一步",
  continue: "继续",
};
var errors$1 = {
  something_went_wrong: "出错了，请重试",
  fill_required_fields: "请填写所有必填字段后再提交。",
};
var countries$1 = {
  AF: "阿富汗",
  AX: "奥兰群岛",
  AL: "阿尔巴尼亚",
  DZ: "阿尔及利亚",
  AD: "安道尔",
  AO: "安哥拉",
  AI: "安圭拉",
  AQ: "南极洲",
  AG: "安提瓜和巴布达",
  AR: "阿根廷",
  AM: "亚美尼亚",
  AW: "阿鲁巴",
  AU: "澳大利亚",
  AT: "奥地利",
  AZ: "阿塞拜疆",
  BS: "巴哈马",
  BH: "巴林",
  BD: "孟加拉国",
  BB: "巴巴多斯",
  BY: "白俄罗斯",
  BE: "比利时",
  BZ: "伯利兹",
  BJ: "贝宁",
  BM: "百慕大",
  BT: "不丹",
  BO: "玻利維亞多民族国",
  BQ: "博奈尔、圣尤斯特歇斯和萨巴",
  BA: "波黑",
  BW: "博茨瓦纳",
  BV: "布韦岛",
  BR: "巴西",
  IO: "英属印度洋领地",
  BN: "文莱达鲁萨兰国",
  BG: "保加利亚",
  BF: "布基纳法索",
  BI: "布隆迪",
  KH: "柬埔寨",
  CM: "喀麦隆",
  CA: "加拿大",
  CV: "佛得角",
  KY: "开曼群岛",
  CF: "中非共和国",
  TD: "乍得",
  CL: "智利",
  CN: "中国",
  CX: "圣诞岛",
  CC: "科科斯(基林)群岛",
  CO: "哥伦比亚",
  KM: "科摩罗",
  CG: "刚果",
  CD: "刚果民主共和国",
  CK: "库克群岛",
  CR: "哥斯达黎加",
  CI: "科特迪瓦",
  HR: "克罗地亚",
  CW: "库拉索岛",
  CY: "塞浦路斯",
  CZ: "捷克共和国",
  DK: "丹麦",
  DJ: "吉布提",
  DM: "多米尼加",
  DO: "多米尼加共和国",
  EC: "厄瓜多尔",
  EG: "埃及",
  SV: "萨尔瓦多",
  GQ: "赤道几内亚",
  ER: "厄立特里亚",
  EE: "爱沙尼亚",
  ET: "埃塞俄比亚",
  FK: "福克兰群岛(玛尔维娜)",
  FO: "法罗群岛",
  FJ: "斐济",
  FI: "芬兰",
  FR: "法国",
  GF: "法属圭亚那",
  PF: "法属玻利尼西亚",
  TF: "法属南部领地",
  GA: "加蓬",
  GM: "冈比亚",
  GE: "格鲁吉亚",
  DE: "德国",
  GH: "加纳",
  GI: "直布罗陀",
  GR: "希腊",
  GL: "格陵兰",
  GD: "格林纳达",
  GP: "瓜德罗普岛",
  GT: "危地马拉",
  GG: "根西",
  GN: "几内亚",
  GW: "几内亚比绍",
  GY: "圭亚那",
  HT: "海地",
  HM: "赫德岛和麦克唐纳群岛",
  VA: "梵蒂冈",
  HK: "中国香港",
  HN: "洪都拉斯",
  HU: "匈牙利",
  IS: "冰岛",
  IN: "印度",
  ID: "印度尼西亚",
  IQ: "伊拉克",
  IE: "爱尔兰",
  IM: "马恩岛",
  IL: "以色列",
  IT: "意大利",
  JM: "牙买加",
  JP: "日本",
  JE: "泽西",
  JO: "约旦",
  KZ: "哈萨克斯坦",
  KE: "肯尼亚",
  KI: "基里巴斯",
  KR: "韩国",
  KW: "科威特",
  KG: "吉尔吉斯斯坦",
  LA: "老挝人民民主共和国",
  LV: "拉脱维亚",
  LB: "黎巴嫩",
  LS: "莱索托",
  LR: "利比里亚",
  LY: "利比亚",
  LI: "列支敦士登",
  LT: "立陶宛",
  LU: "卢森堡",
  MO: "澳门",
  MK: "南斯拉夫马其顿共和国",
  MG: "马达加斯加",
  MW: "马拉维",
  MY: "马来西亚",
  MV: "马尔代夫",
  ML: "马里",
  MT: "马耳他",
  MQ: "马提尼克",
  MR: "毛利塔尼亚",
  MU: "毛里求斯",
  YT: "马约特岛",
  MX: "墨西哥",
  MD: "摩尔多瓦共和国",
  MC: "摩纳哥",
  MN: "蒙古",
  ME: "黑山",
  MS: "蒙特塞拉特",
  MA: "摩洛哥",
  MZ: "莫桑比克",
  MM: "缅甸",
  NA: "纳米比亚",
  NR: "瑙鲁",
  NP: "尼泊尔",
  NL: "荷兰",
  NC: "新喀里多尼亚",
  NZ: "新西兰",
  NI: "尼加拉瓜",
  NE: "尼日尔",
  NG: "尼日利亚",
  NU: "纽埃",
  NF: "诺福克岛",
  NO: "挪威",
  OM: "阿曼",
  PK: "巴基斯坦",
  PS: "巴勒斯坦",
  PA: "巴拿马",
  PG: "巴布亚新几内亚",
  PY: "巴拉圭",
  PE: "秘鲁",
  PH: "菲律宾",
  PN: "皮特克恩岛",
  PL: "波兰",
  PT: "葡萄牙",
  QA: "卡塔尔",
  RE: "留尼旺岛",
  RO: "罗马尼亚",
  RU: "俄羅斯聯邦",
  RW: "卢旺达",
  BL: "圣巴托洛缪岛",
  SH: "圣赫勒拿、阿森松和特里斯坦达库尼亚",
  KN: "圣克里斯托弗和尼维斯岛",
  LC: "圣卢西亚",
  MF: "圣马丁(法属)",
  PM: "圣皮埃尔和密克隆群岛",
  VC: "圣文森特和格林纳丁斯",
  WS: "萨摩亚",
  SM: "圣马力诺",
  ST: "多美和普林西比",
  SA: "沙特阿拉伯",
  SN: "塞内加尔",
  RS: "塞尔维亚",
  SC: "塞舌尔",
  SL: "塞拉利昂",
  SG: "新加坡",
  SX: "圣马丁(荷属)",
  SK: "斯洛伐克",
  SI: "斯洛文尼亚",
  SB: "所罗门群岛",
  SO: "索马里",
  ZA: "南非",
  GS: "南乔治亚岛和南桑威奇群岛",
  SS: "南苏丹",
  ES: "西班牙",
  LK: "斯里兰卡",
  SR: "苏里南",
  SJ: "斯瓦尔巴特和扬马延群岛",
  SZ: "斯威士兰",
  SE: "瑞典",
  CH: "瑞士",
  TW: "台湾",
  TJ: "塔吉克斯坦",
  TZ: "坦桑尼亚联合共和国",
  TH: "泰国",
  TL: "东帝汶",
  TG: "多哥",
  TK: "托克劳",
  TO: "汤加",
  TT: "特立尼达和多巴哥",
  TN: "突尼斯",
  TR: "土耳其",
  TM: "土库曼斯坦",
  TC: "特克斯和凯科斯群岛",
  TV: "图瓦卢",
  UG: "乌干达",
  UA: "乌克兰",
  AE: "阿拉伯联合酋长国",
  GB: "英国",
  US: "美国",
  UY: "乌拉圭",
  UZ: "乌兹别克斯坦",
  VU: "瓦努阿图",
  VE: "委内瑞拉玻利瓦尔共和国",
  VN: "越南",
  VG: "英属维京群岛",
  WF: "瓦利斯群岛和富图纳群岛",
  EH: "西撒哈拉",
  YE: "也门",
  ZM: "赞比亚",
  ZW: "津巴布韦",
};
var states$1 = {
  AU: {
    ACT: "澳大利亚首都特区",
    NSW: "新南威尔士州",
    NT: "北领地",
    QLD: "昆士兰州",
    SA: "澳大利亚南部",
    TAS: "塔斯马尼亚州",
    VIC: "维多利亚",
    WA: "澳大利亚西部",
  },
  BR: {
    AC: "阿克里",
    AL: "阿拉戈斯",
    AP: "阿马帕州",
    AM: "亚马逊州",
    BA: "巴伊亚州",
    CE: "塞阿拉州",
    DF: "联邦区",
    ES: "圣埃斯皮里图州",
    GO: "戈亚斯州",
    MA: "马拉尼昂州",
    MT: "马托格罗索州",
    MS: "南马托格罗索州",
    MG: "米纳斯吉拉斯州",
    PA: "帕拉州",
    PB: "帕拉伊巴州",
    PR: "巴拉那州",
    PE: "伯南布哥州",
    PI: "皮奥伊州",
    RJ: "里约热内卢",
    RN: "北里奥格兰德州",
    RS: "南里奥格兰德州",
    RO: "朗多尼亚州",
    RR: "罗赖马州",
    SC: "圣卡塔琳娜州",
    SP: "圣保罗",
    SE: "塞尔希培州",
    TO: "托坎廷斯州",
  },
  CA: {
    AB: "艾伯塔",
    BC: "不列颠哥伦比亚",
    MB: "马尼托巴",
    NB: "新不伦瑞克",
    NL: "纽芬兰与拉布拉多省",
    NT: "西北地区",
    NS: "新斯科舍",
    NU: "努勒维特",
    ON: "安大略",
    PE: "爱德华王子岛",
    QC: "魁北克",
    SK: "萨斯喀彻温",
    YT: "育空地区",
  },
  CN: {
    11: "北京市",
    12: "天津市",
    13: "河北省",
    14: "山西省",
    15: "内蒙古",
    21: "辽宁省",
    22: "吉林省",
    23: "黑龙江省",
    31: "上海市",
    32: "江苏省",
    33: "浙江省",
    34: "安徽省",
    35: "福建省",
    36: "江西省",
    37: "山东省",
    41: "河南省",
    42: "湖北省",
    43: "湖南省",
    44: "广东省",
    45: "广西省",
    46: "海南省",
    50: "重庆市",
    51: "四川省",
    52: "贵州省",
    53: "云南省",
    54: "西藏自治区",
    61: "陕西省",
    62: "甘肃省",
    63: "青海省",
    64: "宁夏省",
    65: "新疆省",
    71: "台湾",
    91: "中国香港",
    92: "澳门",
  },
  IN: {
    AN: "安达曼和尼科巴群岛",
    AP: "安得拉邦",
    AR: "阿鲁那恰尔邦",
    AS: "阿萨姆邦",
    BR: "比哈尔邦",
    CH: "昌迪加尔",
    CT: "恰蒂斯加尔邦",
    DN: "达德拉-纳加尔哈维利",
    DD: "达曼和第乌",
    DL: "德里",
    GA: "果阿邦",
    GJ: "古吉拉特邦",
    HR: "哈里亚纳邦",
    HP: "喜马偕尔邦",
    JK: "克什米尔",
    JH: "贾坎德邦",
    KA: "卡纳塔克邦",
    KL: "喀拉拉邦",
    LD: "拉克沙群岛",
    MP: "中央邦",
    MH: "马哈拉施特拉邦",
    MN: "曼尼普尔邦",
    ML: "梅加拉亚邦",
    MZ: "米佐拉姆邦",
    NL: "那加兰邦",
    OR: "奥里萨邦",
    PY: "本地治里",
    PB: "旁遮普邦",
    RJ: "拉贾斯坦邦",
    SK: "锡金邦",
    TN: "泰米尔纳德邦",
    TG: "特伦甘纳邦",
    TR: "特里普拉邦",
    UT: "北阿坎德邦",
    UP: "北方邦",
    WB: "西孟加拉邦",
  },
  IE: {
    CW: "卡洛",
    CN: "温哥华港",
    CE: "克莱尔",
    CO: "科克",
    DL: "多尼哥",
    D: "都柏林地区",
    G: "戈尔韦",
    KY: "凯里",
    KE: "启尔达",
    KK: "基尔肯尼",
    LS: "老挝",
    LM: "利特里姆",
    LK: "利默里克",
    LD: "朗福德",
    LH: "劳斯",
    MO: "梅奥",
    MH: "米斯",
    MN: "莫纳亨",
    OY: "奥法利",
    RN: "罗斯康芒",
    SO: "斯来哥",
    TA: "蒂珀雷里",
    WD: "沃特福德",
    WH: "韦斯特米斯",
    WX: "韦克斯福德",
    WW: "威克洛",
  },
  IT: {
    AG: "阿格里真托",
    AL: "亚历山德里亚",
    AN: "安科纳",
    AO: "奥斯塔",
    AR: "阿雷佐",
    AP: "阿斯科利皮切诺",
    AT: "阿斯蒂",
    AV: "阿韦利诺",
    BA: "巴里",
    BT: "巴列塔-安德里亚",
    BL: "贝卢诺",
    BN: "贝内文托",
    BG: "贝尔格蒙",
    BI: "比拉",
    BO: "博洛尼亚",
    BZ: "博尔扎诺",
    BS: "布雷西亚",
    BR: "布林迪西",
    CA: "卡利亚里",
    CL: "卡尔塔尼塞塔",
    CB: "坎波巴索",
    CI: "卡博尼亚-伊格莱西亚斯",
    CE: "卡塞塔",
    CT: "卡塔尼亚",
    CZ: "卡坦扎罗",
    CH: "基耶蒂",
    CO: "科莫",
    CS: "科森扎",
    CR: "克雷莫纳",
    KR: "克罗托内",
    CN: "库内奥",
    EN: "恩纳",
    FM: "费尔莫",
    FE: "费拉拉",
    FI: "佛罗伦萨",
    FG: "福贾",
    FC: "费利-切塞纳",
    FR: "弗罗西诺内",
    GE: "热那亚",
    GO: "戈里齐亚",
    GR: "格罗塞托",
    IM: "因佩里亚",
    IS: "伊塞尔尼亚",
    AQ: "拉奎拉",
    SP: "拉斯佩齐亚",
    LT: "拉蒂纳",
    LE: "莱切",
    LC: "莱科",
    LI: "里窝那",
    LO: "洛迪",
    LU: "卢卡",
    MC: "马切拉塔",
    MN: "曼托瓦",
    MS: "马萨-卡拉拉",
    MT: "马泰拉",
    VS: "梅迪奥坎皮达诺",
    ME: "墨西拿",
    MI: "米兰",
    MO: "莫代纳",
    MB: "蒙萨和布里安萨",
    NA: "那不勒斯",
    NO: "诺瓦拉",
    NU: "努奥罗",
    OG: "奥格利亚斯切华",
    OT: "奥尔比亚",
    OR: "奥里斯塔诺",
    PD: "帕多瓦",
    PA: "巴勒莫",
    PR: "帕尔马",
    PV: "帕维亚",
    PG: "佩鲁贾",
    PU: "佩萨罗-乌尔比诺",
    PE: "佩斯卡拉",
    PC: "皮亚琴察",
    PI: "比萨",
    PT: "皮斯托亚",
    PN: "波尔德诺内",
    PZ: "波坦察",
    PO: "普拉托",
    RG: "拉古萨",
    RA: "拉韦纳",
    RC: "雷焦卡拉布里亚",
    RE: "雷焦艾米利亚",
    RI: "列蒂",
    RN: "里米尼",
    RM: "罗马",
    RO: "罗维戈",
    SA: "萨莱诺",
    SS: "萨萨里",
    SV: "萨沃纳",
    SI: "锡耶纳",
    SO: "桑得里奥",
    SR: "锡拉丘兹",
    TA: "塔兰托",
    TE: "泰拉莫",
    TR: "特尔尼",
    TP: "特拉帕尼",
    TN: "特伦托",
    TV: "特雷维索",
    TS: "的里雅斯特",
    TO: "都灵",
    UD: "乌迪内",
    VA: "瓦雷泽",
    VE: "威尼斯",
    VB: "韦巴诺-库西奥-奥索拉",
    VC: "韦尔切利",
    VR: "维罗纳",
    VV: "维博瓦伦蒂亚",
    VI: "维琴察",
    VT: "维泰博",
  },
  MX: {
    AG: "阿瓜斯卡连特斯",
    BC: "下加利福尼亚州",
    BS: "南下加利福尼亚州",
    CM: "坎佩切州",
    CS: "恰帕斯州",
    CH: "奇瓦瓦州",
    CO: "科阿韦拉州",
    CL: "科利马",
    DG: "杜兰戈州",
    DF: "联邦地区",
    GT: "瓜纳华托州",
    GR: "格雷罗州",
    HG: "伊达尔戈州",
    JA: "哈利斯科州",
    ME: "新墨西哥州",
    MI: "米却肯州",
    MO: "莫雷洛斯州",
    NA: "纳亚里特州",
    NL: "新莱昂州",
    OA: "瓦哈卡州",
    PB: "普埃布拉州",
    QE: "克雷塔罗州",
    QR: "金塔纳罗奥州",
    SL: "圣路易斯波托西州",
    SI: "锡那罗亚州",
    SO: "索诺拉州",
    TB: "塔巴斯科州",
    TM: "塔毛利帕斯州",
    TL: "特拉斯卡拉州",
    VE: "韦拉克鲁斯州",
    YU: "尤卡坦州",
    ZA: "萨卡特卡斯州",
  },
  US: {
    AL: "亚拉巴马州",
    AK: "阿拉斯加州",
    AZ: "亚利桑那州",
    AR: "阿肯色州",
    CA: "加利福尼亚州",
    CO: "科罗拉多州",
    CT: "康涅狄格州",
    DE: "特拉华州",
    DC: "哥伦比亚特区",
    FL: "佛罗里达州",
    GA: "格鲁吉亚",
    HI: "夏威夷州",
    ID: "爱达荷州",
    IL: "伊利诺伊州",
    IN: "印第安纳州",
    IA: "艾奥瓦州",
    KS: "堪萨斯州",
    KY: "肯塔基州",
    LA: "路易斯安那州",
    ME: "缅因州",
    MD: "马里兰州",
    MA: "马萨诸塞州",
    MI: "密歇根州",
    MN: "明尼苏达州",
    MS: "密西西比州",
    MO: "密苏里州",
    MT: "蒙大拿州",
    NE: "内布拉斯加州",
    NV: "内华达州",
    NH: "新罕布什尔州",
    NJ: "新泽西州",
    NM: "新墨西哥州",
    NY: "纽约州",
    NC: "北卡罗来纳州",
    ND: "北达科他州",
    OH: "俄亥俄州",
    OK: "俄克拉何马州",
    OR: "俄勒冈州",
    PA: "宾夕法尼亚州",
    PR: "波多黎各",
    RI: "罗得岛",
    SC: "南卡罗来纳州",
    SD: "南达科他州",
    TN: "田纳西州",
    TX: "得克萨斯州",
    UT: "犹他州",
    VT: "佛蒙特州",
    VA: "弗吉尼亚州",
    WA: "华盛顿州",
    WV: "西弗吉尼亚州",
    WI: "威斯康星州",
    WY: "怀俄明州",
  },
};
var zhCN = {
  status: status$1,
  progress: progress$1,
  fields: fields$1,
  buttons: buttons$1,
  errors: errors$1,
  countries: countries$1,
  states: states$1,
};

var status = {
  loading: "正在載入...",
};
var progress = {
  steps: "步驟 %{currentStepNumber}/%{totalSteps}",
};
var fields = {
  email: "電子郵件",
  country: "國家/地區",
  state: "州/省",
  first_name: "名字",
  last_name: "姓氏",
  company_name: "公司名稱",
  role: "角色名稱",
  relationship: "與 Salesforce 的關係",
  required: "(必填)",
  select_placeholder: "選取選項",
};
var buttons = {
  close: "關閉",
  cancel: "取消",
  save: "儲存",
  next: "下一步",
  continue: "繼續",
};
var errors = {
  something_went_wrong: "發生錯誤，請再試一次",
  fill_required_fields: "提交前請填寫必填欄位。",
};
var countries = {
  AF: "阿富汗",
  AX: "奧蘭群島",
  AL: "阿爾巴尼亞",
  DZ: "阿爾及利亞",
  AD: "安道爾",
  AO: "安哥拉",
  AI: "安圭拉",
  AQ: "南極",
  AG: "安地卡及巴布達",
  AR: "阿根廷",
  AM: "亞美尼亞",
  AW: "阿魯巴島",
  AU: "澳洲",
  AT: "奧地利",
  AZ: "亞塞拜然",
  BS: "巴哈馬",
  BH: "巴林",
  BD: "孟加拉",
  BB: "巴貝多",
  BY: "白俄羅斯",
  BE: "比利時",
  BZ: "貝里斯",
  BJ: "貝南",
  BM: "百慕達",
  BT: "不丹",
  BO: "玻利維亞共和國",
  BQ: "波奈、聖佑達修斯及沙巴",
  BA: "波士尼亞與赫塞哥維納",
  BW: "波札那",
  BV: "波維特島",
  BR: "巴西",
  IO: "英屬印度洋地區",
  BN: "汶萊",
  BG: "保加利亞",
  BF: "布吉納法索",
  BI: "蒲隆地",
  KH: "柬埔寨",
  CM: "喀麥隆",
  CA: "加拿大",
  CV: "維德角",
  KY: "開曼群島",
  CF: "中非共和國",
  TD: "查德",
  CL: "智利",
  CN: "中國",
  CX: "聖誕島",
  CC: "科克斯 (基靈) 群島",
  CO: "哥倫比亞",
  KM: "科摩羅群島",
  CG: "剛果共和國",
  CD: "剛果民主共和國",
  CK: "庫克群島",
  CR: "哥斯大黎加",
  CI: "象牙海岸",
  HR: "克羅埃西亞",
  CW: "古拉索",
  CY: "賽普勒斯",
  CZ: "捷克共和國",
  DK: "丹麥",
  DJ: "吉布提",
  DM: "多米尼克",
  DO: "多明尼加共和國",
  EC: "厄瓜多",
  EG: "埃及",
  SV: "薩爾瓦多",
  GQ: "赤道幾內亞",
  ER: "厄立垂亞",
  EE: "愛沙尼亞",
  ET: "衣索比亞",
  FK: "福克蘭群島 (馬爾維納斯群島)",
  FO: "丹麥屬法羅群島",
  FJ: "斐濟",
  FI: "芬蘭",
  FR: "法國",
  GF: "法屬圭亞那",
  PF: "法屬玻里尼西亞",
  TF: "法屬南部屬地",
  GA: "加彭",
  GM: "甘比亞",
  GE: "喬治亞",
  DE: "德國",
  GH: "迦納",
  GI: "直布羅陀",
  GR: "希臘",
  GL: "格陵蘭",
  GD: "格瑞那達",
  GP: "瓜德洛普",
  GT: "瓜地馬拉",
  GG: "根西島",
  GN: "幾內亞",
  GW: "幾內亞比索",
  GY: "蓋亞那",
  HT: "海地",
  HM: "赫德及麥當勞群島",
  VA: "教廷 (梵蒂岡城國)",
  HK: "香港",
  HN: "宏都拉斯",
  HU: "匈牙利",
  IS: "冰島",
  IN: "印度",
  ID: "印度尼西亞",
  IQ: "伊拉克",
  IE: "愛爾蘭",
  IM: "曼島",
  IL: "以色列",
  IT: "義大利",
  JM: "牙買加",
  JP: "日本",
  JE: "澤西島",
  JO: "約旦",
  KZ: "哈薩克",
  KE: "肯亞",
  KI: "巴斯",
  KR: "大韓民國",
  KW: "科威特",
  KG: "吉爾吉斯",
  LA: "寮國",
  LV: "拉脫維亞",
  LB: "黎巴嫩",
  LS: "賴索托",
  LR: "賴比瑞亞",
  LY: "利比亞",
  LI: "列支敦士敦",
  LT: "立陶宛",
  LU: "盧森堡",
  MO: "澳門",
  MK: "前南斯拉夫馬其頓共和國",
  MG: "馬達加斯加",
  MW: "馬拉威",
  MY: "馬來西亞",
  MV: "馬爾地夫",
  ML: "馬利",
  MT: "馬爾他",
  MQ: "法屬馬提尼克島",
  MR: "茅利塔尼亞",
  MU: "模里西斯",
  YT: "美亞特",
  MX: "墨西哥",
  MD: "摩爾多瓦共和國",
  MC: "摩納哥",
  MN: "蒙古",
  ME: "蒙特內哥羅",
  MS: "英屬蒙瑟拉特島",
  MA: "摩洛哥",
  MZ: "莫三比克",
  MM: "緬甸",
  NA: "那比亞",
  NR: "諾魯",
  NP: "尼泊爾",
  NL: "荷蘭",
  NC: "新喀里多尼亞",
  NZ: "紐西蘭",
  NI: "尼加拉瓜",
  NE: "尼日",
  NG: "奈及利亞",
  NU: "紐威島",
  NF: "諾福克島",
  NO: "挪威",
  OM: "阿曼",
  PK: "巴基斯坦",
  PS: "巴勒斯坦",
  PA: "巴拿馬",
  PG: "巴布亞新幾內亞",
  PY: "巴拉圭",
  PE: "秘魯",
  PH: "菲律賓",
  PN: "英屬皮特康島",
  PL: "波蘭",
  PT: "葡萄牙",
  QA: "卡達",
  RE: "法屬留尼望",
  RO: "羅馬尼亞",
  RU: "俄羅斯",
  RW: "盧安達",
  BL: "聖巴瑟米",
  SH: "英屬聖赫勒拿島",
  KN: "聖克里斯多福及尼維斯",
  LC: "聖露西亞",
  MF: "法屬聖馬丁",
  PM: "法屬聖匹及密啟倫群島",
  VC: "聖文森",
  WS: "薩摩亞群島",
  SM: "聖馬力諾",
  ST: "聖多美及普林西比",
  SA: "沙烏地阿拉伯",
  SN: "塞內加爾",
  RS: "塞爾維亞",
  SC: "塞席爾",
  SL: "獅子山",
  SG: "新加坡",
  SX: "荷屬聖馬丁",
  SK: "斯洛伐克",
  SI: "斯洛維尼亞",
  SB: "索羅門群島",
  SO: "索馬利亞",
  ZA: "南非",
  GS: "南喬治亞與南桑威奇群島",
  SS: "南蘇丹共和國",
  ES: "西班牙",
  LK: "斯里蘭卡",
  SR: "蘇利南",
  SJ: "挪威屬斯瓦巴及尖棉",
  SZ: "史瓦濟蘭",
  SE: "瑞典",
  CH: "瑞士",
  TW: "台灣",
  TJ: "塔吉克",
  TZ: "坦尚尼亞",
  TH: "泰國",
  TL: "東帝汶",
  TG: "多哥",
  TK: "托克勞群島",
  TO: "東加",
  TT: "千里達與托巴哥",
  TN: "突尼西亞",
  TR: "土耳其",
  TM: "土庫曼",
  TC: "英屬土克斯及開科斯群島",
  TV: "吐瓦魯",
  UG: "烏干達",
  UA: "烏克蘭",
  AE: "阿拉伯聯合大公國",
  GB: "英國",
  US: "美國",
  UY: "烏拉圭",
  UZ: "烏茲別克",
  VU: "萬那杜",
  VE: "委內瑞拉",
  VN: "越南",
  VG: "英屬維京群島",
  WF: "沃里斯及伏塔那島",
  EH: "西薩哈拉",
  YE: "葉門",
  ZM: "尚比亞",
  ZW: "辛巴威",
};
var states = {
  AU: {
    ACT: "澳洲首都直轄區",
    NSW: "新南威爾斯",
    NT: "北領地",
    QLD: "昆士蘭",
    SA: "南澳洲",
    TAS: "塔斯馬尼亞",
    VIC: "維多利亞",
    WA: "西澳洲",
  },
  BR: {
    AC: "阿卡",
    AL: "阿拉戈斯",
    AP: "阿瑪帕",
    AM: "亞馬遜",
    BA: "巴伊亞",
    CE: "塞阿拉",
    DF: "聯邦區",
    ES: "聖埃斯皮里圖",
    GO: "戈亞斯",
    MA: "馬拉尼昂",
    MT: "馬托格羅索",
    MS: "南馬托格羅索",
    MG: "米納斯吉拉斯",
    PA: "帕拉",
    PB: "帕拉伊巴",
    PR: "巴拉那",
    PE: "伯南布哥",
    PI: "皮奧伊",
    RJ: "里約熱內盧",
    RN: "北里奧格蘭德",
    RS: "南里奧格蘭德",
    RO: "朗多尼亞",
    RR: "羅賴馬",
    SC: "聖卡塔琳娜",
    SP: "聖保羅",
    SE: "塞爾希培",
    TO: "托坎廷斯",
  },
  CA: {
    AB: "亞伯達",
    BC: "英屬哥倫比亞",
    MB: "曼尼托巴",
    NB: "新伯倫瑞克",
    NL: "紐芬蘭和拉布拉多",
    NT: "西北地區",
    NS: "紐斯科舍",
    NU: "努勒維特",
    ON: "安大略",
    PE: "愛德華王子島",
    QC: "魁北克",
    SK: "薩克其萬",
    YT: "育空特區",
  },
  CN: {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "內蒙古",
    21: "遼寧",
    22: "吉林",
    23: "黑龍江",
    31: "上海",
    32: "江蘇",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山東",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "廣東",
    45: "廣西",
    46: "海南",
    50: "重慶",
    51: "四川",
    52: "貴州",
    53: "雲南",
    54: "西藏",
    61: "陜西",
    62: "甘肅",
    63: "青海",
    64: "寧夏",
    65: "新疆",
    71: "台灣",
    91: "香港",
    92: "澳門",
  },
  IN: {
    AN: "安達曼與尼科巴群島",
    AP: "安得拉省",
    AR: "阿魯納恰爾省",
    AS: "阿薩姆",
    BR: "比哈爾省",
    CH: "昌迪加爾",
    CT: "切蒂斯格爾",
    DN: "達德拉與納加爾哈維",
    DD: "達曼與第烏",
    DL: "德里",
    GA: "果阿",
    GJ: "古吉拉特",
    HR: "哈里亞納省",
    HP: "喜馬偕爾省",
    JK: "查謨與克什米爾",
    JH: "恰爾肯德省",
    KA: "卡納塔克省",
    KL: "喀拉拉省",
    LD: "拉克沙",
    MP: "中央省",
    MH: "馬哈拉施特拉省",
    MN: "曼尼普爾",
    ML: "梅加拉亞省",
    MZ: "米佐拉姆",
    NL: "那加蘭省",
    OR: "奧里薩邦",
    PY: "龐迪切里",
    PB: "旁遮普省",
    RJ: "拉賈斯坦省",
    SK: "錫金",
    TN: "泰米爾納德省",
    TG: "泰倫迦納",
    TR: "特里普拉省",
    UT: "烏塔拉坎德省",
    UP: "北方省",
    WB: "西孟加拉省",
  },
  IE: {
    CW: "卡洛",
    CN: "卡文",
    CE: "克萊爾",
    CO: "軟木",
    DL: "多尼戈爾",
    D: "都柏林",
    G: "戈爾韋",
    KY: "凱里",
    KE: "基爾代爾",
    KK: "基爾肯尼",
    LS: "勞易斯",
    LM: "利特里姆",
    LK: "利默里克",
    LD: "朗福德",
    LH: "勞斯",
    MO: "梅奧",
    MH: "米斯",
    MN: "莫納漢",
    OY: "奧法利",
    RN: "羅斯康",
    SO: "斯萊戈",
    TA: "蒂珀雷",
    WD: "沃特福德",
    WH: "韋斯特米斯",
    WX: "韋克斯福德",
    WW: "威克洛",
  },
  IT: {
    AG: "阿格里真托",
    AL: "亞歷山德里亞",
    AN: "安科納",
    AO: "奧斯塔",
    AR: "阿雷佐",
    AP: "阿斯科利皮切諾",
    AT: "阿斯蒂",
    AV: "阿韋利諾",
    BA: "巴利",
    BT: "巴列塔安德里亞特拉尼",
    BL: "貝盧諾",
    BN: "貝內芬托",
    BG: "貝加莫",
    BI: "比拉",
    BO: "博洛尼亞",
    BZ: "博爾扎諾",
    BS: "布雷沙",
    BR: "布林底希",
    CA: "卡拉里",
    CL: "卡塔尼塞塔",
    CB: "坎波巴索",
    CI: "卡波尼亞伊格勒夏斯",
    CE: "卡塞塔",
    CT: "卡塔尼亞",
    CZ: "加坦薩羅",
    CH: "基耶蒂",
    CO: "科莫",
    CS: "利瑟",
    CR: "克雷莫納",
    KR: "克羅登",
    CN: "庫內奧",
    EN: "恩納",
    FM: "費爾莫",
    FE: "費拉拉",
    FI: "弗羅倫斯",
    FG: "福賈",
    FC: "福爾利切塞納",
    FR: "夫羅西諾尼",
    GE: "吉那歐",
    GO: "戈里齊亞",
    GR: "格羅塞托",
    IM: "因匹里亞",
    IS: "伊瑟尼亞",
    AQ: "拉奎拉",
    SP: "拉斯佩吉亞",
    LT: "拉蒂納",
    LE: "萊切",
    LC: "萊科",
    LI: "利沃諾",
    LO: "洛迪",
    LU: "盧卡",
    MC: "馬切拉塔",
    MN: "曼圖亞",
    MS: "馬薩及卡拉拉",
    MT: "馬泰拉",
    VS: "米迪奧坎皮達諾",
    ME: "墨西拿",
    MI: "米蘭",
    MO: "摩德納",
    MB: "蒙扎及布里安沙",
    NA: "那不勒斯",
    NO: "諾瓦拉",
    NU: "奴歐羅",
    OG: "奧里亞斯特拉",
    OT: "奧爾比亞田匹歐",
    OR: "奧里斯塔諾",
    PD: "帕杜瓦",
    PA: "巴勒摩",
    PR: "帕爾馬",
    PV: "帕維亞",
    PG: "佩魯賈",
    PU: "佩薩羅及烏爾比諾",
    PE: "佩斯卡拉",
    PC: "皮辰札",
    PI: "比薩",
    PT: "皮斯托雅",
    PN: "波代諾內",
    PZ: "波坦察",
    PO: "普拉托",
    RG: "拉古薩",
    RA: "拉文納",
    RC: "雷喬卡拉布里亞",
    RE: "雷喬艾米利亞",
    RI: "瑞耶提",
    RN: "里米尼",
    RM: "羅馬",
    RO: "羅維戈",
    SA: "沙勒諾",
    SS: "薩薩里",
    SV: "沙弗納",
    SI: "西恩納",
    SO: "松德里奧",
    SR: "西勒鳩斯",
    TA: "塔蘭托",
    TE: "泰拉莫",
    TR: "特爾尼",
    TP: "特拉帕尼",
    TN: "特倫托",
    TV: "特雷維索",
    TS: "德里亞斯特",
    TO: "杜林",
    UD: "烏迪內",
    VA: "瓦雷瑟",
    VE: "威尼斯",
    VB: "韋爾巴諾庫西亞奧索拉",
    VC: "佛赤利",
    VR: "維羅納",
    VV: "維博瓦倫蒂亞",
    VI: "維琴察",
    VT: "維泰博",
  },
  MX: {
    AG: "阿瓜斯卡達特斯州",
    BC: "下加利福尼亞州",
    BS: "南下加利福尼亞州",
    CM: "坎佩奇",
    CS: "恰帕斯州",
    CH: "奇瓦瓦",
    CO: "科阿韋拉",
    CL: "科利馬",
    DG: "杜藍哥",
    DF: "聯邦特區",
    GT: "瓜納華托",
    GR: "格雷羅",
    HG: "希達哥",
    JA: "哈利斯科",
    ME: "墨西哥州",
    MI: "米喬肯",
    MO: "莫雷洛斯",
    NA: "納亞里特",
    NL: "新萊昂州",
    OA: "瓦哈卡",
    PB: "普埃布拉",
    QE: "克雷塔羅",
    QR: "金塔納羅奧",
    SL: "聖路易斯波托西",
    SI: "西納洛亞",
    SO: "索諾拉",
    TB: "塔瓦斯科",
    TM: "塔毛利帕斯",
    TL: "特拉斯卡拉",
    VE: "韋拉克魯斯",
    YU: "尤卡坦",
    ZA: "札卡特卡",
  },
  US: {
    AL: "阿拉巴馬",
    AK: "阿拉斯加",
    AZ: "亞利桑那",
    AR: "阿肯色",
    CA: "加利福尼亞",
    CO: "科羅拉多",
    CT: "康乃狄克",
    DE: "德拉瓦",
    DC: "哥倫比亞特區",
    FL: "佛羅里達",
    GA: "喬治亞",
    HI: "夏威夷",
    ID: "愛達華",
    IL: "伊利諾",
    IN: "印第安那",
    IA: "愛荷華",
    KS: "堪薩斯",
    KY: "肯塔基",
    LA: "路易斯安那",
    ME: "緬因",
    MD: "馬里蘭",
    MA: "麻薩諸塞",
    MI: "密西根",
    MN: "明尼蘇達",
    MS: "密西西比",
    MO: "密蘇里",
    MT: "蒙大拿",
    NE: "內布拉斯加",
    NV: "內華達",
    NH: "新罕布夏",
    NJ: "紐澤西",
    NM: "新墨西哥",
    NY: "紐約",
    NC: "北卡洛來納",
    ND: "北達科他",
    OH: "俄亥俄",
    OK: "奧克拉荷馬",
    OR: "俄勒岡",
    PA: "賓夕法尼亞",
    PR: "波多黎各",
    RI: "羅德島",
    SC: "南卡羅來納",
    SD: "南達科他",
    TN: "田納西",
    TX: "德克薩斯",
    UT: "猶他",
    VT: "佛蒙特",
    VA: "維吉尼亞",
    WA: "華盛頓",
    WV: "西維吉尼亞",
    WI: "威斯康辛",
    WY: "懷俄明",
  },
};
var zhTW = {
  status: status,
  progress: progress,
  fields: fields,
  buttons: buttons,
  errors: errors,
  countries: countries,
  states: states,
};

const commonLocales = {
  da,
  de,
  en,
  eo,
  es,
  esMX,
  fi,
  fr,
  it,
  ja,
  ko,
  nl,
  no,
  ptBR,
  ru,
  sv,
  th,
  zhCN,
  zhTW,
};

// TODO: Fix this type issue
//@ts-ignore
new I18n({
  address: commonLocales,
});

export {
  LANGUAGE_LABEL_MAP as L,
  commonLocales as c,
  getLanguage as g,
  setLanguage as s,
};
